<template>
  <div class="has-header">
    <div class="header main">
      <div class="align-left">
        <dateselectionheader :label="dateDisplay" @PrevDate="modDate('sub')" @NextDate="modDate('add')" />
      </div>
      <div class="align-middle">
        <headerbuttonstack :state="headerButtons" />
      </div>
      <div class="align-right">
        <headerbuttonstack :state="sideButtons" />
      </div>
    </div>
    <!-- ---------------------- -->
    <!-- ---- EXPORT PAGE ----- -->
    <!-- ---------------------- -->
    <div class="scrollbar-container export-builder" v-if="!loading && !exporting && subPage === 'export'">
      <labelc type="header title" v-bind:text="titleText"/>

      <!-- Einstellungen -->
      <div class="panel settings" id="settings" v-if="!hiddenStates.exportsettings" v-bind:style="{ order: orderStates.exportsettings }">
        <labelc
          v-if="duplicateEmployees.length > 0"
          type=""
          :text="$t('export.builder.employeeDuplicate')"
          :icon-right="{
            type: 'icon-overlay',
            icon: 'fa-info-circle',
            styleButton: { marginLeft: '0px' },
            tooltip: GetEmployeeInfoTooltip(),
          }"
          style="z-index: 10; position: absolute; left: -220px !important; right: 0 !important; margin: auto; top: 4px; width: fit-content; height: 40px; color: #e51550"
        />

        <labelc
          v-if="missingPersonalIds.length > 0"
          type=""
          :text="$t('export.builder.missingPersonnelNumber')"
          :icon-right="{
            type: 'icon-overlay',
            icon: 'fa-info-circle',
            styleButton: { marginLeft: '0px' },
            tooltip: GetEmployeeMissingPersoTooltip(),
          }"
          style="z-index: 10; position: absolute; left: 220px !important; right: 0 !important; margin: auto; top: 45px; width: fit-content; height: 40px; color: #e51550"
        />

        <labelc
          type="header title"
          :text="$t('export.builder.exportSettings')"
          :icon-right="{
            styleButton: {
              'border-radius': '100px',
              width: '25px',
              marginTop: '5px',
            },
            type: 'icon-overlay',
            icon: collapseStates.exportsettings ? 'fa-angle-down' : 'fa-angle-up',
            click: () => {
              collapseStates.exportsettings = !collapseStates.exportsettings;
            },
          }"
        />
        <div style="text-align: left; padding: 7px; color: #e51550" v-if="hiddenStores > 0">
          <small v-if="hiddenStores == 1">{{ $t('export.builder.hiddenStoresOne', { count: hiddenStores }) }}</small>
          <small v-if="hiddenStores > 1">{{ $t('export.builder.hiddenStoresMany', { count: hiddenStores }) }}</small>
        </div>
        <div
          class="panel-container"
          v-bind:style="{
            display: !collapseStates.exportsettings && !isDragging ? '' : 'none',
          }"
        >
          <datatablesimple style="flex-basis: calc(50% - 48px)" :state="settingsCompanyState" class="flex-item" />
          <datatablesimple v-if="$parent.mode !== 'individual-wagetypes'" class="flex-item" :state="settingsHeaderState" />
          <datatablesimple v-if="$parent.mode === 'individual-wagetypes'" class="flex-item" :state="settingsIndividualWageTypesListState" />
          <datatablesimple v-if="$parent.mode === 'individual-wagetypes'" class="flex-item-wide" :state="settingsIndividualWageTypesHeaderState" />
          <datatablesimple v-if="$parent.mode === 'monthly'" class="flex-item" :state="settingsMonthlyAdditionalState" />
          <datatablesimple v-if="$parent.mode === 'daily'" class="flex-item" :state="settingsDailyAdditionalState" />
          <datatablesimple v-if="$parent.mode === 'personnelProvisions'" class="flex-item" :state="settingsPersonnelProvisionsAdditionalState" />
        </div>
      </div>

      <!-- Verfügbare Beschäftigungsmodelle -->
      <div class="panel employmentModels" id="employmentModels" v-if="$parent.mode === 'individual-wagetypes' && !hiddenStates.employmentModels" v-bind:style="{ order: orderStates.employmentModels }">
        <labelc
          type="header title"
          :text="$t('export.builder.availableEmploymentModels')"
          :icon-right="{
            styleButton: {
              'border-radius': '100px',
              width: '25px',
              marginTop: '5px',
            },
            type: 'icon-overlay',
            icon: collapseStates.employmentModels ? 'fa-angle-down' : 'fa-angle-up',
            click: () => {
              collapseStates.employmentModels = !collapseStates.employmentModels;
            },
          }"
        />
        <div
          class="panel-container"
          v-bind:style="{
            display: !collapseStates.employmentModels && !isDragging ? '' : 'none',
          }"
          style="text-align: left"
        >
          <buttonc
            v-for="(em, index) in employmentModels"
            :key="'MainL'+index"
            :label="em.name"
            @click="
              () => {
                em.checked = !em.checked;
                somethingHasChangedWhatAffectsExportTable = true;
                saveEmploymentModelsLS();
              }
            "
            v-bind:class="{ selected: em.checked }"
            style="width: 254px; height: 30px; margin: 2.5px"
            v-tooltip="$t('export.builder.selectDeselect')"
          />
        </div>
      </div>

      <!-- Verfügbare Lohnarten -->
      <div class="panel settings" id="wageTypes" v-if="['monthly', 'daily'].includes($parent.mode) && !hiddenStates.wageTypes" v-bind:style="{ order: orderStates.wageTypes }">
        <labelc
          type="header title"
          :text="$t('export.builder.availableWageTypes')"
          :icon-right="{
            styleButton: {
              'border-radius': '100px',
              width: '25px',
              marginTop: '5px',
            },
            type: 'icon-overlay',
            icon: collapseStates.wageTypes ? 'fa-angle-down' : 'fa-angle-up',
            click: () => {
              collapseStates.wageTypes = !collapseStates.wageTypes;
            },
          }"
        />
        <div
          class="panel-container compact-gap"
          v-bind:style="{
            display: !collapseStates.wageTypes && !isDragging ? '' : 'none',
          }"
          style="text-align: left"
        >
          <div class="button-group">
            <buttonc
              v-for="(wage, index) in contentMain"
              :key="'MainL'+index"
              :label="$t(`wageTypes.md.${wage.id}`)"
              @click="
                () => {
                  wage.checked = !wage.checked;
                  somethingHasChangedWhatAffectsExportTable = true;
                  saveContentLS();
                }
              "
              v-bind:class="{ selected: wage.checked }"
              style="width: 254px; height: 30px; margin: 2.5px"
              v-tooltip="$t('export.builder.selectDeselect')"
            />
          </div>
          <div class="button-group">
            <buttonc
              v-for="(wage, index) in contentSecondary"
              :key="'SubL'+index"
              :label="$t(`wageTypes.md.${wage.id}`)"
              @click="
                () => {
                  wage.checked = !wage.checked;
                  somethingHasChangedWhatAffectsExportTable = true;
                  saveContentLS();
                }
              "
              v-bind:class="{ selected: wage.checked }"
              style="width: 254px; height: 30px; margin: 2.5px"
              v-tooltip="$t('export.builder.selectDeselect')"
            />
          </div>
        </div>
      </div>
      <div class="panel wagetypes" id="wageTypes" v-if="$parent.mode === 'individual-wagetypes' && !hiddenStates.wageTypes" v-bind:style="{ order: orderStates.wageTypes }">
        <labelc
          type="header title"
          :text="$t('export.builder.availableWageTypes')"
          :icon-right="{
            styleButton: {
              'border-radius': '100px',
              width: '25px',
              marginTop: '5px',
            },
            type: 'icon-overlay',
            icon: collapseStates.wageTypes ? 'fa-angle-down' : 'fa-angle-up',
            click: () => {
              collapseStates.wageTypes = !collapseStates.wageTypes;
            },
          }"
        />
        <div
          class="panel-container"
          v-bind:style="{
            display: !collapseStates.wageTypes ? '' : 'none',
          }"
          style="text-align: left"
        >
          <datatablesimple v-if="$parent.mode === 'individual-wagetypes'" :state="settingsIndividualWageTypesWageTypeState" />
        </div>
      </div>

      <!-- Monatsabschlüsse -->
      <div class="panel employees" id="employees" v-if="['monthly'].includes($parent.mode) && !hiddenStates.employees" v-bind:style="{ order: orderStates.employees }">
        <inputc
          class="name-filter"
          :inputProp="employeeNameFilter"
          @Update="
            (val) => {
              employeeNameFilter = val;
              $forceUpdate();
            }
          "
          :placeholder="employeeNameFilter === '' ? $t('export.builder.employeeName') : employeeNameFilter"
        />
        <labelc
          type="header title"
          :text="$t('export.builder.mdMonthlyClosings')"
          :icon-right="{
            styleButton: {
              'border-radius': '100px',
              width: '25px',
              marginTop: '5px',
            },
            type: 'icon-overlay',
            icon: collapseStates.employees ? 'fa-angle-down' : 'fa-angle-up',
            click: () => {
              collapseStates.employees = !collapseStates.employees;
            },
          }"
        />
        <div
          class="panel-container"
          style="padding-right: 24px;"
          v-bind:style="{
            display: !collapseStates.employees && !isDragging ? '' : 'none'
          }"
        >
          <datatablesimple :state="settingsEmployeesState" v-if="!collapseStates.employees" />
        </div>
      </div>

      <!-- Export Vorschau Panel -->
      <div class="panel employees" id="preview" v-if="!hiddenStates.preview" v-bind:style="{ order: orderStates.preview }" >
        <labelc
          type="header title"
          :text="$t('export.builder.exportPreview')"
          :icon-right="{
            styleButton: {
              'border-radius': '100px',
              width: '25px',
              marginTop: '5px',
            },
            type: 'icon-overlay',
            icon: collapseStates.preview ? 'fa-angle-down' : 'fa-angle-up',
            click: () => {
              collapseStates.preview = !collapseStates.preview;
            },
          }"
        />
        <div style="text-align: left;" v-if="somethingHasChangedWhatAffectsExportTable && !buildingExportTable" class="panel-container"
          v-bind:style="{
            display: !collapseStates.preview && !isDragging ? '' : 'none',
          }">
          <p style="margin-left: 5px; margin-top: 8px;"><strong>{{ $t('export.builder.tableDataChanged') }}</strong></p>
          <buttonc
            :label="$t('export.builder.regenerateTable')"
            class=""
            type="no-border"
            :disabled="!hasSelectedWageType"
            @click="
              buildingExportTable = true;
              buildExportTable();
            "
          />
        </div>

        <div v-if="buildingExportTable">
          <i class="fas fa-circle-notch fa-spin"></i>
          <br /><strong>{{ $t('export.comp.tableGenerating') }}</strong>
        </div>

        <div
          v-if="!somethingHasChangedWhatAffectsExportTable"
          class="panel-container"
          v-bind:style="{
            display: !collapseStates.preview && !isDragging ? '' : 'none',
          }"
        >
          <datatablesimple style="margin-top: 30px" :state="previewState" v-if="!collapseStates.preview" />
        </div>
      </div>
    </div>
    <!-- ---------------------- -->
    <!-- -EXPORT SETTINGS PAGE- -->
    <!-- ---------------------- -->
    <div class="scrollbar-container export-builder" v-if="!loading && !exporting && subPage === 'settings'">
      <labelc type="header title" v-bind:text="settingsTitleText" style="font-size: 40px" />

      <!-- Basis Einstellungen -->
      <!-- <div class="panel settings" id="sBaseSettings"> -->
      <div class="panel settings" id="sBaseSettings">
      <!-- <div v-if="softwareId === 0" class="panel settings" id="sBaseSettings"> -->
        <labelc
          type="header title"
          :text="$t('export.builder.basicSettings')"
        />
        <div class="panel-container">
          <!-- enableExportViaTransferService -->
          <div class="entryBox">
            <div class="entryHeader">{{ $t('export.comp.enableAutomaticExports') }}</div>
            <div class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-eevts'"
                 v-bind:class="{ false: !baseSettings.enableExportViaTransferService }"
                 v-on:click="settingsUpdated = true; baseSettings.enableExportViaTransferService = !baseSettings.enableExportViaTransferService"></i>
            </div>
          </div>

          <!-- enablePeriodicExport -->
          <div class="entryBox">
            <div class="entryHeader">{{ $t('export.comp.enablePeriodicExport') }}</div>
            <div class="entryData" style="">
              <i class="fas fa-check-circle checkbox" :key="'cb-epe'"
                 v-bind:class="{ false: !baseSettings.enablePeriodicExport || !baseSettings.enableExportViaTransferService, disabled: !baseSettings.enableExportViaTransferService }"
                 v-on:click="settingsUpdated = true; baseSettings.enablePeriodicExport = !baseSettings.enablePeriodicExport"></i>
              <i v-if="baseSettings.enablePeriodicExport && baseSettings.enableExportViaTransferService && selectedSettingsId" class="fas fa-plus" style="padding-left: 20px;" v-tooltip="$t('export.builder.addTime')"
                 v-on:click="openEditPeriodicTimePopup({type: 0, dayOfMonth: 0, dayOfWeek: 0, hours: 0, minutes: 0, exportId: selectedSettingsId, exportMonth: 0, monthlyClosingRequired: false, months: []}, true)"></i>
            </div>
          </div>

          <!-- periodic export times -->
          <div v-if="baseSettings.enablePeriodicExport && baseSettings.enableExportViaTransferService && baseSettings.periodicExportTimes.length > 0">
            <div v-for="time in baseSettings.periodicExportTimes" v-bind:key="time.id" class="entryBox">
              <div v-if="!time.editing && sExportSettings.find(e => e.id === time.exportId)" class="entryHeader" style="text-align: right; padding-right: 10px">{{ sExportSettings.find(e => e.id === time.exportId).name }}</div>
              <div v-if="!time.editing && periodicExportTimeReportMonth.find(e => e.value === time.exportMonth)" class="entryData" style="width: 100px">{{ periodicExportTimeReportMonth.find(e => e.value === time.exportMonth).label }}</div>
              <div v-if="!time.editing && periodicExportTimeTypes.find(e => e.value === time.type)" class="entryData" style="width: 100px">{{ periodicExportTimeTypes.find(e => e.value === time.type).label }}</div>
              <div v-if="!time.editing" class="entryData" style="width: 270px">{{ getPeriodicTimeLabel(time) }}</div>
              <div v-if="!time.editing && time.monthlyClosingRequired" class="entryData" style="">Nur exportieren, wenn Monat abgeschlossen ist</div>
              <div v-else-if="!time.editing" class="entryData" style="">Unabhängig von Monatsabschluss exportieren</div>
              <div v-show="!time.editing" class="entryData">
                &nbsp;
                <i v-tooltip="$t('export.builder.editTime')" class="fas fa-pen" style="padding-left: 5px;" v-on:click="openEditPeriodicTimePopup(time)/*settingsUpdated = true; time.editing = true;*/" />
              </div>
              <div v-show="!time.editing" class="entryData">
                &nbsp;
                <i v-tooltip="$t('export.builder.deleteTime')" class="fas fa-trash" v-on:click="baseSettings.periodicExportTimes.splice(baseSettings.periodicExportTimes.indexOf(time), 1); settingsUpdated = true;" />
              </div>
            </div>
          </div>

          <!-- enable triggered Export after monthly closing -->
          <div class="entryBox">
            <div class="entryHeader">Export bei Monatsabschluss aktivieren</div>
            <div class="entryData" style="">
              <i class="fas fa-check-circle checkbox" :key="'cb-emce'"
                 v-bind:class="{ false: !baseSettings.enableMonthlyClosingExport || !baseSettings.enableExportViaTransferService, disabled: !baseSettings.enableExportViaTransferService }"
                 v-on:click="settingsUpdated = true; baseSettings.enableMonthlyClosingExport = !baseSettings.enableMonthlyClosingExport"></i>
              <i v-if="baseSettings.enableMonthlyClosingExport && baseSettings.enableExportViaTransferService && selectedSettingsId" class="fas fa-plus" style="padding-left: 20px;" v-tooltip="$t('export.builder.addExport')"
                 v-on:click="openEditMonthlyClosingExportPopup({exportId: selectedSettingsId, months: [] }, true)"></i>
            </div>
          </div>

          <!-- monthly closing export settings -->
          <div v-if="baseSettings.enableMonthlyClosingExport && baseSettings.enableExportViaTransferService && baseSettings.monthlyClosingExportSettings.length > 0">
            <div v-for="time in baseSettings.monthlyClosingExportSettings" v-bind:key="time.id" class="entryBox">
              <div v-if="sExportSettings.find(e => e.id === time.exportId)" class="entryHeader" style="text-align: right; padding-right: 10px">{{ sExportSettings.find(e => e.id === time.exportId).name }}</div>
              <div class="entryData">{{ getMonthlyClosingSettingMonths(time) }}</div>
              <div class="entryData">
                &nbsp;
                <i v-tooltip="$t('export.builder.editSetting')" class="fas fa-pen" style="padding-left: 5px;" v-on:click="openEditMonthlyClosingExportPopup(time)" />
              </div>
              <div class="entryData">
                &nbsp;
                <i v-tooltip="$t('export.builder.deleteSetting')" class="fas fa-trash" v-on:click="baseSettings.monthlyClosingExportSettings.splice(baseSettings.monthlyClosingExportSettings.indexOf(time), 1); settingsUpdated = true;" />
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Export Selektor -->
      <div class="panel" id="sExportSelector">
        <labelc
          type="header title"
          :text="$t('export.builder.exportSelection')"
          :icon-right="{
            styleButton: {
              'border-radius': '100px',
              width: '25px',
              marginTop: '5px',
            },
            type: 'icon-overlay',
            icon: 'fa-pen',
            click: openEditSettingsPopup,
            tooltip: 'test',
            show: selectedSettingsId
          }"
        />
        <div class="panel-container"
             style="text-align: left"
        >

          <buttonc
              v-for="(exportSettings, index) in sExportSettings"
              :key="'selector'+index"
              :label="exportSettings.name"
              :icon="exportSettings.locked ? 'fa-lock' : ''"
              :styleIcon="{ 'font-size': '14px' }"
              :styleLabel="{ 'overflow': 'hidden', 'text-wrap': 'nowrap'}"
              @click="
              () => {
                setExportSettingId(exportSettings.id);
              }
            "
              v-bind:class="{ selected: selectedSettingsId === exportSettings.id }"
              style="width: 254px; height: 30px; margin: 2.5px"
              v-tooltip="$t('export.builder.selectExportSetting')"
          /><br /><br />
          <buttonc
              :key="'selectorAddNew'"
              :label="'+'"
              @click="
              () => {
                openCreateNewSettingsPopup();
              }
            "
              style="width: 254px; height: 30px; margin: 2.5px"
              v-tooltip="$t('export.builder.createExportSetting')"
          />
          <buttonc
              v-if="companyArray.length > 1"
              :key="'selectorCopy'"
              :label="$t('export.builder.copy')"
              @click="
              () => {
                copyCurrentExportSettings();
              }
            "
              style="width: 254px; height: 30px; margin: 2.5px"
              v-tooltip="$t('export.builder.copyTooltip')"
          />
          <buttonc
              v-if="companyArray.length > 1"
              :key="'selectorImport'"
              :label="$t('export.builder.import')"
              @click="
              () => {
                openImportSettingsFromCompanySelect();
              }
            "
              style="width: 254px; height: 30px; margin: 2.5px"
              v-tooltip="$t('export.builder.importFromOtherCompany')"
          />

        </div>
      </div>

        <!-- Export Einstellungen -->
      <div v-if="selectedSettingsId" class="panel settings" id="sExportSettings">
        <labelc
          type="header title"
          :text="$t('export.builder.exportSettings')"
        />
        <div class="panel-container">
          <datatablesimple :state="sSettingsCompanyState" class="flex-item" />
          <datatablesimple v-if="$parent.mode !== 'individual-wagetypes'" class="flex-item" :state="sSettingsHeaderState" />
          <datatablesimple v-if="$parent.mode === 'individual-wagetypes'" class="flex-item" :state="sSettingsIndividualWageTypesListState" />
          <datatablesimple v-if="$parent.mode === 'individual-wagetypes'" class="flex-item-wide" :state="sSettingsIndividualWageTypesHeaderState" />
          <datatablesimple v-if="$parent.mode === 'monthly'" class="flex-item" :state="sSettingsMonthlyAdditionalState" />
          <datatablesimple v-if="$parent.mode === 'daily'" class="flex-item" :state="sSettingsDailyAdditionalState" />
          <datatablesimple v-if="$parent.mode === 'personnelProvisions'" class="flex-item" :state="sSettingsPersonnelProvisionsAdditionalState" />
        </div>
      </div>

      <!-- Verfügbare Beschäftigungsmodelle -->
      <div v-if="['individual-wagetypes'].includes($parent.mode) && selectedSettingsId" class="panel employmentModels" id="sEmploymentModels">
        <labelc
          type="header title"
          :text="$t('export.builder.availableEmploymentModels')"
        />
        <div
          class="panel-container"
          style="text-align: left"
        >
          <buttonc
            v-for="(em, index) in employmentModels"
            :key="'MainL'+index"
            :label="em.name"
            @click="
              () => {
                if (!sExportSettings.find(e => e.id === selectedSettingsId)) {
                  return;
                }
                if (sExportSettings.find(e => e.id === selectedSettingsId).locked) {
                  $helpers.warning(this.$t('export.builder.warning'), this.$t('export.builder.settingsLocked'))
                  return;
                }
                if (sExportSettings.find(e => e.id === selectedSettingsId) && sExportSettings.find(e => e.id === selectedSettingsId).selectedEmploymentModels.includes(em.id)) {
                  sExportSettings.find(e => e.id === selectedSettingsId).selectedEmploymentModels = sExportSettings.find(e => e.id === selectedSettingsId).selectedEmploymentModels.filter(e => e !== em.id);
                } else {
                  sExportSettings.find(e => e.id === selectedSettingsId).selectedEmploymentModels.push(em.id);
                }
                settingsUpdated = true;
              }
            "
            v-bind:class="{ selected: sExportSettings.find(e => e.id === selectedSettingsId) && sExportSettings.find(e => e.id === selectedSettingsId).selectedEmploymentModels.includes(em.id),
              locked: sExportSettings.find(e => e.id === selectedSettingsId) && sExportSettings.find(e => e.id === selectedSettingsId).locked }"
            style="width: 254px; height: 30px; margin: 2.5px"
            v-tooltip="$t('export.builder.selectDeselect')"
          />
        </div>
      </div>

      <!-- Verfügbare Lohnarten -->
      <div v-if="['monthly', 'daily'].includes($parent.mode) && selectedSettingsId" class="panel wageTypes" id="sWageTypes">
        <labelc
          type="header title"
          :text="$t('export.builder.availableWageTypes')"
        />
        <div
          class="panel-container compact-gap"
          style="text-align: left"
        >
          <div class="button-group">
            <buttonc
              v-for="(wage, index) in sContentMain"
              :key="'MainL'+index"
              :label="wage.name"
              @click="
                () => {
                  if (!sExportSettings.find(e => e.id === selectedSettingsId)) {
                    return;
                  }
                  if (sExportSettings.find(e => e.id === selectedSettingsId).locked) {
                    $helpers.warning($t('export.builder.warning'), $t('export.builder.settingsLocked'));
                    return;
                  }
                  if (sExportSettings.find(e => e.id === selectedSettingsId) && sExportSettings.find(e => e.id === selectedSettingsId).selectedWageTypes.includes(wage.id)) {
                    sExportSettings.find(e => e.id === selectedSettingsId).selectedWageTypes = sExportSettings.find(e => e.id === selectedSettingsId).selectedWageTypes.filter(e => e !== wage.id);
                  } else {
                    sExportSettings.find(e => e.id === selectedSettingsId).selectedWageTypes.push(wage.id);
                  }
                  settingsUpdated = true;
                }
              "
              v-bind:class="{ selected: wage.checked, locked: sExportSettings.find(e => e.id === selectedSettingsId) && sExportSettings.find(e => e.id === selectedSettingsId).locked }"
              style="width: 254px; height: 30px; margin: 2.5px"
              v-tooltip="$t('export.builder.selectDeselect')"
            />
          </div>
          <div class="button-group">
            <buttonc
              v-for="(wage, index) in sContentSecondary"
              :key="'SubL'+index"
              :label="wage.name"
              @click="
                () => {
                  if (!sExportSettings.find(e => e.id === selectedSettingsId)) {
                    return;
                  }
                  if (sExportSettings.find(e => e.id === selectedSettingsId).locked) {
                    $helpers.warning($t('export.builder.warning'), $t('export.builder.settingsLocked'));
                    return;
                  }
                  if (sExportSettings.find(e => e.id === selectedSettingsId) && sExportSettings.find(e => e.id === selectedSettingsId).selectedWageTypes.includes(wage.id)) {
                    sExportSettings.find(e => e.id === selectedSettingsId).selectedWageTypes = sExportSettings.find(e => e.id === selectedSettingsId).selectedWageTypes.filter(e => e !== wage.id);
                  } else {
                    sExportSettings.find(e => e.id === selectedSettingsId).selectedWageTypes.push(wage.id);
                  }
                  settingsUpdated = true;
                }
              "
              v-bind:class="{ selected: wage.checked, locked: sExportSettings.find(e => e.id === selectedSettingsId) && sExportSettings.find(e => e.id === selectedSettingsId).locked }"
              style="width: 254px; height: 30px; margin: 2.5px"
              v-tooltip="$t('export.builder.selectDeselect')"
            />
          </div>
        </div>
      </div>
      <div v-if="['individual-wagetypes'].includes($parent.mode) && selectedSettingsId" class="panel wageTypes" id="sWageTypes">
        <labelc
          type="header title"
          :text="$t('export.builder.availableWageTypes')"
        />
        <div
          class="panel-container"
          style="text-align: left;"
        >
          <datatablesimple v-if="$parent.mode === 'individual-wagetypes'" :state="sSettingsIndividualWageTypesWageTypeState" />
        </div>
      </div>

    </div>
    <!-- ---------------------- -->
    <!-- -EXPORT OVERVIEW PAGE- -->
    <!-- ---------------------- -->
    <div class="scrollbar-container export-builder" v-if="!loading && !exporting && subPage === 'export_overview'">
      <labelc type="header title" v-bind:text="overviewTitleText"/>

      <table class="styled-table">
        <tr>
            <th>{{ $t('settings.sync.startedBy') }}</th>
            <th v-if="$parent.mode === 'individual-wagetypes'">{{ $t('settings.wage.locations') }}</th>
            <th>{{ $t('export.builder.selectSetting') }}</th>
            <th v-if="$parent.mode === 'individual-wagetypes'">{{ $t('export.builder.exportSetting') }}</th>
            <th>{{ $t('settings.sync.exportStarted') }}</th>
            <th>{{ $t('export.builder.exportSent') }}</th>
            <th v-if="$parent.mode === 'individual-wagetypes'">{{ $t('export.builder.useForLastValue') }}</th>
            <th class="center">{{ $t('export.builder.downloadExport') }}</th>
            <th class="center" v-if="$parent.mode === 'individual-wagetypes'">{{ $t('export.builder.showPdf') }}</th>
        </tr>
        <tr v-for="exportJob in exportJobs" v-bind:key="exportJob.id">
          <td>{{ exportJob.authuserName }}</td>
          <td v-if="$parent.mode === 'individual-wagetypes'" style="white-space: pre;">{{ getStoreNames(exportJob.storeIds) }}</td>
          <td>{{ months.find(m => m.value === exportJob.month).label }} {{ exportJob.year }}</td>
          <td v-if="$parent.mode === 'individual-wagetypes'" style="white-space: pre;">{{ JSON.parse(exportJob.exportSettings).name }}</td>
          <td>{{ exportJob.jobStarted }}</td>
          <td>{{ exportJob.jobEnded }}</td>
          <td v-if="$parent.mode === 'individual-wagetypes'">
            <div class="entryData">
              <i class="fas fa-check-circle checkbox" :key="'cb-eevts'"
                 v-bind:class="{ false: !exportJob.useForDeltaCalculation }"
                 v-on:click="exportJob.useForDeltaCalculation = !exportJob.useForDeltaCalculation; setDeltaCalculationFlag(exportJob.individualWageTypeExportId, exportJob.useForDeltaCalculation)"></i>
            </div>
          </td>
          <td class="center">
            <button v-if="exportJob.exportCsv != null" class="icon-button" v-on:click="downloadCSVFromExportJob(exportJob.exportCsv, exportJob.jobStartedISO, exportJob.filename)">
              <i class="fas fa-file-download"></i>
            </button>
          </td>
          <td class="center" v-if="$parent.mode === 'individual-wagetypes'">
            <button v-if="exportJob.exportJson != null" class="icon-button" v-on:click="openCreatePdfFromExportJob(exportJob, exportJob.jobStartedISO)">
              <i class="fas fa-file-pdf"></i>
            </button>
          </td>
        </tr>
      </table>

    </div>
    <div v-if="loading" class="loading-md bg" style="z-index: 20">
      <i class="fas fa-spinner"></i>
      <br />
      <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
        {{ loadingText }}
      </div>
    </div>

    <div v-if="exporting" class="loading-md bg" style="z-index: 20">
      <i class="fas fa-spinner"></i>
      <br />
      <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">{{ $t('export.builder.pleaseWaitGenerateExport') }}</div>
    </div>

    <b-modal ref="modal-pdfpreview" @close="closePdfPreview()" centered>
      <template slot="modal-header">
        <div class="error-modal">
          <div class="headerlabel">{{ $t('export.builder.reportCreated') }}</div>
        </div>
      </template>
      <b-container fluid>
        <b-row class="my-1" style="text-align: left;">
          <div>
            <span>{{ $t('export.builder.reportReady') }}</span>
          </div>
        </b-row>
      </b-container>
      <template slot="modal-footer">
        <div class="button right" @click="closePdfPreview()">
          <div class="label">
            {{ $t('global.ui.close') }}
          </div>
        </div>
        <div class="button ml right" @click="openPreviewedPdf()">
          <div class="label">
            {{ $t('employee.data.openInNewTab') }}
          </div>
        </div>
        <div class="button ml right" @click="savePreviewedPdf()">
          <div class="label">
            {{ $t('employee.data.save') }}
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal size="md" ref="modal-loading" :no-close-on-backdrop="true" :no-close-on-esc="true" centered>
      <template slot="modal-header">
        <div></div>
      </template>
      <b-container fluid>
        <div class="full">
          <div class="label left" style="text-align: center">
            <i class="fas fa-spinner fa-spin" style="font-size: xxx-large"></i> <br/><br/>
            {{ $t('employee.collective.pleaseWait') }}<br />
            {{ $t('employee.comp.dataLoading') + '...'}}...<br />
          </div>
        </div>
      </b-container>
      <template slot="modal-footer">
        <div></div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import 'jspdf-autotable';
import Dropdownsearch from "@/components/uicomponents/dropdownsearch.vue";
import { RFC_2822 } from "moment";
export default {
  name: "ExportBuilder",
  components: {Dropdownsearch},
  data() {
    return {
      titleText: this.$t('export.builder.csvExport'),
      availableHeaders: {
        [this.$t('export.builder.companyId')]: true,
        [this.$t('comp.ui.employeeId')]: true,
        [this.$t('export.builder.employeeNameIn')]: true, // keeping source text as given
        [this.$t('export.builder.wageType')]: true,
        [this.$t('export.builder.paidHours')]: false,
        [this.$t('export.builder.contentLabel')]: false
      },

      somethingHasChangedWhatAffectsExportTable: false,
      buildingExportTable: false,

      isDragging: false,
      panelDragged: null,
      headerReplace: {},
      selectedStores: {},
      loadingText: this.$t('employee.comp.dataLoading') + '...',
      hiddenStates: {
        exportsettings: false,
        employmentModels: false,
        wageTypes: false,
        employees: false,
        preview: false,
      },
      orderStates: {
        exportsettings: 0,
        employmentModels: 1,
        wageTypes: 2,
        employees: 3,
        preview: 4,
      },
      collapseStates: {
        exportsettings: false,
        employmentModels: false,
        wageTypes: false,
        employees: true,
        preview: false,
      },
      employeeNameFilter: "",

      missingPersonalIds: [],

      loading: true,
      loadingMFS: true,
      exporting: false,
      saves: false,
      subPage: 'export',
      prevPage: '',

      loadStores: true,
      storesMap: [],
      stores: [],
      storeSettingWeekdaysMap: {},
      employeeMap: {},
      hiddenStores: 0,

      employeeMdids: {},
      mdEmployeeContractMap: {},
      mdContractArray: [],

      prevMonthlyStatements: [],
      monthlyStatements: [],
      showMonthlyStatement: false,

      exportTable: [],
      exportPreviewVisible: false,

      monthlyStatementPerEmployee: {},
      previousMonthlyStatementPerEmployee: {},
      preferencePerEmployee: {},
      duplicateEmployees: [],

      prevMonthStatementResponses: [],
      statementResponses: [],
      employeeWorkDaysCount: [],

      selectedDate: this.$helpers.getMomentTZ().clone().subtract(1, "months"),
      timeframeStart: this.$helpers.getMomentTZ().clone().subtract(1, "months").startOf("month"),
      timeframeEnd: this.$helpers.getMomentTZ().clone().subtract(1, "months").endOf("month"),

      modalPdfBase64: null,
      modalPdfFilename: '',

      balanceItems: [],

      availableFieldsMonthly: [
          {
              key: "externalCompanyId",
              name: this.$t('export.builder.externalCompanyId'),
              newName: this.$t('export.builder.company'),
              checked: true,
          },
          {
              key: "externalEmployeeId",
              name: this.$t('export.builder.externalEmployeeId'),
              newName: this.$t('export.builder.employeeNumber'),
              checked: true,
          },
          {
              key: "month",
              name: this.$t('export.builder.month'),
              newName: this.$t('export.builder.month'),
              checked: true,
          },
          {
              key: "rollUpMonth",
              name: this.$t('export.builder.rollUpMonth'),
              newName: this.$t('export.builder.rollUpMonth'),
              checked: false,
          },
          {
              key: "lohnart",
              name: this.$t('export.builder.lohnart'),
              newName: this.$t('export.builder.lohnart'),
              checked: true,
          },
          {
              key: "paidWorkTime",
              name: this.$t('export.builder.paidWorkTime'),
              newName: this.$t('export.builder.paidWorkTime'),
              checked: true,
          },
          {
              key: "contentName",
              name: this.$t('export.builder.contentName'),
              newName: this.$t('export.builder.content'),
              checked: true,
          },
          {
              key: "employeeName",
              name: this.$t('export.builder.employeeName'),
              newName: this.$t('settings.groups.name'),
              checked: true,
          },
      ],
      availableFieldsMonthlyAdditional: [
          {
              key: "headerAdditional",
              name: this.$t('export.builder.headerAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.doNotPrintColumnLabels')
              },
              checked: true,
          },
          {
              key: "monthAdditional",
              name: this.$t('export.builder.monthAdditional'),
              item: {
                  key: "current",
                  label: this.$t('export.builder.currentMonth')
              },
              checked: true,
          },
          {
              key: "rollUpMonthAdditional",
              name: this.$t('export.builder.rollUpMonthAdditional'),
              item: {
                  key: "current",
                  label: this.$t('export.builder.currentMonth')
              },
              checked: false,
          },
          {
              key: "paidWorkTimeAdditional",
              name: this.$t('export.builder.paidWorkTimeAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.exportZeroValues')
              },
              checked: true,
          },
      ],
      availableFieldsDaily: [
          {
              key: "dailyExternalCompanyId",
              name: this.$t('export.builder.dailyExternalCompanyId'),
              newName: this.$t('export.builder.company'),
              checked: true,
          },
          {
              key: "dailyExternalEmployeeId",
              name: this.$t('export.builder.dailyExternalEmployeeId'),
              newName: this.$t('global.ui.pNumber'),
              checked: true,
          },
          {
              key: "dailyLohnart",
              name: this.$t('export.builder.dailyLohnart'),
              newName: this.$t('export.builder.typeShort'),
              checked: true,
          },
          {
              key: "dailyFrom",
              name: this.$t('export.builder.dailyFrom'),
              newName: this.$t('export.builder.fromShort'),
              checked: true,
          },
          {
              key: "dailyTo",
              name: this.$t('export.builder.dailyTo'),
              newName: this.$t('export.builder.toShort'),
              checked: true,
          },
          {
              key: "dailyPayoutValue",
              name: this.$t('export.builder.dailyPayoutValue'),
              newName: this.$t('export.builder.administration'),
              checked: true,
          },
          {
              key: "dailyPayoutHoursValue",
              name: this.$t('export.builder.dailyPayoutHoursValue'),
              newName: this.$t('export.builder.paid'),
              checked: false,
          },
          {
              key: "dailyProcessingFlag",
              name: this.$t('export.builder.dailyProcessingFlag'),
              newName: this.$t('export.builder.dailyProcessingFlag'),
              checked: true,
          },
          {
              key: "dailyContentName",
              name: this.$t('export.builder.dailyContentName'),
              newName: this.$t('export.builder.content'),
              checked: true,
          },
          {
              key: "dailyEmployeeName",
              name: this.$t('export.builder.dailyEmployeeName'),
              newName: this.$t('settings.groups.name'),
              checked: true,
          },
      ],
      availableFieldsDailyAdditional: [
          {
              key: "headerAdditional",
              name: this.$t('export.builder.headerAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.doNotPrintColumnLabels')
              },
              checked: true,
          },
          {
              key: "dailyPayoutValueAdditional",
              name: this.$t('export.builder.dailyPayoutValueAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.valueInHours')
              },
              checked: true,
          },
          {
              key: "dailyPayoutHoursValueAdditional",
              name: this.$t('export.builder.dailyPayoutHoursValueAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.valueInHours')
              },
              checked: true,
          },
          {
              key: "dailyProcessingFlagAdditional",
              name: this.$t('export.builder.dailyProcessingFlagAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.createAbsences')
              },
              checked: true,
          },
      ],
      availableFieldsPersonnelProvisions: [
          {
              key: "ppExternalCompanyId",
              name: this.$t('export.builder.externalCompanyId'),
              newName: this.$t('export.builder.company'),
              checked: true,
          },
          {
              key: "ppExternalEmployeeId",
              name: this.$t('comp.ui.employeeId'),
              newName: this.$t('export.builder.employeeNumber'),
              checked: true,
          },
          {
              key: "ppEmployeeName",
              name: this.$t('export.builder.employeeName'),
              newName: this.$t('settings.groups.name'),
              checked: false,
          },
          {
              key: "balance1",
              name: this.$t('export.builder.balance1'),
              newName: this.$t('wageTypes.md.36'),
              item: {
                  key: 36,
                  label: this.$t('wageTypes.md.36')
              },
              checked: true,
          },
          {
              key: "balance2",
              name: this.$t('export.builder.balance2'),
              newName: this.$t('wageTypes.md.70'),
              item: {
                  key: 70,
                  label: this.$t('wageTypes.md.70')
              },
              checked: true,
          },
          {
              key: "balance3",
              name: this.$t('export.builder.balance3'),
              newName: this.$t('wageTypes.md.1'),
              item: {
                  key: 1,
                  label: this.$t('wageTypes.md.1')
              },
              checked: true,
          },
          {
              key: "balance4",
              name: this.$t('export.builder.balance4'),
              newName: this.$t('wageTypes.md.0'),
              item: {
                  key: 0,
                  label: this.$t('wageTypes.md.0')
              },
              checked: false,
          },
          {
              key: "balance5",
              name: this.$t('export.builder.balance5'),
              newName: this.$t('wageTypes.md.0'),
              item: {
                  key: 0,
                  label: this.$t('wageTypes.md.0')
              },
              checked: false,
          },
      ],
      availableFieldsPersonnelProvisionsAdditional: [
          {
              key: "ppHeaderAdditional",
              name: this.$t('export.builder.ppHeaderAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.doNotPrintColumnLabels')
              },
              checked: true,
          },
          {
              key: "ppBalanceAdditional",
              name: this.$t('export.builder.ppBalanceAdditional'),
              item: {
                  key: 1,
                  label: this.$t('export.builder.doNotExportZeroValues')
              },
              checked: true,
          },
          {
              key: "ppValuesAdditional",
              name: this.$t('export.builder.ppValuesAdditional'),
              item: {
                  key: 2,
                  label: this.$t('export.builder.industryMinutes')
              },
              checked: true,
          },
          {
              key: "ppAllowNegativesAdditional",
              name: this.$t('export.builder.ppAllowNegativesAdditional'),
              item: [],
              checked: true,
          },
          {
              key: "ppIncludePaidAdditional",
              name: this.$t('export.builder.ppIncludePaidAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.includePayouts')
              },
              checked: true,
          },
          {
              key: "balance1Additional",
              name: this.$t('export.builder.balance1Additional'),
              item: {
                  key: 1
              },
              checked: true,
          },
          {
              key: "balance2Additional",
              name: this.$t('export.builder.balance2Additional'),
              item: {
                  key: 2
              },
              checked: true,
          },
          {
              key: "balance3Additional",
              name: this.$t('export.builder.balance3Additional'),
              item: {
                  key: 0
              },
              checked: false,
          },
          {
              key: "balance4Additional",
              name: this.$t('export.builder.balance4Additional'),
              item: {
                  key: 0
              },
              checked: false,
          },
          {
              key: "balance5Additional",
              name: this.$t('export.builder.balance5Additional'),
              item: {
                  key: 0
              },
              checked: false,
          },
      ],
      availableFieldsIndividualWageTypes: [
          {
              key: "externalCompanyId",
              name: this.$t('export.builder.externalCompanyId'),
              newName: this.$t('export.builder.company'),
              checked: true,
              fieldOrder: 1,
          },
          {
              key: "externalEmployeeId",
              name: this.$t('export.builder.externalEmployeeId'),
              newName: this.$t('export.builder.employeeNumber'),
              checked: true,
              fieldOrder: 2,
          },
          {
              key: "month",
              name: this.$t('export.builder.month'),
              newName: this.$t('export.builder.month'),
              checked: true,
              fieldOrder: 3,
          },
          {
              key: "rollUpMonth",
              name: this.$t('export.builder.rollUpMonth'),
              newName: this.$t('export.builder.rollUpMonth'),
              checked: false,
              fieldOrder: 4,
          },
          {
              key: "lohnart",
              name: this.$t('export.builder.lohnart'),
              newName: this.$t('export.builder.lohnart'),
              checked: true,
              fieldOrder: 5,
          },
          {
              key: "paidWorkTime",
              name: this.$t('export.builder.paidWorkTime'),
              newName: this.$t('export.builder.paidWorkTime'),
              checked: true,
              fieldOrder: 6,
          },
          {
              key: "contentName",
              name: this.$t('export.builder.contentName'),
              newName: this.$t('export.builder.content'),
              checked: true,
              fieldOrder: 7,
          },
          {
              key: "employeeName",
              name: this.$t('export.builder.employeeName'),
              newName: this.$t('settings.groups.name'),
              checked: true,
              fieldOrder: 8,
          },
          {
              key: "date",
              name: this.$t('export.builder.date'),
              newName: this.$t('export.builder.date'),
              checked: false,
              fieldOrder: 9,
          },
          {
              key: "costCenter",
              name: this.$t('export.builder.costCenter'),
              newName: this.$t('comp.ui.costCenter'),
              checked: false,
              fieldOrder: 10,
          },
          {
              key: "factor",
              name: this.$t('export.builder.factor'),
              newName: this.$t('export.builder.factor'),
              checked: false,
              fieldOrder: 11,
          },
          {
              key: "hours",
              name: this.$t('export.builder.hours'),
              newName: this.$t('export.builder.hours'),
              checked: false,
              fieldOrder: 12,
          },
          {
              key: "payment",
              name: this.$t('export.builder.payment'),
              newName: this.$t('export.builder.payment'),
              checked: false,
              fieldOrder: 13,
          },
          {
              key: "year",
              name: this.$t('export.builder.year'),
              newName: this.$t('export.builder.year'),
              checked: false,
              fieldOrder: 14,
          },
          {
              key: "day",
              name: this.$t('export.builder.day'),
              newName: this.$t('export.builder.day'),
              checked: false,
              fieldOrder: 15,
          },
          {
              key: "unavailabilityCode",
              name: this.$t('export.builder.unavailabilityCode'),
              newName: this.$t('export.builder.unavailabilityCode'),
              checked: false,
              fieldOrder: 16,
          },
          {
              key: "days",
              name: this.$t('export.builder.days'),
              newName: this.$t('export.builder.days'),
              checked: false,
              fieldOrder: 17,
          },
          {
              key: "storeCostCenter",
              name: this.$t('export.builder.storeCostCenter'),
              newName: this.$t('export.builder.storeCostCenter'),
              checked: false,
              fieldOrder: 18,
          },
          {
              key: "processingKey",
              name: this.$t('export.builder.processingKey'),
              newName: this.$t('export.builder.processingKey'),
              checked: false,
              fieldOrder: 19,
          },
          {
              key: "daysCalculated",
              name: this.$t('export.builder.daysCalculated'),
              newName: this.$t('export.builder.daysCalculated'),
              checked: false,
              fieldOrder: 20,
          },
          {
              key: "date2",
              name: this.$t('export.builder.date2'),
              newName: this.$t('export.builder.date2'),
              checked: false,
              fieldOrder: 21,
          },
          {
              key: "taxId",
              name: this.$t('export.builder.taxId'),
              newName: this.$t('export.builder.taxId'),
              checked: false,
              fieldOrder: 22,
          },
      ],
      availableFieldsIndividualWageTypesListAdditional: [
          {
              key: "headerAdditional",
              name: this.$t('export.builder.headerAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.doNotPrintColumnLabels')
              },
              checked: true,
          },
          {
              key: "sumsAdditional",
              name: this.$t('export.builder.sumsAdditional'),
              item: {
                  key: 2,
                  label: this.$t('export.builder.monthlySums')
              },
              checked: true,
          },
          {
              key: "zeroValuesAdditional",
              name: this.$t('export.builder.zeroValuesAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.doNotExportZeroValues')
              },
              checked: true,
          },
          {
              key: "absencesAdditional",
              name: this.$t('export.builder.absencesAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.standard')
              },
              checked: true,
          },
          {
              key: "mergeAdditional",
              name: this.$t('export.builder.mergeAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.exportWageTypesIndividually')
              },
              checked: true,
          },
          {
              key: "shiftsAdditional",
              name: this.$t('export.builder.shiftsAdditional'),
              item: {
                  key: 2,
                  label: this.$t('export.builder.exportActualShifts')
              },
              checked: true,
          },
          {
              key: "calcModeAdditional",
              name: this.$t('export.builder.calcModeAdditional'),
              item: {
                  key: 1,
                  label: this.$t('export.builder.calcModeCurrentDay')
              },
              checked: true,
          },
          {
              key: "deltaAdditional",
              name: this.$t('export.builder.deltaAdditional'),
              item: {
                  key: 1,
                  label: this.$t('export.builder.ignoreLastExportValues')
              },
              checked: true,
          },
          {
              key: "processingKeyAdditionalHours",
              name: this.$t('export.builder.processingKeyAdditionalHours'),
              fixedValue: "1",
              checked: true,
          },
          {
              key: "processingKeyAdditionalValue",
              name: this.$t('export.builder.processingKeyAdditionalValue'),
              fixedValue: "3",
              checked: true,
          },
          {
              key: "addAdditional",
              name: this.$t('export.builder.addAdditional'),
              checked: true,
          },
      ],
      availableFieldsIndividualWageTypesFieldsAdditional: [
          {
              key: "monthAdditional",
              name: this.$t('export.builder.monthAdditional'),
              item: {
                  key: "current",
                  label: this.$t('export.builder.currentMonth')
              },
              checked: true,
          },
          {
              key: "rollUpMonthAdditional",
              name: this.$t('export.builder.rollUpMonthAdditional'),
              item: {
                  key: "current",
                  label: this.$t('export.builder.currentMonth')
              },
              checked: false,
          },
          {
              key: "externalEmployeeIdAdditional",
              name: this.$t('export.builder.externalEmployeeIdAdditional'),
              item: {
                  key: 0,
                  label: this.$t('export.builder.applyWithoutChange')
              },
              checked: true,
          },
          {
              key: "paidWorkTimeAdditional",
              name: this.$t('export.builder.paidWorkTimeAdditional'),
              item: {
                  key: 1,
                  label: this.$t('export.builder.doNotExportZeroValues')
              },
              checked: true,
          },
      ],

      content: [],
      employmentModelArray: [],
      currentCSV: null,
      previewCSV: null,
      currentJson: null,
      currentFilename: null,
      currentCreateDate: null,
      bmdId: 0,
      softwareId: -1,

      settingsUpdated: false,
      baseSettingsBackup: {},
      baseSettings: {},
      baseSettingsTemplate: {
        enableExportViaTransferService: false,
        enablePeriodicExport: false,
        enableMonthlyClosingExport: false,
        openSettingsPageDefault: false,
        periodicExportTimes: [],
        monthlyClosingExportSettings: [],
      },
      selectedSettingsId: 0,
      sExportSettingsBackup : [
        // {name: "Standard", id: 0, selectedStores: [], availableFields: [], availableFieldsAdditional: [], selectedWageTypes: []},
        // {name: "Export 2", id: 2, selectedStores: [], availableFields: [], availableFieldsAdditional: [], selectedWageTypes: []},
        // {name: "Urlaube monatlich", id: 3, selectedStores: [], availableFields: [], availableFieldsAdditional: [], selectedWageTypes: []}
      ],
      sExportSettings : [
        // {name: "Standard", id: 0, selectedStores: [], availableFields: [], availableFieldsAdditional: [], selectedWageTypes: []},
        // {name: "Export 2", id: 2, selectedStores: [], availableFields: [], availableFieldsAdditional: [], selectedWageTypes: []},
        // {name: "Urlaube monatlich", id: 3, selectedStores: [], availableFields: [], availableFieldsAdditional: [], selectedWageTypes: []}
      ],


      exportJobs: [],
    };
  },
  watch: {
    companyId: function (val, oldVal) {
      this.refresh(false, false);
    },
    globalFilter: function (val, oldVal) {
      this.globalFilterChanged();
    },
    baseSettings: {
      handler (val, oldVal) {
        val.periodicExportTimes.forEach(time => {
          let hours = parseInt(time.hours);
          if (hours > 23) {
            time.hours = 23;
          } else if (hours < 10) {
            time.hours = "0" + hours;
          } else {
            time.hours = hours;
          }

          let minutes = parseInt(time.minutes);
          if (minutes > 59) {
            time.minutes = 59;
          } else if (minutes < 10) {
            time.minutes = "0" + minutes;
          } else {
            time.minutes = minutes;
          }
        });
      },
      deep: true,
    },
  },
  created() {
    let view = this;
  },
  mounted() {
    let view = this;
    this.LoadFilterDropdown();
      this.titleText = ["individual-wagetypes"].includes(view.$parent.mode)
          ? this.$t('export.builder.csvExportIndividualWageTypes')
          : this.$parent.mode == 'monthly'
              ? this.$t('export.builder.csvExportMonthlySums')
              : this.$parent.mode == 'daily'
                  ? this.$t('export.builder.csvExportAbsences')
                  : this.$t('export.builder.csvExportProvisions');
      this.settingsTitleText = ["individual-wagetypes"].includes(view.$parent.mode)
          ? this.$t('export.builder.csvExportSettingsIndividualWageTypes')
          : this.$parent.mode == 'monthly'
              ? this.$t('export.builder.csvExportSettingsMonthlySums')
              : this.$parent.mode == 'daily'
                  ? this.$t('export.builder.csvExportSettingsAbsences')
                  : this.$t('export.builder.csvExportSettingsProvisions');
      this.overviewTitleText = ["individual-wagetypes"].includes(view.$parent.mode)
          ? this.$t('export.builder.exportOverviewIndividualWageTypes')
          : this.$parent.mode == 'monthly'
              ? this.$t('export.builder.exportOverviewMonthlySums')
              : this.$parent.mode == 'daily'
                  ? this.$t('export.builder.exportOverviewAbsences')
                  : this.$t('export.builder.exportOverviewProvisions');

    view.$helpers.GetExportSelectedDate().then((data) => {
      if(data.currentDate){
        const isLessThanOneHourAgo = view.$helpers.getMomentTZ().diff(data.currentDate, 'hours') < 3;
        if (isLessThanOneHourAgo) {
          view.selectedDate = view.$helpers.getMomentFromString(data.date);
          view.timeframeStart = view.selectedDate.clone().startOf("month");
          view.timeframeEnd = view.selectedDate.clone().endOf("month");
          view.$forceUpdate();
        }
      }
    });

    view.$helpers.GetExportSelectedColumns(this.$parent.mode).then((data) => {
      for (let i in view.availableFields) {
        if (data[view.availableFields[i].key]) {
          view.availableFields[i].checked = data[view.availableFields[i].key].checked;
          if (view.$parent.mode === 'personnelProvisions') { // special case for personnel provisions
            view.availableFields[i].item = data[view.availableFields[i].key].item;
            view.availableFields[i].newName = data[view.availableFields[i].key].item ?
              data[view.availableFields[i].key].item.label
              : data[view.availableFields[i].key].newName;
            // hack to fix local storage data after rework of overtime balance
            // "Überstunden Saldo" is now key 70. key 29 is now "Zuschlagspfl. Überstunden Saldo" and reflects the old "Überstunden Saldo"
            if (view.availableFields[i].item && view.availableFields[i].item.key == 29 && view.availableFields[i].item.label == this.$t('export.builder.overtimeBalance2')) {
              view.availableFields[i].item.key = 70;
            }
          } else {
            view.availableFields[i].newName = data[view.availableFields[i].key].newName;
          }
          if (this.$parent.mode === "individual-wagetypes") {
            view.availableFields[i].fieldOrder = data[view.availableFields[i].key].fieldOrder;
            for (let i in view.availableFieldsIndividualWageTypesListAdditional) {
              if (data[view.availableFieldsIndividualWageTypesListAdditional[i].key]) {
                view.availableFieldsIndividualWageTypesListAdditional[i].checked = data[view.availableFieldsIndividualWageTypesListAdditional[i].key].checked;
                view.availableFieldsIndividualWageTypesListAdditional[i].item = data[view.availableFieldsIndividualWageTypesListAdditional[i].key].item;
                view.availableFieldsIndividualWageTypesListAdditional[i].fixedValue = data[view.availableFieldsIndividualWageTypesListAdditional[i].key].fixedValue ?? "";
              }
            }
          }
        }
      }
      if (this.$parent.mode === "individual-wagetypes") {
        // find placeholders
        Object.entries(data).filter(([key, value]) => key.startsWith("placeholder")).forEach(([key, value]) => {
          view.availableFieldsIndividualWageTypes.push({
            key: key,
            name: value.name,
            newName: value.newName,
            fixedValue: value.fixedValue ?? "",
            deleteable: true,
            deleteFunction: () => {
              let currentFieldOrder = view.availableFieldsIndividualWageTypes.find(a => a.key == value.key).fieldOrder;
              view.updateFieldOrder(view, currentFieldOrder, 100);
              view.availableFieldsIndividualWageTypes = view.availableFieldsIndividualWageTypes.filter(a => a.key != value.key);
              view.saveAvailableFieldsLS();
              view.somethingHasChangedWhatAffectsExportTable = true;
              view.$forceUpdate();
            },
            checked: value.checked,
            fieldOrder: value.fieldOrder,
          });
        });
        // find new fields with higher field order than the currently saved ones and add them to the end of the list.
        // this should ensure that new fields do not have the same field order due to possible placeholders
        // 1.: count placeholders
        // 2.: check what new fields are not in the list yet --> check what items are in availableFieldsIndividualWagetypes, but not in data
        // 3.: set fieldOrder to fieldOrder + number of placeholders for all new fields
        let placeholderCount = view.availableFieldsIndividualWageTypes.filter(f => f.key.startsWith("placeholder")).length;
        view.availableFieldsIndividualWageTypes.forEach(f => {
          if (!data[f.key] && !f.key.startsWith("placeholder")) {
            f.fieldOrder = f.fieldOrder + placeholderCount;
          }
        });
        view.availableFieldsIndividualWageTypes.sort((a, b) => a.fieldOrder - b.fieldOrder);
      }
      for (let i in view.availableFieldsAdditional) {
        if (data[view.availableFieldsAdditional[i].key]) {
          view.availableFieldsAdditional[i].checked = data[view.availableFieldsAdditional[i].key].checked;
          view.availableFieldsAdditional[i].item = data[view.availableFieldsAdditional[i].key].item;
        }
      }
    });

    this.refresh(false, false);
    let localOrder = localStorage.getItem("localOrderExportBuilderPanels");
    if (localOrder) {
      this.orderStates = JSON.parse(localOrder);
    }
  },
  computed: {
    ...mapGetters(["companyId", "isSuperUser", "loggedIn", "userInfo", "activeStoreUsersMap", "companyArray", "storeArray", "globalFilter", "companySettings"]),
    contentMain() {
      let data = [];
      for (let i in this.content) {
        if (this.content[i].isMain) {
          data.push(this.content[i]);
        }
      }
      return data;
    },
    contentSecondary() {
      let data = [];
      for (let i in this.content) {
        if (!this.content[i].isMain) {
          data.push(this.content[i]);
        }
      }
      return data;
    },
    hasSelectedWageType() {
      if (this.$parent.mode === 'personnelProvisions') {
        return this.availableFieldsPersonnelProvisions.some((field) =>
          /^balance[1-5]$/.test(field.key) && field.checked
        );
      }

      return this.content.some((wageType) => wageType.checked);
    },

    sContentMain() {
      let data = [];
      let currentSetting = this.sExportSettings.find(e => e.id === this.selectedSettingsId);
      for (let i in this.content) {
        if (this.content[i].isMain) {
          let currentEntry = JSON.parse(JSON.stringify(this.content[i]));
          currentEntry.checked = currentSetting ? currentSetting.selectedWageTypes.includes(currentEntry.id) : false;
          data.push(currentEntry);
        }
      }
      return data;
    },
    sContentSecondary() {
      let data = [];
      let currentSetting = this.sExportSettings.find(e => e.id === this.selectedSettingsId);
      for (let i in this.content) {
        if (!this.content[i].isMain) {
          let currentEntry = JSON.parse(JSON.stringify(this.content[i]));
          currentEntry.checked = currentSetting ? currentSetting.selectedWageTypes.includes(currentEntry.id) : false;
          data.push(currentEntry);
        }
      }
      return data;
    },

    employmentModels() {
      return this.employmentModelArray;
    },

    availableFields() {
      let view = this;
      if (view.$parent.mode === 'monthly') {
        return view.availableFieldsMonthly.map(field => { field.name = view.$t(`export.builder.${field.key}`); return field; });
      } else if (view.$parent.mode === 'individual-wagetypes') {
        return view.availableFieldsIndividualWageTypes.map(field => { field.name = view.$t(`export.builder.${field.key}`); return field; });
      } else if (view.$parent.mode === 'daily') {
        return view.availableFieldsDaily.map(field => { field.name = view.$t(`export.builder.${field.key}`); return field; });
      } else if (view.$parent.mode === 'personnelProvisions') {
        let translatedItems = view.balanceItems.map(i => {
          return { key: i.key, label: view.$t(`wageTypes.md.${i.key}`) };
        });
        return view.availableFieldsPersonnelProvisions.map(field => {
          field.name = view.$t(`export.builder.${field.key}`);
          if (field.key.startsWith("balance")) {
            let balanceKey = field.item ? field.item.key : null;
            let balance = translatedItems.find(b => b.key == balanceKey);
            if (balance) {
              field.newName = balance.label;
              field.item.label = balance.label;
            }
          }
          return field;
        });
      }
      return [];
    },
    availableFieldsAdditional() {
      let view = this;

      if (view.$parent.mode === 'monthly') {
        return view.availableFieldsMonthlyAdditional.map(field => { field.name = view.$t(`export.builder.${field.key}`); return field; });
      } else if (view.$parent.mode === 'individual-wagetypes') {
        return view.availableFieldsIndividualWageTypesFieldsAdditional.map(field => { field.name = view.$t(`export.builder.${field.key}`); return field; });
      } else if (view.$parent.mode === 'daily') {
        return view.availableFieldsDailyAdditional.map(field => { field.name = view.$t(`export.builder.${field.key}`); return field; });
      } else if (view.$parent.mode === 'personnelProvisions') {
        return view.availableFieldsPersonnelProvisionsAdditional.map(field => { field.name = view.$t(`export.builder.${field.key}`); return field; });
      }
      return [];
    },


    months() {
      return [
          {value: 1, label: this.$t('global.time.month0')},
          {value: 2, label: this.$t('global.time.month1')},
          {value: 3, label: this.$t('global.time.month2')},
          {value: 4, label: this.$t('global.time.month3')},
          {value: 5, label: this.$t('global.time.month4')},
          {value: 6, label: this.$t('global.time.month5')},
          {value: 7, label: this.$t('global.time.month6')},
          {value: 8, label: this.$t('global.time.month7')},
          {value: 9, label: this.$t('global.time.month8')},
          {value: 10, label: this.$t('global.time.month9')},
          {value: 11, label: this.$t('global.time.month10')},
          {value: 12, label: this.$t('global.time.month11')}
      ];
    },
    dateDisplay: function () {
      let view = this;
      return view.months.find(month => month.value === (view.timeframeStart.months() + 1)).label + " " + view.timeframeStart.format("YYYY");
    },
    headerButtons() {
      let view = this;

      let state = {
        buttons: [],
        helperLinks: [
          {
              title: this.$t('export.builder.supportTitle'),
              helperText: this.$t('export.builder.supportHelperText'),
              externalUrl:
                "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/11",
            externalLabel:  view.$t('settings.sync.contactSupport') ,
            cancelLabel: view.$t('global.ui.close'),
          }
        ]
      };
      if (view.$parent.mode === 'individual-wagetypes' && view.subPage === 'settings') {
        state.helperLinks.unshift({
            title: this.$t('export.builder.reportViaMDPTitle'),
            helperText: this.$t('export.builder.reportViaMDPHelperText'),
            externalUrl:
                "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/3262611460",
            externalLabel: this.$t('export.builder.learnMore'),
            cancelLabel: this.$t('export.builder.thanks'),
            icon: "fa-file-signature"
        });
      }
      if (view.$parent.mode === 'individual-wagetypes') {
        state.helperLinks.unshift({
            title: this.$t('export.builder.individualWageTypesTitle'),
            helperText: this.$t('export.builder.individualWageTypesHelperText'),
            externalUrl:
                "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/3130720268",
            externalLabel: this.$t('export.builder.learnMore'),
            cancelLabel: this.$t('export.builder.thanks'),
            icon: "fa-file-export"
        });
      }

      if (view.subPage === 'export') {

        state.buttons.push({
          type: "block border-r",
          icon: "fa-refresh",
          disabled: this.loading || this.exporting || view.settingsUpdated,
          click: () => {
            view.refresh(true, true);
          },
          tooltip: view.$t('settings.wage.reloadData'),
        });
        state.buttons.push({
          type: "block border-r",
          icon: "fa-cog",
          // show: view.$parent.mode !== 'individual-wagetypes',
          disabled: this.loading || this.exporting,
          click: () => {
            view.subPage = 'settings';
          },
          tooltip: view.$t('settings.sync.exportSettings'),
        });
        state.buttons.push({
          type: "block border-r",
          icon: "fa-magnifying-glass",
          show: view.baseSettings.enableExportViaTransferService,
          disabled: this.loading || this.exporting || view.settingsUpdated,
          click: () => {
            view.prevPage = 'export';
            view.subPage = 'export_overview';
          },
          tooltip:  view.$t('settings.sync.viewExport') ,
          title:  view.$t('settings.sync.viewExport') ,
        });

        if (view.somethingHasChangedWhatAffectsExportTable && !view.buildingExportTable) {
          state.buttons.push({
            type: "block border-r",
            icon: "fa-table-cells",
            disabled: this.loading || this.exporting || !view.hasSelectedWageType,
            click: () => {
              view.buildExportTable();
            },
            tooltip: view.$t('export.builder.regenerateTable') + ' ',
          });
        }

        if (!view.somethingHasChangedWhatAffectsExportTable) {
          if (view.$parent.mode === 'individual-wagetypes') {
            state.buttons.push({
              type: "block border-r",
              icon: "fa-file-pdf",
              disabled: this.loading || this.exporting || !this.currentJson,
              click: () => {
                view.openCreatePdfFromExportJson(JSON.stringify(view.currentJson));
              },
              tooltip: this.$t('export.builder.generatePdfFromCurrentTable'),
            });
          }
          state.buttons.push({
            type: "block border-r",
            icon: view.$parent.mode === 'individual-wagetypes' ? "fa-file-arrow-down" : "fa-file-csv",
            disabled: this.loading || this.exporting || !this.previewCSV,
            click: () => {
              view.doCsvDownload();
            },
            tooltip: this.$t('export.builder.download'),
          });
          state.buttons.push({
            type: "block border-r",
            icon: "fa-file-export",
            show: view.baseSettings.enableExportViaTransferService,
            disabled: this.loading || this.exporting || !this.previewCSV,
            click: () => {
              view.triggerCsvExportWithFrontendSettings();
            },
            tooltip: this.$t('export.builder.triggerExportWithCurrentSettings'),
          });
        }


      } else if (view.subPage === 'settings') {

        state.buttons.push({
          type: "block border-r",
          icon: "fa-refresh",
          disabled: this.loading || this.exporting || view.settingsUpdated,
          click: () => {
            view.refresh(true, true);
          },
          tooltip: view.$t('settings.wage.reloadData'),
        });
        state.buttons.push({
          type: "block border-r",
          icon: "fa-chevron-left",
          disabled: this.loading || this.exporting || view.settingsUpdated,
          click: () => {
            view.subPage = 'export';
          },
          tooltip: this.$t('export.builder.backToExport'),
        });
        state.buttons.push({
          type: "block border-r",
          icon: "fa-magnifying-glass",
          show: view.baseSettings.enableExportViaTransferService,
          disabled: this.loading || this.exporting || view.settingsUpdated,
          click: () => {
            view.prevPage = 'settings';
            view.subPage = 'export_overview';
          },
          tooltip:  view.$t('settings.sync.viewExport') ,
          title:  view.$t('settings.sync.viewExport') ,
        });
        if (view.$parent.mode === 'individual-wagetypes') {
          state.buttons.push({
            type: "block ",
            icon: "fa-file-pdf",
            disabled: this.loading || this.exporting || view.settingsUpdated || view.sExportSettings.length === 0,
            click: () => {
              view.openPdfDownloadPopup();
            },
            tooltip: this.$t('export.builder.generatePdf'),
          });
          state.buttons.push({
            type: "block",
            icon: "fa-file-csv",
            disabled: this.loading || this.exporting || view.settingsUpdated || view.sExportSettings.length === 0,
            click: () => {
              view.generateCsvOverview();
            },
            tooltip: this.$t('export.builder.downloadCsvOverview'),
          });
        }
        state.buttons.push({
          type: "block green",
          icon: view.$parent.mode === 'individual-wagetypes' ? "fa-file-arrow-down" : "fa-file-csv",
          disabled: this.loading || this.exporting || view.settingsUpdated || view.sExportSettings.length === 0,
          click: () => {
            view.openCsvDownloadWithSettingsPopup();
          },
          tooltip: view.$t('employee.doc.download'),
        });
        state.buttons.push({
          type: "block green",
          icon: "fa-file-export",
          show: view.baseSettings.enableExportViaTransferService,
          disabled: this.loading || this.exporting || view.settingsUpdated || view.sExportSettings.length === 0,
          click: () => {
            view.openCsvExportWithSettingsPopup();
          },
          tooltip: view.$t('global.ui.export'),
        });
        state.buttons.push({
          type: "block green",
          icon: "fa-save",
          show: view.settingsUpdated,
          click: () => {
            if (view.baseSettings.enableMonthlyClosingExport) {
              let error = false;
              view.baseSettings.monthlyClosingExportSettings.forEach((setting) => {
                let exportSetting = view.sExportSettings.find((e) => e.id === setting.exportId);
                if (exportSetting && exportSetting.selectedStores.length > 1) {
                  error = true;
                }
              });
              if (error) {
                view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.noMultiStoreSaveForMonthEnd'));
                return;
              }
            }

            view.baseSettings.periodicExportTimes.forEach((time) => { time.editing = false; });
            let successmessage = {
              title: view.$t('global.ui.success'),
              message: view.$t('export.builder.settingsSaved')
            };
            let errormessage = {
              title: view.$t('global.messages.error'),
              message: view.$t('export.builder.settingsCouldNotBeSaved')
            };
            view.putExportSettings(view.$parent.mode, successmessage, errormessage)
            .then((response) => {
              view.baseSettingsBackup = JSON.parse(JSON.stringify(view.baseSettings));
              view.sExportSettingsBackup = JSON.parse(JSON.stringify(view.sExportSettings));
              view.settingsUpdated = false;
            })
            .catch((e) => {
              console.log(e);
            });
          },
          tooltip: this.$t('employee.data.save'),
        });
        state.buttons.push({
          type: "block red",
          icon: "fa-minus-circle",
          show: view.settingsUpdated,
          click: () => {
            view.baseSettings = JSON.parse(JSON.stringify(view.baseSettingsBackup));
            view.sExportSettings = JSON.parse(JSON.stringify(view.sExportSettingsBackup));
            view.sExportSettings.forEach(setting => {
              // sort availableFields by fieldOrder if available (IWT)
              if (setting.availableFields.length > 0 && setting.availableFields[0].hasOwnProperty('fieldOrder')) {
                // console.log("sorting");
                setting.availableFields.sort((a, b) => a.fieldOrder - b.fieldOrder);
              }

              // reapply delete functions for placeholders
              setting.availableFields.filter(f => f.key && f.key.startsWith("placeholder")).forEach(f => {
                f.deleteFunction = () => {
                  let currentFieldOrder = setting.availableFields.find(a => a.key == f.key).fieldOrder;
                  if (setting.locked) {
                    view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                    return;
                  }
                  view.updateFieldOrder(setting, currentFieldOrder, 100);
                  setting.availableFields = setting.availableFields.filter(a => a.key != f.key);
                  view.settingsUpdated = true;
                }
              });
            });
            let currentSetting = view.sExportSettings.find(e => e.id === view.selectedSettingsId);
            if (!currentSetting) {
              view.selectedSettingsId = view.sExportSettings.length > 0 ? view.sExportSettings[0].id : 0;
            }
            view.settingsUpdated = false;
          },
          tooltip: this.$t('export.builder.discardChanges'),
        });

      } else if (view.subPage === 'export_overview') {

        state.buttons.push({
          type: "block border-r",
          icon: "fa-refresh",
          disabled: this.loading || this.exporting || view.settingsUpdated,
          click: () => {
            view.loadExportJobs();
          },
          tooltip: view.$t('export.builder.reloadExports'),
        });
        state.buttons.push({
          type: "block border-r",
          icon: "fa-chevron-left",
          disabled: this.loading,
          click: () => {
            view.subPage = view.prevPage;
          },
          tooltip: view.$t('global.ui.back'),
        });

      } else {

      }

      return state;
    },
    sideButtons() {
      let view = this;

      let state = {
        buttons: [],
      };
      if (view.subPage === 'export') {
        state.buttons.push({
          type: "block border-r",
          icon: "fa-eye",
          tooltip: view.$t('comp.ui.displayFilter'),
          click: ($event) => {
            view.OpenFilterDropdown($event);
          },
        });
      }

      if ([1,3,4,5,6,7].includes(view.softwareId) && view.subPage == "settings") {
        state.buttons.push({
          type: "block border-r",
          icon: "fa-plus",
          tooltip: view.$t('export.builder.createExportTemplate'),
          click: ($event) => {
            view.createExportTemplate();
          },
        });
      }

      if ([1,3,4,5,6,7].includes(view.softwareId) && view.subPage == "settings") {
        state.buttons.push({
          type: "block border-r",
          icon: "fa-location-plus",
          tooltip: view.$t('export.builder.createExportTemplatePerStore'),
          click: ($event) => {
            view.createExportTemplate(true);
          },
        });
      }

      if (view.subPage === 'settings') {
        state.buttons.push({
          type: "block",
          icon: "fa-thumbtack",
          styleIcon: view.baseSettings.openSettingsPageDefault ? "" : "font-weight: 200;",
          tooltip: view.$t('export.builder.pinExportSettings'),
          click: ($event) => {
            view.baseSettings.openSettingsPageDefault = !view.baseSettings.openSettingsPageDefault;
            view.putOpenSettingsPageDefault(view.$parent.mode);
          },
        });
      }

      if ((((["monthly"].includes(view.$parent.mode) || view.$parent.mode == "daily") && view.softwareId == 0) || view.subPage == "export")) {
        state.buttons.push({
          type: "block",
          icon: "fa-bars",
          tooltip:  view.$t('settings.help.additionalDownloads') ,
          click: ($event) => {
            view.OpenMenuDetails($event, this.burgerMenuState);
          },
        });
      }

      return state;
    },


    monthItems() {
      return [
        {
            key: "current",
            label: this.$t('export.builder.currentMonth')
        },
        {
            key: "previous",
            label: this.$t('export.builder.previousMonth')
        },
        {
            key: "next",
            label: this.$t('export.builder.nextMonth')
        }
      ];
    },

    balanceAdditionItems() {
      return [
        {
            key: 0,
            label: this.$t('export.builder.noAddition')
        },
        {
            key: 1,
            label: this.$t('export.builder.addition25')
        },
        {
            key: 2,
            label: this.$t('export.builder.addition50')
        },
        {
            key: 3,
            label: this.$t('export.builder.addition75')
        },
        {
            key: 4,
            label: this.$t('export.builder.addition100')
        },
      ];
    },
    ppValuesAdditionalItems() {
      return [
        {
            key: 0,
            label: this.$t('export.builder.minutes')
        },
        {
            key: 1,
            label: this.$t('employee.contract.hours')
        },
        {
            key: 2,
            label: this.$t('export.builder.industryMinutes')
        }
      ];
    },
    ppIncludePaidAdditionalItems() {
      return [
        {
            key: 0,
            label: this.$t('export.builder.includePayouts')
        },
        {
            key: 1,
            label: this.$t('export.builder.excludePayouts')
        }
      ];
    },
    ppAllowNegativesAdditionalItems() {
      return [
        {
            value: 1,
            label: this.$t('export.builder.balance1'),
            selected: false
        },
        {
            value: 2,
            label: this.$t('export.builder.balance2'),
            selected: false
        },
        {
            value: 3,
            label: this.$t('export.builder.balance3'),
            selected: false
        },
        {
            value: 4,
            label: this.$t('export.builder.balance4'),
            selected: false
        },
        {
            value: 5,
            label: this.$t('export.builder.balance5'),
            selected: false
        }
      ];
    },
    externalEmployeeIdItems() {
      return [
        {
            key: 0,
            label: this.$t('export.builder.applyWithoutChange')
        },
        {
            key: 1,
            label: this.$t('export.builder.fixedLength4')
        },
        {
            key: 2,
            label: this.$t('export.builder.fixedLength5')
        },
        {
            key: 3,
            label: this.$t('export.builder.fixedLength6')
        }
      ];
    },
    paidWorkTimeAdditionalItems() {
      return [
        {
            key: 0,
            label: this.$t('export.builder.exportZeroValues')
        },
        {
            key: 1,
            label: this.$t('export.builder.doNotExportZeroValues')
        }
      ];
    },
    headerAdditionalItems() {
      return [
          {
              key: 0,
              label: this.$t('export.builder.doNotPrintColumnLabels')
          },
          {
              key: 1,
              label: this.$t('export.builder.printColumnLabels')
          }
      ];
    },
    sumsAdditionalItems() {
      return [
          {
              key: 0,
              label: this.$t('export.builder.dailySums')
          },
          // {
          //   key: 1,
          //   label: this.$t('export.builder.weeklySums')
          // },
          {
              key: 2,
              label: this.$t('export.builder.monthlySums')
          }
      ];
    },
    zeroValuesAdditionalItems() {
      return [
          {
              key: 0,
              label: this.$t('export.builder.doNotExportZeroValues')
          },
          {
              key: 1,
              label: this.$t('export.builder.exportZeroValues')
          }
      ];
    },
    absencesAdditionalItems() {
      return [
          {
              key: 0,
              label: this.$t('export.builder.standard')
          },
          {
              key: 1,
              label: this.$t('export.builder.forceDailyEntries')
          }
      ];
    },
    mergeAdditionalItems() {
      return [
          {
              key: 0,
              label: this.$t('export.builder.exportWageTypesIndividually')
          },
          {
              key: 1,
              label: this.$t('export.builder.mergeSameExportId')
          }
      ];
    },
    shiftsAdditionalItems() {
      return [
          {
              key: 1,
              label: this.$t('export.builder.exportAllShifts')
          },
          {
              key: 2,
              label: this.$t('export.builder.exportActualShifts')
          },
          {
              key: 3,
              label: this.$t('export.builder.exportPlannedShifts')
          }
      ];
    },
    calcModeAdditionalItems() {
      return [
          {
              key: 1,
              label: this.$t('export.builder.calcModeCurrentDay')
          },
          {
              key: 2,
              label: this.$t('export.builder.calcModeShiftStart')
          }
      ];
    },
    deltaAdditionalItems() {
      return [
          {
              key: 1,
              label: this.$t('export.builder.ignoreLastExportValues')
          },
          {
              key: 2,
              label: this.$t('export.builder.listLastExportValuesAsNegative')
          },
          {
              key: 3,
              label: this.$t('export.builder.subtractLastExportValues')
          }
      ];
    },
    exportDateItems() {
      return [
          {
              key: 0,
              label: this.$t('export.builder.createAbsences')
          },
          {
              key: 1,
              label: this.$t('export.builder.linkAbsences')
          }
      ];
    },
    dailyPayoutValueAdditionalItems() {
      return [
          {
              key: 0,
              label: this.$t('export.builder.valueInHours')
          },
          {
              key: 1,
              label: this.$t('export.builder.valueInDays')
          },
          {
              key: 2,
              label: this.$t('export.builder.valueInHoursNegative')
          },
          {
              key: 3,
              label: this.$t('export.builder.valueInDaysNegative')
          }
      ];
    },
    dailyPayoutHoursValueAdditionalItems() {
      return [
          {
              key: 0,
              label: this.$t('export.builder.valueInHours')
          },
          {
              key: 1,
              label: this.$t('export.builder.valueInDays')
          },
          {
              key: 2,
              label: this.$t('export.builder.valueInHoursNegative')
          },
          {
              key: 3,
              label: this.$t('export.builder.valueInDaysNegative')
          }
      ];
    },
    periodicExportTimeReportMonth() {
      return [
          {
              value: 0,
              label: this.$t('export.builder.previousMonth')
          },
          {
              value: 1,
              label: this.$t('export.builder.currentMonth')
          }
      ];
    },
    periodicExportTimeTypes() {
      return [
          {
              value: 0,
              label: this.$t('export.builder.daily')
          },
          {
              value: 1,
              label: this.$t('export.builder.weekly')
          },
          {
              value: 2,
              label: this.$t('export.builder.monthly')
          }
      ];
    },
    individualWageTypesExportValueTypes() {
      return [
          {
              value: 0,
              label: this.$t('employee.contract.hours') // existing key, reused
          },
          {
              value: 1,
              label: this.$t('export.builder.quantity')
          },
          // {
          //   value: 2,
          //   label: this.$t('export.builder.flatCount') // (commented out in source)
          // },
          {
              value: 3,
              label: this.$t('employee.comp.amount') // existing key, reused
          },
          {
              value: 4,
              label: this.$t('export.builder.monthEndValue')
          }
      ];
    },

    // export page
    settingsCompanyState() {
      let view = this;

      let customStores = [];
      view.hiddenStores = 0;
      view.stores.forEach(function (store) {
        let pushed = false;
        if (view.globalFilter && view.globalFilter.stores && view.globalFilter.companyId == view.$store.state.companyId) {
          for (let i in view.globalFilter.stores) {
            if (view.globalFilter.stores[i].id == store.id && view.globalFilter.stores[i].selected) {
              customStores.push(store);
              view.storesMap[store.id].selected = true;
              pushed = true;
            }
          }
        }
        if (!pushed) {
          view.storesMap[store.id].selected = false;
          view.hiddenStores++;
        }
      });

      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          storeId: view.$t('settings.wage.locations'),
          employeeFinishedState: view.$t('export.builder.monthEndDoneNotDone'),
        },
        customStores
      );

      state.headerMap.storeId.width = "40%";
      state.headerMap.storeId.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: data.name,
            type: "occupy-container",
            class: `  ${view.selectedStores[data.id] ? "selected" : ""}`,
            tooltip: view.$t('export.builder.selectDeselect'),
            style: "height: calc(100% - 5px) !important;",
            customEvents: {
              click: () => {
                // "Lodas", "Lohn und Gehalt" and "Agenda" only allow one store at a time
                let promises = [];
                if ([3,5,6].includes(view.softwareId)) {
                  Object.entries(view.selectedStores).forEach(([key, value]) => {
                    view.$set(view.selectedStores, key, false);
                    if (view.storesMap[key]) {
                      view.storesMap[key].selected = false;
                    }
                  });
                  promises.push(view.toggleStoreLocalStorage(Object.keys(view.selectedStores), false));
                }
                Promise.all(promises).then(() => {
                  view.$set(view.selectedStores, data.id, !view.selectedStores[data.id]);
                  view.storesMap[data.id].selected = view.selectedStores[data.id];
                  view.toggleStoreLocalStorage([data.id], view.selectedStores[data.id]);
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.checkDuplicateEmployees();
                  view.$forceUpdate();
                });
              },
            },
            styleText: { "text-align": "left", width: "100%" },
          };
        },
      ];

      state.headerMap.employeeFinishedState.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: view.$t('export.builder.monthEnd'),
            type: "occupy-container",
            style: "height: calc(100% - 5px) !important;pointer-events:none; box-shadow: inset  10px 0 0 -5px var(--bg)",
          };
        },
        (data, entry) => {
          return {
            componentType: "buttonc",
            icon: !view.monthlyStatements[data.id].loading && view.monthlyStatements[data.id].confirmed ? "fa-check" : "fa-times",
            type: "icon-overlay",
            style: "pointer-events:none;position: absolute; top: 0, left: initial !important; right: 120px !important; bottom: 0; margin: auto; transform: scale(.8)",
            styleIcon: {
              color: !view.monthlyStatements[data.id].loading && view.monthlyStatements[data.id].confirmed ? "var(--md)" : "var(--ml)",
            },
          };
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.headerMap.employeeFinishedState.stylesHeader.paddingLeft = "5px";
      state.compact = true;
      return state;
    },
    settingsHeaderState() {
      let view = this;
      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          listStructure: view.$t('export.builder.listStructure'),
          columns: view.$t('export.builder.columnLabel'),
        },
        Object.values(this.availableFields)
      );

      state.headerMap.listStructure.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: view.$t(`export.builder.${data.key}`),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `  ${data.checked ? "selected" : ""}`,
            customEvents: {
              click: () => {
                data.checked = !data.checked;
                view.saveAvailableFieldsLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {

          if (data.key.startsWith("balance")) {
            let translatedItems = view.balanceItems.map(i => {
              return { key: i.key, label: view.$t(`wageTypes.md.${i.key}`) };
            }).sort((a, b) => a.label.localeCompare(b.label));
            let selectedItem = view.availableFields.find(a => a.key == data.key).item;
            return {
              componentType: "dropdownsearch",
              state: {
                items: translatedItems,
                selectedItem: translatedItems.find(a => a.key == selectedItem.key),
                onceSelected: function ($event, item) {
                  view.availableFields.find(a => a.key == data.key).item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else {
            return {
              componentType: "inputc",
              inputProp: data.newName,
              placeholder: data.newName,
              style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
              customEvents: {
                Update: (val) => {
                  data.newName = val;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
              },
            };
          }
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.compact = true;
      return state;
    },
    settingsIndividualWageTypesListState() {
      let view = this;

      this.availableFieldsIndividualWageTypesListAdditional.forEach(a => a.hidden = false);
      // Lodas
      if (view.softwareId !== 5) {
        this.availableFieldsIndividualWageTypesListAdditional.filter(a => a.key.startsWith("processingKeyAdditional")).forEach(a => a.hidden = true);
      }
      // Lohn und Gehalt
      if (view.softwareId !== 6) {
        this.availableFieldsIndividualWageTypesListAdditional.filter(a => a.key === "absencesAdditional").forEach(a => a.hidden = true);
      }

      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          header: view.$t('export.builder.setting'),
          columns: view.$t('export.builder.selection'),
        },
        Object.values(this.availableFieldsIndividualWageTypesListAdditional)
      );

      state.headerMap.header.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: view.$t(`export.builder.${data.key}`),
            type: "occupy-container",
            // tooltip: "Auswählen / Abwählen",
            class: `  ${data.checked ? "selected" : ""}`,
            customEvents: {
              click: () => {
                // data.checked = !data.checked;
                // view.saveAvailableFieldsLS();
                // view.somethingHasChangedWhatAffectsExportTable = true;
                // view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {
          if (data.key === "headerAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.headerAdditionalItems,
                selectedItem: view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "headerAdditional")
                  ? view.headerAdditionalItems.find(item => item.key === view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "headerAdditional").item.key)
                  : view.headerAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "headerAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "sumsAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.sumsAdditionalItems,
                selectedItem: view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "sumsAdditional")
                  ? view.sumsAdditionalItems.find(item => item.key === view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "sumsAdditional").item.key)
                  : view.sumsAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "sumsAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "zeroValuesAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.zeroValuesAdditionalItems,
                selectedItem: view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "zeroValuesAdditional")
                  ? view.zeroValuesAdditionalItems.find(item => item.key === view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "zeroValuesAdditional").item.key)
                  : view.zeroValuesAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "zeroValuesAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "absencesAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.absencesAdditionalItems,
                selectedItem: view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "absencesAdditional")
                  ? view.absencesAdditionalItems.find(item => item.key === view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "absencesAdditional").item.key)
                  : view.absencesAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "absencesAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "mergeAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.mergeAdditionalItems,
                selectedItem: view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "mergeAdditional")
                  ? view.mergeAdditionalItems.find(item => item.key === view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "mergeAdditional").item.key)
                  : view.mergeAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "mergeAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "shiftsAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.shiftsAdditionalItems,
                selectedItem: view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "shiftsAdditional")
                  ? view.shiftsAdditionalItems.find(item => item.key === view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "shiftsAdditional").item.key)
                  : view.shiftsAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "shiftsAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "calcModeAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.calcModeAdditionalItems,
                selectedItem: view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "calcModeAdditional")
                  ? view.calcModeAdditionalItems.find(item => item.key === view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "calcModeAdditional").item.key)
                  : view.calcModeAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "calcModeAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "deltaAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.deltaAdditionalItems,
                selectedItem: view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "deltaAdditional")
                  ? view.deltaAdditionalItems.find(item => item.key === view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "deltaAdditional").item.key)
                  : view.deltaAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsIndividualWageTypesListAdditional.find(a => a.key == "deltaAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "processingKeyAdditionalHours") {
            return {
              componentType: "inputc",
              inputProp: data.fixedValue,
              placeholder: data.fixedValue,
              style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
              customEvents: {
                Update: (val) => {
                  data.fixedValue = val;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
              },
            };
          } else if (data.key === "processingKeyAdditionalValue") {
            return {
              componentType: "inputc",
              inputProp: data.fixedValue,
              placeholder: data.fixedValue,
              style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
              customEvents: {
                Update: (val) => {
                  data.fixedValue = val;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
              },
            };
          } else if (data.key === "addAdditional") {
            return {
              componentType: "buttonc",
              label: "+",
              type: "occupy-container",
              tooltip: view.$t('export.builder.addAdditional'),
              class: "",
              customEvents: {
                click: () => {
                  let placeHolderCount = view.availableFieldsIndividualWageTypes.filter(a => a.key.startsWith("placeholder")).length;
                  let newPlaceHolderCount = placeHolderCount + 1;
                  let fieldOrder = view.availableFieldsIndividualWageTypes.length + 1;
                  view.availableFieldsIndividualWageTypes.push({
                    key: "placeholder" + newPlaceHolderCount,
                    name: view.$t('export.builder.placeholder') + " " + newPlaceHolderCount,
                    newName: view.$t('export.builder.placeholder') + " " + newPlaceHolderCount,
                    fixedValue: "",
                    deleteable: true,
                    deleteFunction: () => {
                      let currentFieldOrder = view.availableFieldsIndividualWageTypes.find(a => a.key == "placeholder" + newPlaceHolderCount).fieldOrder;
                      view.updateFieldOrder(view, currentFieldOrder, 100);
                      view.availableFieldsIndividualWageTypes = view.availableFieldsIndividualWageTypes.filter(a => a.key != "placeholder" + newPlaceHolderCount);
                      view.saveAvailableFieldsLS();
                      view.somethingHasChangedWhatAffectsExportTable = true;
                      view.$forceUpdate();
                    },
                    checked: true,
                    fieldOrder: fieldOrder,
                  });
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
              },
              style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
              styleLabel: { "text-align": "center", width: "100%" },
            };
          } else {
            return {};
          }
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.compact = true;
      return state;
    },
    settingsIndividualWageTypesHeaderState() {
      let view = this;
      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          listStructure: view.$t('export.builder.listStructure'),
          columns: view.$t('export.builder.columnLabel'),
          columnSettings: this.$t('employee.data.additionalSettings'),
        },
        Object.values(this.availableFields)
      );

      // console.log(Object.values(this.availableFields));
      // console.log(Object.values(this.availableFields).sort((a, b) => a.fieldOrder - b.fieldOrder));

      state.headerMap.listStructure.componentStateBuilders = [
        (data, entry) => {
          let label = data.key.startsWith("placeholder") ? view.$t('export.builder.placeholder') + " " + data.key.replace("placeholder", "") : view.$t(`export.builder.${data.key}`);
          return {
            componentType: "buttonc",
            label: label,
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `  ${data.checked ? "selected" : ""}`,
            customEvents: {
              click: () => {
                data.checked = !data.checked;
                view.saveAvailableFieldsLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "inputc",
            inputProp: data.newName,
            placeholder: data.newName,
            style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
            customEvents: {
              Update: (val) => {
                data.newName = val;
                view.saveAvailableFieldsLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
          };
        },
      ];
      state.headerMap.columnSettings.componentStateBuilders = [
        (data, entry) => {

          if (data.key === "month") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.monthItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == "monthAdditional")
                  ? view.monthItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == "monthAdditional").item.key)
                  : view.monthItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == "monthAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "rollUpMonth") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.monthItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == "rollUpMonthAdditional")
                  ? view.monthItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == "rollUpMonthAdditional").item.key)
                  : view.monthItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == "rollUpMonthAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          // } else if (data.key === "paidWorkTime") {
          //   return {
          //     componentType: "dropdownsearch",
          //     state: {
          //       items: view.paidWorkTimeAdditionalItems,
          //       selectedItem: view.availableFieldsAdditional.find(a => a.key == "paidWorkTimeAdditional").item,
          //       onceSelected: function ($event, item) {
          //         view.availableFieldsAdditional.find(a => a.key == "paidWorkTimeAdditional").item = item;
          //         view.saveAvailableFieldsLS();
          //         view.somethingHasChangedWhatAffectsExportTable = true;
          //         view.$forceUpdate();
          //       },
          //       styleLight: true,
          //       style: "",
          //     },
          //   };
          } else if (data.key === "header") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.headerAdditionalItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == "headerAdditional")
                  ? view.headerAdditionalItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == "headerAdditional").item.key)
                  : view.headerAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == "headerAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key == "externalEmployeeId" && view.softwareId == 4) { // only for "Gesper"
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.externalEmployeeIdItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == "externalEmployeeIdAdditional")
                  ? view.externalEmployeeIdItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == "externalEmployeeIdAdditional").item.key)
                  : view.externalEmployeeIdItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == "externalEmployeeIdAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key.startsWith("placeholder")) {
            return {
              componentType: "inputc",
              inputProp: data.fixedValue,
              placeholder: data.fixedValue,
              style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
              customEvents: {
                Update: (val) => {
                  data.fixedValue = val;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
              },
            };
          } else {
            return {

            };
          }
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = {"justify-content": "start"}));
      state.compact = true;
      state.deleteable = true;
      state.draggable = true;
      state.draggableId = "1";
      state.dragOptions = {
        handle: ".fa-up-down",
        onStart: function (/**Event*/event) {
          // console.log("dragging started", event);
          // remove strange "glow" from "transform: translateZ(0px)"
          event.item.style.transform = null;
        },
        onUpdate(/**Event*/event) {
          // console.log("dragging updated", event);
          view.updateFieldOrder(view, event.oldIndex + 1, event.newIndex + 1);
          view.saveAvailableFieldsLS();
          view.somethingHasChangedWhatAffectsExportTable = true;
          view.$forceUpdate();
        }
      };
      return state;
    },
    settingsIndividualWageTypesWageTypeState() {
      let view = this;
      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          header: this.$t('settings.wage.wageType'),
          value: this.$t('export.builder.paidValueSelection'),
          printPaidValue: this.$t('export.builder.paidValue'),
          printHours: this.$t('export.builder.workHours'),
          printDays: this.$t('export.builder.days'),
          printDaysCalculated: this.$t('export.builder.daysCalculated'),
          printFactor: this.$t('export.builder.wageRate'),
          printPayment: this.$t('employee.comp.amount')
        },
        Object.values(this.content)
      );

      // console.log(this.content);

      state.headerMap.header.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: data.exportId + " - " + data.name,
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `  ${data.checked ? "selected" : ""}`,
            customEvents: {
              click: () => {
                data.checked = !data.checked;
                view.saveContentLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.value.componentStateBuilders = [
        (data, entry) => {
          // console.log(view.content.find(a => a.id == data.id));
          let workType = view.content.find(a => a.id == data.id).details.workType;
          let items = view.individualWageTypesExportValueTypes;
          switch (workType) {
            case 0: // Arbeitszeit
            case 1: // Abwesenheit
            case 4: // Monatssummen
              items = view.individualWageTypesExportValueTypes.filter(a => [0,1,3].includes(a.value)); // allow "Stunden", "Anzahl", "Betrag"
              break;
            case 2: // Andere Kosten
            case 3: // Bonuszahlung
              items = view.individualWageTypesExportValueTypes.filter(a => [1,3].includes(a.value)); // allow "Anzahl", "Betrag"
              break;
            case 5: // Monatsabschluss
              items = view.individualWageTypesExportValueTypes.filter(a => a.value == 4); // only allow "Wert aus Monatsanschluss"
              break;
            default: break;
          }
          return {
              componentType: "dropdownsearch",
              state: {
                items: items,
                selectedItem: view.content.find(a => a.id == data.id)
                  ? items.find(a => a.value == view.content.find(a => a.id == data.id).selectedValue.value)
                  : items[0],
                onceSelected: function ($event, item) {
                  view.content.find(a => a.id == data.id).selectedValue = item;
                  view.saveContentLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
        },
      ];
      state.headerMap.printPaidValue.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: data.printPaidValue ? view.$t('export.builder.fillPaidValue') : view.$t('export.builder.doNotFillPaidValue'),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `  ${data.printPaidValue ? "selected" : ""}`,
            customEvents: {
              click: () => {
                data.printPaidValue = !data.printPaidValue;
                view.saveContentLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.printHours.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: data.printHours ? view.$t('export.builder.fillWorkHours') : view.$t('export.builder.doNotFillWorkHours'),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `  ${data.printHours ? "selected" : ""}`,
            customEvents: {
              click: () => {
                data.printHours = !data.printHours;
                view.saveContentLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.printDays.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: data.printDays ? view.$t('export.builder.fillDays') : view.$t('export.builder.doNotFillDays'),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `  ${data.printDays ? "selected" : ""}`,
            customEvents: {
              click: () => {
                data.printDays = !data.printDays;
                view.saveContentLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.printDaysCalculated.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: data.printDaysCalculated ? view.$t('export.builder.fillDaysCalculated') : view.$t('export.builder.doNotFillDaysCalculated'),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `  ${data.printDaysCalculated ? "selected" : ""}`,
            customEvents: {
              click: () => {
                data.printDaysCalculated = !data.printDaysCalculated;
                view.saveContentLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.printFactor.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: data.printFactor ? view.$t('export.builder.fillWageRate') : view.$t('export.builder.doNotFillWageRate'),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `  ${data.printFactor ? "selected" : ""}`,
            customEvents: {
              click: () => {
                data.printFactor = !data.printFactor;
                view.saveContentLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.printPayment.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: data.printPayment ? view.$t('export.builder.fillAmounts') : view.$t('export.builder.doNotFillAmounts'),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `  ${data.printPayment ? "selected" : ""}`,
            customEvents: {
              click: () => {
                data.printPayment = !data.printPayment;
                view.saveContentLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];


      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.compact = true;
      return state;
    },
    settingsMonthlyAdditionalState() {
      let view = this;
      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          header: view.$t('export.builder.listEntries'),
          columns: this.$t('employee.data.additionalSettings'),
        },
        Object.values(this.availableFieldsAdditional)
      );

      state.headerMap.header.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: view.$t(`export.builder.${data.key}`),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `  ${data.checked ? "selected" : ""}`,
            customEvents: {
              click: () => {
                data.checked = !data.checked;
                view.saveAvailableFieldsLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {

          if (data.key === "monthAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.monthItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == "monthAdditional")
                  ? view.monthItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == "monthAdditional").item.key)
                  : view.monthItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == "monthAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "rollUpMonthAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.monthItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == "rollUpMonthAdditional")
                  ? view.monthItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == "rollUpMonthAdditional").item.key)
                  : view.monthItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == "rollUpMonthAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "paidWorkTimeAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.paidWorkTimeAdditionalItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == "paidWorkTimeAdditional")
                  ? view.paidWorkTimeAdditionalItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == "paidWorkTimeAdditional").item.key)
                  : view.paidWorkTimeAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == "paidWorkTimeAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "headerAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.headerAdditionalItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == "headerAdditional")
                  ? view.headerAdditionalItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == "headerAdditional").item.key)
                  : view.headerAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == "headerAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else {
            return {
              componentType: "inputc",
              inputProp: data.newName,
              placeholder: data.newName,
              style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
              customEvents: {
                Update: (val) => {
                  data.newName = val;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
              },
            };
          }
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.compact = true;
      return state;
    },
    settingsDailyAdditionalState() {
      let view = this;
      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          header: view.$t('export.builder.listEntries'),
          columns: this.$t('employee.data.additionalSettings'),
        },
        Object.values(this.availableFieldsAdditional)
      );

      state.headerMap.header.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: view.$t(`export.builder.${data.key}`),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `  ${data.checked ? "selected" : ""}`,
            customEvents: {
              click: () => {
                data.checked = !data.checked;
                view.saveAvailableFieldsLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {

          if (data.key === "dailyProcessingFlagAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.exportDateItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == "dailyProcessingFlagAdditional")
                  ? view.exportDateItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == "dailyProcessingFlagAdditional").item.key)
                  : view.exportDateItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == "dailyProcessingFlagAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "headerAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.headerAdditionalItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == "headerAdditional")
                  ? view.headerAdditionalItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == "headerAdditional").item.key)
                  : view.headerAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == "headerAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: ""
              },
            };
          } else if (data.key === "dailyPayoutValueAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.dailyPayoutValueAdditionalItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == "dailyPayoutValueAdditional")
                  ? view.dailyPayoutValueAdditionalItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == "dailyPayoutValueAdditional").item.key)
                  : view.dailyPayoutValueAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == "dailyPayoutValueAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: ""
              },
            };
          } else if (data.key === "dailyPayoutHoursValueAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.dailyPayoutHoursValueAdditionalItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == "dailyPayoutHoursValueAdditional")
                  ? view.dailyPayoutHoursValueAdditionalItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == "dailyPayoutHoursValueAdditional").item.key)
                  : view.dailyPayoutHoursValueAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == "dailyPayoutHoursValueAdditional").item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: ""
              },
            };
          } else {
            return {
              componentType: "inputc",
              inputProp: data.newName,
              placeholder: data.newName,
              style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
              customEvents: {
                Update: (val) => {
                  data.newName = val;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
              },
            };
          }
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.compact = true;
      return state;
    },
    settingsPersonnelProvisionsAdditionalState() {
      let view = this;
      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          header: view.$t('export.builder.listEntries'),
          columns: this.$t('employee.data.additionalSettings'),
        },
        Object.values(this.availableFieldsAdditional)
      );

      state.headerMap.header.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: view.$t(`export.builder.${data.key}`),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `  ${data.checked ? "selected" : ""}`,
            customEvents: {
              click: () => {
                data.checked = !data.checked;
                view.saveAvailableFieldsLS();
                view.somethingHasChangedWhatAffectsExportTable = true;
                view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {

          if (data.key === "ppHeaderAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.headerAdditionalItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == data.key)
                  ? view.headerAdditionalItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == data.key).item.key)
                  : view.headerAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == data.key).item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "ppBalanceAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.paidWorkTimeAdditionalItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == data.key)
                  ? view.paidWorkTimeAdditionalItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == data.key).item.key)
                  : view.paidWorkTimeAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == data.key).item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "ppValuesAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.ppValuesAdditionalItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == data.key)
                  ? view.ppValuesAdditionalItems.find(a => a.key == view.availableFieldsAdditional.find(a => a.key == data.key).item.key)
                  : view.ppValuesAdditionalItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == data.key).item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "ppAllowNegativesAdditional") {
            let currentPpAllowNegativesAdditionalItems = view.ppAllowNegativesAdditionalItems.map(a => {
              return {
                value: a.value,
                label: a.label,
                selected: view.availableFieldsAdditional.find(b => b.key == data.key)
                  ? view.availableFieldsAdditional.find(b => b.key == data.key).item.includes(a.value)
                  : false
              };
            });
            return {
              componentType: "dropdownsearch",
              state: {
                selectMultiple: true,
                items: currentPpAllowNegativesAdditionalItems,
                onceSelected: function ($event, items, comp) {
                  console.log("selected items", items);
                  view.availableFieldsAdditional.find(a => a.key == data.key).item = items;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "ppIncludePaidAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.ppIncludePaidAdditionalItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == data.key)
                  ? view.ppIncludePaidAdditionalItems.find(item => item.key === view.availableFieldsAdditional.find(a => a.key == data.key).item.key)
                  : view.ppIncludePaidAdditionalItems[1],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == data.key).item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key.startsWith("balance")) {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.balanceAdditionItems,
                selectedItem: view.availableFieldsAdditional.find(a => a.key == data.key)
                  ? view.balanceAdditionItems.find(b => b.key == view.availableFieldsAdditional.find(a => a.key == data.key).item.key)
                  : view.balanceAdditionItems[0],
                onceSelected: function ($event, item) {
                  view.availableFieldsAdditional.find(a => a.key == data.key).item = item;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
                styleLight: true,
                style: "",
              },
            };
          } else {
            return {
              componentType: "inputc",
              inputProp: data.newName,
              placeholder: data.newName,
              style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
              customEvents: {
                Update: (val) => {
                  data.newName = val;
                  view.saveAvailableFieldsLS();
                  view.somethingHasChangedWhatAffectsExportTable = true;
                  view.$forceUpdate();
                },
              },
            };
          }
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.compact = true;
      return state;
    },
    // settings page
    sSettingsCompanyState() {
      let view = this;

      let currentSetting = view.sExportSettings.find(s => s.id === view.selectedSettingsId);
      // console.log("currentSetting", currentSetting);

      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          storeId: view.$t('settings.wage.locations'),
          employeeFinishedState: view.$t('export.builder.monthEndDoneNotDone'),
        },
        view.stores
      );

      state.headerMap.storeId.width = "40%";
      state.headerMap.storeId.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: data.name,
            type: "occupy-container",
            class: `${currentSetting.selectedStores.includes(data.id) ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            tooltip: view.$t('export.builder.selectDeselect'),
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                // "Lodas", "Lohn und Gehalt" and "Agenda" only allow one store at a time
                if ([3,5,6].includes(view.softwareId)) {
                  if (!currentSetting.selectedStores.includes(data.id)) {
                    currentSetting.selectedStores = [data.id];
                    view.settingsUpdated = true;
                  }
                } else {
                  if (currentSetting.selectedStores.includes(data.id)) {
                    let index = currentSetting.selectedStores.indexOf(currentSetting.selectedStores.find(elem => elem === data.id));
                    currentSetting.selectedStores.splice(index, 1);
                  } else {
                    currentSetting.selectedStores.push(data.id);
                  }
                  view.settingsUpdated = true;
                }
              },
            },
            styleText: { "text-align": "left", width: "100%" },
          };
        },
      ];

      state.headerMap.employeeFinishedState.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: view.$t('export.builder.monthEnd'),
            type: "occupy-container",
            style: "pointer-events:none; box-shadow: inset  10px 0 0 -5px var(--bg)",
          };
        },
        (data, entry) => {
          return {
            componentType: "buttonc",
            icon: !view.monthlyStatements[data.id].loading && view.monthlyStatements[data.id].confirmed ? "fa-check" : "fa-times",
            type: "icon-overlay",
            style: "pointer-events:none;position: absolute; top: 0, left: initial !important; right: 120px !important; bottom: 0; margin: auto; transform: scale(.8)",
            styleIcon: {
              color: !view.monthlyStatements[data.id].loading && view.monthlyStatements[data.id].confirmed ? "var(--md)" : "var(--ml)",
            },
          };
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.headerMap.employeeFinishedState.stylesHeader.paddingLeft = "5px";
      state.compact = true;
      return state;
    },
    sSettingsHeaderState() {
      let view = this;

      let currentSetting = view.sExportSettings.find(s => s.id === view.selectedSettingsId);

      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          listStructure: view.$t('export.builder.listStructure'),
          columns: view.$t('export.builder.columnLabel'),
        },
        Object.values(this.availableFields)
      );

      state.headerMap.listStructure.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: view.$t(`export.builder.${data.key}`),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `${currentSetting.availableFields.find(f => f.key === data.key)
                && currentSetting.availableFields.find(f => f.key === data.key).checked ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                let currentField = currentSetting.availableFields.find(f => f.key === data.key);
                if (currentField && currentField.checked) {
                  currentField.checked = false;
                } else if (currentField) {
                  currentField.checked = true;
                } else {
                  let newData = JSON.parse(JSON.stringify(data));
                  newData.checked = true;
                  currentSetting.availableFields.push(newData);
                }
                view.settingsUpdated = true;
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {

          if (data.key.startsWith("balance")) {
            let balanceX = currentSetting.availableFields.find(f => f.key === data.key);
            // console.log(data.key);
            // console.log(balanceX);
            // console.log(currentSetting.availableFields);
            // console.log("view.availableFields", view.availableFields);
            // console.log("balanceItems", view.balanceItems);
            let translatedItems = view.balanceItems.map(i => {
              return { key: i.key, label: view.$t(`wageTypes.md.${i.key}`) };
            }).sort((a, b) => a.label.localeCompare(b.label));
            let selectedItem = balanceX
                  ? balanceX.item
                  : view.availableFields.find(a => a.key == data.key).item;
            return {
              componentType: "dropdownsearch",
              state: {
                items: translatedItems,
                selectedItem: translatedItems.find(a => a.key == selectedItem.key),
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!currentSetting.availableFields.find(f => f.key === data.key)) {
                    currentSetting.availableFields.push(JSON.parse(JSON.stringify(view.availableFieldsPersonnelProvisions.find(f => f.key === data.key))));
                  }
                  balanceX = currentSetting.availableFields.find(f => f.key === data.key);
                  balanceX.item = item;
                  balanceX.newName = item.label;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else {
            return {
              componentType: "inputc",
              inputProp: currentSetting.availableFields.find(f => f.key === data.key) ? currentSetting.availableFields.find(f => f.key === data.key).newName : data.newName,
              placeholder: currentSetting.availableFields.find(f => f.key === data.key) ? currentSetting.availableFields.find(f => f.key === data.key).newName : data.newName,
              inputOptions: {
                disabled: currentSetting.locked,
              },
              style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
              customEvents: {
                Update: (val) => {
                  let currentField = currentSetting.availableFields.find(f => f.key === data.key);
                  if (currentField) {
                    currentField.newName = val;
                  } else {
                    let newData = JSON.parse(JSON.stringify(data));
                    newData.checked = false;
                    newData.newName = val;
                    currentSetting.availableFields.push(newData);
                  }
                  view.settingsUpdated = true;
                },
              },
            };
          }
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.compact = true;
      return state;
    },
    sSettingsIndividualWageTypesListState() {
      let view = this;
      let currentSetting = view.sExportSettings.find(s => s.id === view.selectedSettingsId);
      // console.log("currentSetting", currentSetting);

      // Lodas
      if (view.softwareId !== 5) {
        this.availableFieldsIndividualWageTypesListAdditional = this.availableFieldsIndividualWageTypesListAdditional.filter(a => !a.key.startsWith("processingKeyAdditional"));
      }
      // Lohn und Gehalt
      if (view.softwareId !== 6) {
        this.availableFieldsIndividualWageTypesListAdditional = this.availableFieldsIndividualWageTypesListAdditional.filter(a => a.key !== "absencesAdditional");
      }

      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          header: view.$t('export.builder.setting'),
          columns: view.$t('export.builder.selection'),
        },
        Object.values(this.availableFieldsIndividualWageTypesListAdditional)
      );

      state.headerMap.header.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: view.$t(`export.builder.${data.key}`),
            type: "occupy-container",
            // tooltip: "Auswählen / Abwählen",
            // class: `${currentSetting && currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key)
            //   && currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).checked ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            class: `${currentSetting.locked ? "selected locked" : "selected"}`, // we do not allow a deselect, so always have it as selected
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                // data.checked = !data.checked;
                // view.saveAvailableFieldsLS();
                // view.somethingHasChangedWhatAffectsExportTable = true;
                // view.$forceUpdate();
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {
          if (data.key === "headerAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.headerAdditionalItems,
                selectedItem: currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key)
                  ? view.headerAdditionalItems.find(item => item.key === currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item.key)
                  : view.headerAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "sumsAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.sumsAdditionalItems,
                selectedItem: currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key)
                  ? view.sumsAdditionalItems.find(item => item.key === currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item.key)
                  : view.sumsAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "zeroValuesAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.zeroValuesAdditionalItems,
                selectedItem: currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key)
                  ? view.zeroValuesAdditionalItems.find(item => item.key === currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item.key)
                  : view.zeroValuesAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "absencesAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.absencesAdditionalItems,
                selectedItem: currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key)
                  ? view.absencesAdditionalItems.find(item => item.key === currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item.key)
                  : view.absencesAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "mergeAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.mergeAdditionalItems,
                selectedItem: currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key)
                  ? view.mergeAdditionalItems.find(item => item.key === currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item.key)
                  : view.mergeAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "shiftsAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.shiftsAdditionalItems,
                selectedItem: currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key)
                  ? view.shiftsAdditionalItems.find(item => item.key === currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item.key)
                  : view.shiftsAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "calcModeAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.calcModeAdditionalItems,
                selectedItem: currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key)
                  ? view.calcModeAdditionalItems.find(item => item.key === currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item.key)
                  : view.calcModeAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "deltaAdditional") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.deltaAdditionalItems,
                selectedItem: currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key)
                  ? view.deltaAdditionalItems.find(item => item.key === currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item.key)
                  : view.deltaAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "processingKeyAdditionalHours") {
            let fixedValue = currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key)
                  ? currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).fixedValue
                  : "1";
            return {
              componentType: "inputc",
              inputProp: fixedValue,
              placeholder: fixedValue,
              inputOptions: {
                disabled: currentSetting.locked,
              },
              style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
              customEvents: {
                Update: (val) => {
                  currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).fixedValue = val;
                  view.settingsUpdated = true;
                },
              },
            };
          } else if (data.key === "processingKeyAdditionalValue") {
            let fixedValue = currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key)
                  ? currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).fixedValue
                  : "3";
            return {
              componentType: "inputc",
              inputProp: fixedValue,
              placeholder: fixedValue,
              inputOptions: {
                disabled: currentSetting.locked,
              },
              style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
              customEvents: {
                Update: (val) => {
                  currentSetting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === data.key).fixedValue = val;
                  view.settingsUpdated = true;
                },
              },
            };
          } else if (data.key === "addAdditional") {
            return {
              componentType: "buttonc",
              label: "+",
              type: "occupy-container",
              tooltip: view.$t('export.builder.addAdditional'),
              class: "",
              customEvents: {
                click: () => {
                  if (currentSetting.locked) {
                    view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                    return;
                  }
                  let placeHolderCount = currentSetting.availableFields.filter(a => a.key.startsWith("placeholder")).length;
                  let newPlaceHolderCount = placeHolderCount + 1;
                  currentSetting.availableFields.push({
                    key: "placeholder" + newPlaceHolderCount,
                    name: view.$t('export.builder.placeholder') + " " + newPlaceHolderCount,
                    newName: view.$t('export.builder.placeholder') + " " + newPlaceHolderCount,
                    fixedValue: "",
                    deleteable: true,
                    deleteFunction: () => {
                      let currentFieldOrder = currentSetting.availableFields.find(a => a.key == "placeholder" + newPlaceHolderCount).fieldOrder;
                      if (currentSetting.locked) {
                        view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                        return;
                      }
                      view.updateFieldOrder(view.sExportSettings.find(s => s.id === view.selectedSettingsId), currentFieldOrder, 100);
                      currentSetting.availableFields = currentSetting.availableFields.filter(a => a.key != "placeholder" + newPlaceHolderCount);
                      view.settingsUpdated = true;
                    },
                    checked: true,
                    fieldOrder: currentSetting.availableFields.length + 1,
                  });
                  view.settingsUpdated = true;

                  // console.log("currentSetting.availableFields", currentSetting.availableFields);
                  // console.log("view.availableFields", view.availableFields);
                },
              },
              style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
              styleLabel: { "text-align": "center", width: "100%" },
            };
          } else {
            return {};
          }
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.compact = true;
      return state;
    },
    sSettingsIndividualWageTypesHeaderState() {
      let view = this;
      let currentSetting = view.sExportSettings.find(s => s.id === view.selectedSettingsId);
      // console.log("currentSetting.availableFields", currentSetting.availableFields);

      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          listStructure: view.$t('export.builder.listStructure'),
          columns: view.$t('export.builder.columnLabel'),
          columnSettings: this.$t('employee.data.additionalSettings'),
        },
        Object.values(currentSetting.availableFields)
      );

      state.headerMap.listStructure.componentStateBuilders = [
        (data, entry) => {
          let label = data.key.startsWith("placeholder") ? view.$t('export.builder.placeholder') + " " + data.key.replace("placeholder", "") : view.$t(`export.builder.${data.key}`);
          return {
            componentType: "buttonc",
            label: label,
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `${currentSetting && currentSetting.availableFields.find(f => f.key === data.key)
              && currentSetting.availableFields.find(f => f.key === data.key).checked ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                currentSetting.availableFields.find(f => f.key === data.key).checked = !currentSetting.availableFields.find(f => f.key === data.key).checked;
                view.settingsUpdated = true;
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "inputc",
            inputProp: data.newName,
            placeholder: data.newName,
            inputOptions: {
              disabled: currentSetting.locked,
            },
            style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
            customEvents: {
              Update: (val) => {
                currentSetting.availableFields.find(f => f.key === data.key).newName = val;
                view.settingsUpdated = true;
              },
            },
          };
        },
      ];
      state.headerMap.columnSettings.componentStateBuilders = [
        (data, entry) => {

          if (data.key === "month") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.monthItems,
                selectedItem: currentSetting.availableFieldsAdditional.find(a => a.key == "monthAdditional")
                  ? view.monthItems.find(item => item.key === currentSetting.availableFieldsAdditional.find(a => a.key == "monthAdditional").item.key)
                  : view.monthItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.availableFieldsAdditional.find(a => a.key == "monthAdditional").item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "rollUpMonth") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.monthItems,
                selectedItem: currentSetting.availableFieldsAdditional.find(a => a.key == "rollUpMonthAdditional")
                  ? view.monthItems.find(item => item.key === currentSetting.availableFieldsAdditional.find(a => a.key == "rollUpMonthAdditional").item.key)
                  : view.monthItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.availableFieldsAdditional.find(a => a.key == "rollUpMonthAdditional").item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          // } else if (data.key === "paidWorkTime") {
          //   return {
          //     componentType: "dropdownsearch",
          //     state: {
          //       items: view.paidWorkTimeAdditionalItems,
          //       selectedItem: currentSetting.availableFieldsAdditional.find(a => a.key == "paidWorkTimeAdditional").item,
          //       onceSelected: function ($event, item) {
          //         vcurrentSettingiew.availableFieldsAdditional.find(a => a.key == "paidWorkTimeAdditional").item = item;
          //         view.settingsUpdated = true;
          //       },
          //       styleLight: true,
          //       style: "",
          //     },
          //   };
          } else if (data.key === "header") {
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.headerAdditionalItems,
                selectedItem: currentSetting.availableFieldsAdditional.find(a => a.key == "headerAdditional")
                  ? view.headerAdditionalItems.find(item => item.key === currentSetting.availableFieldsAdditional.find(a => a.key == "headerAdditional").item.key)
                  : view.headerAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.availableFieldsAdditional.find(a => a.key == "headerAdditional").item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key == "externalEmployeeId" && view.softwareId == 4) { // only for "Gesper"
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.externalEmployeeIdItems,
                selectedItem: currentSetting.availableFieldsAdditional.find(a => a.key == "externalEmployeeIdAdditional")
                  ? view.externalEmployeeIdItems.find(item => item.key === currentSetting.availableFieldsAdditional.find(a => a.key == "externalEmployeeIdAdditional").item.key)
                  : view.externalEmployeeIdItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.availableFieldsAdditional.find(a => a.key == "externalEmployeeIdAdditional").item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key.startsWith("placeholder")) {
            return {
              componentType: "inputc",
              inputProp: data.fixedValue,
              placeholder: data.fixedValue,
              inputOptions: {
                disabled: currentSetting.locked,
              },
              style: "text-align: left; box-shadow: inset 0 0 0 1px var(--contrast-3); height: calc(100% - 5px); width: calc(100% - 8px); top: 0px",
              customEvents: {
                Update: (val) => {
                  currentSetting.availableFields.find(f => f.key === data.key).fixedValue = val;
                  view.settingsUpdated = true;
                },
              },
            };
          } else {
            return {

            };
          }
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = {"justify-content": "start"}));
      state.compact = true;
      state.deleteable = true;
      state.draggable = true;
      state.showDragAnchor = !currentSetting.locked;
      state.draggableId = "2";
      state.dragOptions = {
        handle: ".fa-up-down",
        onStart: function (/**Event*/event) {
          // console.log("dragging started", event);
          // remove strange "glow" from "transform: translateZ(0px)"
          event.item.style.transform = null;
        },
        onUpdate(/**Event*/event) {
          // console.log("dragging updated", event);
          view.updateFieldOrder(view.sExportSettings.find(s => s.id === view.selectedSettingsId), event.oldIndex + 1, event.newIndex + 1);
          view.settingsUpdated = true;
        }
      };

      return state;
    },
    sSettingsIndividualWageTypesWageTypeState() {
      let view = this;
      let currentSetting = view.sExportSettings.find(s => s.id === view.selectedSettingsId);
      // console.log("content", view.content);

      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          header: this.$t('settings.wage.wageType'),
          columns: this.$t('export.builder.paidValueSelection'),
          printPaidValue: this.$t('export.builder.paidValue'),
          printHours: this.$t('export.builder.workHours'),
          printDays: this.$t('export.builder.days'),
          printDaysCalculated: this.$t('export.builder.daysCalculated'),
          printFactor: this.$t('export.builder.wageRate'),
          printPayment: this.$t('employee.comp.amount')
        },
        Object.values(this.content)
      );

      // console.log(this.content);

      state.headerMap.header.componentStateBuilders = [
        (data, entry) => {
          // console.log("data", data);
          return {
            componentType: "buttonc",
            label: data.exportId + " - " + data.name,
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `${currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                if (currentSetting.selectedWageTypes.find(wt => wt.id === data.id)) {
                  currentSetting.selectedWageTypes = currentSetting.selectedWageTypes.filter(wt => wt.id !== data.id);
                } else {
                  currentSetting.selectedWageTypes.push({
                    id: data.id,
                    selectedValue: data.selectedValue,
                    printPaidValue: data.printPaidValue,
                    printHours: data.printHours,
                    printDays: data.printDays,
                    printDaysCalculated: data.printDaysCalculated,
                    printFactor: data.printFactor,
                    printPayment: data.printPayment
                  });
                }
                view.settingsUpdated = true;
                // console.log(currentSetting.selectedWageTypes);
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {
          // console.log(view.content.find(a => a.id == data.id));
          let workType = view.content.find(a => a.id == data.id).details.workType;
          let items = view.individualWageTypesExportValueTypes;
          switch (workType) {
            case 0: // Arbeitszeit
            case 1: // Abwesenheit
            case 4: // Monatssummen
             items = view.individualWageTypesExportValueTypes.filter(a => [0,1,3].includes(a.value)); // allow "Stunden", "Anzahl", "Betrag"
              break;
            case 2: // Andere Kosten
            case 3: // Bonuszahlung
              items = view.individualWageTypesExportValueTypes.filter(a => [1,3].includes(a.value)); // allow "Anzahl", "Betrag"
              break;
            case 5: // Monatsabschluss
              items = view.individualWageTypesExportValueTypes.filter(a => a.value == 4); // only allow "Wert aus Monatsanschluss"
              break;
            default: break;
          }
          return {
              componentType: "dropdownsearch",
              state: {
                items: items,
                selectedItem: currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id)
                  ? items.find(a => a.value == currentSetting.selectedWageTypes.find(wt => wt.id === data.id).selectedValue.value)
                  : items[0],
                disabledInput: !currentSetting.selectedWageTypes.find(wt => wt.id === data.id) || currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  currentSetting.selectedWageTypes.find(wt => wt.id === data.id).selectedValue = item;
                  view.settingsUpdated = true;
                  // console.log(currentSetting.selectedWageTypes);
                },
                styleLight: true,
                style: "",
              },
            };
        },
      ];
      state.headerMap.printPaidValue.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) && currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printPaidValue ? view.$t('export.builder.fillPaidValue') : view.$t('export.builder.doNotFillPaidValue'),
            disabled: !(currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id)),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `${currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) && currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printPaidValue ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                console.log(currentSetting.selectedWageTypes.find(wt => wt.id === data.id));
                currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printPaidValue = !currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printPaidValue;
                view.settingsUpdated = true;
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.printHours.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) && currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printHours ? view.$t('export.builder.fillWorkHours') : view.$t('export.builder.doNotFillWorkHours'),
            disabled: !(currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id)),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `${currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) && currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printHours ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                console.log(currentSetting.selectedWageTypes.find(wt => wt.id === data.id));
                currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printHours = !currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printHours;
                view.settingsUpdated = true;
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.printDays.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) && currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printDays ? view.$t('export.builder.fillDays') : view.$t('export.builder.doNotFillDays'),
            disabled: !(currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id)),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `${currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) && currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printDays ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                console.log(currentSetting.selectedWageTypes.find(wt => wt.id === data.id));
                currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printDays = !currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printDays;
                view.settingsUpdated = true;
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.printDaysCalculated.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) && currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printDaysCalculated ? view.$t('export.builder.fillDaysCalculated') : view.$t('export.builder.doNotFillDaysCalculated'),
            disabled: !(currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id)),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `${currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) && currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printDaysCalculated ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                console.log(currentSetting.selectedWageTypes.find(wt => wt.id === data.id));
                currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printDaysCalculated = !currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printDaysCalculated;
                view.settingsUpdated = true;
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.printFactor.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) && currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printFactor ? view.$t('export.builder.fillWageRate') : view.$t('export.builder.doNotFillWageRate'),
            disabled: !(currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id)),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `${currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) && currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printFactor ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                console.log(currentSetting.selectedWageTypes.find(wt => wt.id === data.id));
                currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printFactor = !currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printFactor;
                view.settingsUpdated = true;
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.printPayment.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) && currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printPayment ? view.$t('export.builder.fillAmounts') : view.$t('export.builder.doNotFillAmounts'),
            disabled: !(currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id)),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `${currentSetting && currentSetting.selectedWageTypes.find(wt => wt.id === data.id) && currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printPayment ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                console.log(currentSetting.selectedWageTypes.find(wt => wt.id === data.id));
                currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printPayment = !currentSetting.selectedWageTypes.find(wt => wt.id === data.id).printPayment;
                view.settingsUpdated = true;
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.compact = true;
      return state;
    },
    sSettingsMonthlyAdditionalState() {
      let view = this;

      let currentSetting = view.sExportSettings.find(s => s.id === view.selectedSettingsId);

      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          header: view.$t('export.builder.listEntries'),
          columns: this.$t('employee.data.additionalSettings'),
        },
          Object.values(this.availableFieldsAdditional)
      );

      state.headerMap.header.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: view.$t(`export.builder.${data.key}`),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `${currentSetting && currentSetting.availableFieldsAdditional.find(f => f.key === data.key)
              && currentSetting.availableFieldsAdditional.find(f => f.key === data.key).checked ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                let currentField = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                if (currentField && currentField.checked) {
                  currentField.checked = false;
                } else if (currentField) {
                  currentField.checked = true;
                } else {
                  let newData = JSON.parse(JSON.stringify(data));
                  newData.checked = true;
                  currentSetting.availableFieldsAdditional.push(newData);
                }
                view.settingsUpdated = true;
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {

          if (data.key === "monthAdditional") {
            let monthAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.monthItems,
                selectedItem: monthAdditional ?
                    view.monthItems.find(item => item.key === monthAdditional.item.key) :
                    view.monthItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!monthAdditional) {
                    currentSetting.availableFieldsAdditional.push(JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == "monthAdditional"))));
                  }
                  monthAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  monthAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "rollUpMonthAdditional") {
            let rollUpMonthAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.monthItems,
                selectedItem: rollUpMonthAdditional ?
                    view.monthItems.find(item => item.key === rollUpMonthAdditional.item.key) :
                    view.monthItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!rollUpMonthAdditional) {
                    currentSetting.availableFieldsAdditional.push(JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == "rollUpMonthAdditional"))));
                  }
                  rollUpMonthAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  rollUpMonthAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "paidWorkTimeAdditional") {
            let paidWorkTimeAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.paidWorkTimeAdditionalItems,
                selectedItem: paidWorkTimeAdditional ?
                    view.paidWorkTimeAdditionalItems.find(item => item.key === paidWorkTimeAdditional.item.key) :
                    view.paidWorkTimeAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!paidWorkTimeAdditional) {
                    currentSetting.availableFieldsAdditional.push(JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == "paidWorkTimeAdditional"))));
                  }
                  paidWorkTimeAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  paidWorkTimeAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "headerAdditional") {
            let headerAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.headerAdditionalItems,
                selectedItem: headerAdditional ?
                    view.headerAdditionalItems.find(item => item.key === headerAdditional.item.key) :
                    view.headerAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!headerAdditional) {
                    currentSetting.availableFieldsAdditional.push(JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == "headerAdditional"))));
                  }
                  headerAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  headerAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else {
            return {};
          }
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.compact = true;
      return state;
    },
    sSettingsDailyAdditionalState() {
      let view = this;

      let currentSetting = view.sExportSettings.find(s => s.id === view.selectedSettingsId);
      console.log(currentSetting);

      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          header: view.$t('export.builder.listEntries'),
          columns: this.$t('employee.data.additionalSettings'),
        },
        Object.values(this.availableFieldsAdditional)
      );

      state.headerMap.header.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: view.$t(`export.builder.${data.key}`),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `${currentSetting && currentSetting.availableFieldsAdditional.find(f => f.key === data.key)
              && currentSetting.availableFieldsAdditional.find(f => f.key === data.key).checked ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                let currentField = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                if (currentField && currentField.checked) {
                  currentField.checked = false;
                } else if (currentField) {
                  currentField.checked = true;
                } else {
                  let newData = JSON.parse(JSON.stringify(data));
                  newData.checked = true;
                  currentSetting.availableFieldsAdditional.push(newData);
                }
                view.settingsUpdated = true;
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {

          if (data.key === "dailyProcessingFlagAdditional") {
            let dailyProcessingFlagAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.exportDateItems,
                selectedItem: dailyProcessingFlagAdditional ?
                    view.exportDateItems.find(item => item.key === dailyProcessingFlagAdditional.item.key) :
                    view.exportDateItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!dailyProcessingFlagAdditional) {
                    currentSetting.availableFieldsAdditional.push(JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == "dailyProcessingFlagAdditional"))));
                  }
                  dailyProcessingFlagAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  dailyProcessingFlagAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "headerAdditional") {
            let headerAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.headerAdditionalItems,
                selectedItem: headerAdditional ?
                    view.headerAdditionalItems.find(item => item.key === headerAdditional.item.key) :
                    view.headerAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!headerAdditional) {
                    currentSetting.availableFieldsAdditional.push(JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == "headerAdditional"))));
                  }
                  headerAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  headerAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: ""
              },
            };
          } else if (data.key === "dailyPayoutValueAdditional") {
            let dailyPayoutValueAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.dailyPayoutValueAdditionalItems,
                selectedItem: dailyPayoutValueAdditional ?
                    view.dailyPayoutValueAdditionalItems.find(item => item.key === dailyPayoutValueAdditional.item.key) :
                    view.dailyPayoutValueAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!dailyPayoutValueAdditional) {
                    currentSetting.availableFieldsAdditional.push(JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == "dailyPayoutValueAdditional"))));
                  }
                  dailyPayoutValueAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  dailyPayoutValueAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: ""
              },
            };
          } else if (data.key === "dailyPayoutHoursValueAdditional") {
            let dailyPayoutHoursValueAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.dailyPayoutHoursValueAdditionalItems,
                selectedItem: dailyPayoutHoursValueAdditional ?
                    view.dailyPayoutHoursValueAdditionalItems.find(item => item.key === dailyPayoutHoursValueAdditional.item.key) :
                    view.dailyPayoutHoursValueAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!dailyPayoutHoursValueAdditional) {
                    currentSetting.availableFieldsAdditional.push( JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == "dailyPayoutHoursValueAdditional"))));
                  }
                  dailyPayoutHoursValueAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  dailyPayoutHoursValueAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: ""
              },
            };
          } else {
            return {};
          }
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.compact = true;
      return state;
    },
    sSettingsPersonnelProvisionsAdditionalState() {
      let view = this;

      let currentSetting = view.sExportSettings.find(s => s.id === view.selectedSettingsId);
      // console.log(currentSetting);

      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(
        {
          header: view.$t('export.builder.listEntries'),
          columns: this.$t('employee.data.additionalSettings'),
        },
        Object.values(this.availableFieldsAdditional)
      );

      state.headerMap.header.componentStateBuilders = [
        (data, entry) => {
          return {
            componentType: "buttonc",
            label: view.$t(`export.builder.${data.key}`),
            type: "occupy-container",
            tooltip: view.$t('export.builder.selectDeselect'),
            class: `${currentSetting && currentSetting.availableFieldsAdditional.find(f => f.key === data.key)
              && currentSetting.availableFieldsAdditional.find(f => f.key === data.key).checked ? (currentSetting.locked ? "selected locked" : "selected") : ""}`,
            customEvents: {
              click: () => {
                if (currentSetting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                let currentField = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                if (currentField && currentField.checked) {
                  currentField.checked = false;
                } else if (currentField) {
                  currentField.checked = true;
                } else {
                  let newData = JSON.parse(JSON.stringify(data));
                  newData.checked = true;
                  currentSetting.availableFieldsAdditional.push(newData);
                }
                view.settingsUpdated = true;
              },
            },
            style: "height: calc(100% - 5px) !important; width: calc(100% - 8px) !important;",
            styleLabel: { "text-align": "left", width: "100%" },
          };
        },
      ];
      state.headerMap.columns.componentStateBuilders = [
        (data, entry) => {

          // console.log(currentSetting.availableFieldsAdditional);
          if (data.key === "ppHeaderAdditional") {
            let headerAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.headerAdditionalItems,
                selectedItem: headerAdditional ?
                    view.headerAdditionalItems.find(item => item.key === headerAdditional.item.key) :
                    view.headerAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!headerAdditional) {
                    currentSetting.availableFieldsAdditional.push(JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == data.key))));
                  }
                  headerAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  headerAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: ""
              },
            };
          } else if (data.key === "ppBalanceAdditional") {
            let balanceAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.paidWorkTimeAdditionalItems,
                selectedItem: balanceAdditional
                  ? view.paidWorkTimeAdditionalItems.find(item => item.key === balanceAdditional.item.key)
                  : view.paidWorkTimeAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!balanceAdditional) {
                    currentSetting.availableFieldsAdditional.push(JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == data.key))));
                  }
                  balanceAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  balanceAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: "",
              },
            };
          } else if (data.key === "ppValuesAdditional") {
            let valuesAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.ppValuesAdditionalItems,
                selectedItem: valuesAdditional ?
                    view.ppValuesAdditionalItems.find(item => item.key === valuesAdditional.item.key) :
                    view.ppValuesAdditionalItems[0],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!valuesAdditional) {
                    currentSetting.availableFieldsAdditional.push(JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == data.key))));
                  }
                  valuesAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  valuesAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: ""
              },
            };
          } else if (data.key === "ppAllowNegativesAdditional") {
            let allowNegativesAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            let currentPpAllowNegativesAdditionalItems = view.ppAllowNegativesAdditionalItems.map(a => {
              return {
                value: a.value,
                label: a.label,
                selected: currentSetting.availableFieldsAdditional.find(b => b.key == data.key)
                  ? currentSetting.availableFieldsAdditional.find(b => b.key == data.key).item.includes(a.value)
                  : false
              };
            });
            return {
              componentType: "dropdownsearch",
              state: {
                items: currentPpAllowNegativesAdditionalItems,
                selectMultiple: true,
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!allowNegativesAdditional) {
                    currentSetting.availableFieldsAdditional.push(JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == data.key))));
                  }
                  allowNegativesAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  allowNegativesAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: ""
              },
            };
          } else if (data.key === "ppIncludePaidAdditional") {
            let includePaidAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.ppIncludePaidAdditionalItems,
                selectedItem: includePaidAdditional ?
                    view.ppIncludePaidAdditionalItems.find(item => item.key === includePaidAdditional.item.key) :
                    view.ppIncludePaidAdditionalItems[1],
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!includePaidAdditional) {
                    currentSetting.availableFieldsAdditional.push(JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(a => a.key == data.key))));
                  }
                  includePaidAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  includePaidAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: ""
              },
            };
          } else if (data.key.startsWith("balance")) {
            let balanceXAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
            return {
              componentType: "dropdownsearch",
              state: {
                items: view.balanceAdditionItems,
                selectedItem: balanceXAdditional ?
                    view.balanceAdditionItems.find(b => b.key === balanceXAdditional.item.key) :
                    view.balanceAdditionItems.find(b => b.key === view.availableFieldsAdditional.find(a => a.key == data.key).item.key),
                disabledInput: currentSetting.locked,
                disabledInputShowSelected: currentSetting.locked,
                onceSelected: function ($event, item) {
                  if (!balanceXAdditional) {
                    currentSetting.availableFieldsAdditional.push( JSON.parse(JSON.stringify(view.availableFieldsAdditional.find(f => f.key === data.key))));
                  }
                  balanceXAdditional = currentSetting.availableFieldsAdditional.find(f => f.key === data.key);
                  balanceXAdditional.item = item;
                  view.settingsUpdated = true;
                },
                styleLight: true,
                style: ""
              },
            };
          } else {
            return {};
          }
        },
      ];
      Object.values(state.headerMap).forEach((h) => (h.stylesHeader = { "justify-content": "start" }));
      state.compact = true;
      return state;
    },
    // export jobs overview
    // exportJobsFiltered() {
    //   return this.exportJobs.filter(j => j.type === (this.$parent.mode === "monthly" ? 0 : 1));
    // },
    // ---
    previewState() {
      let view = this;
      let nameMap = {};
      let additionalMap = {};
      let selectedStores = view.selectedStores;

      this.availableFields.filter((a) => {
        // console.log(a);
        if (a.checked) {
          if (view.$parent.mode === "personnelProvisions") {
            nameMap[a.key] = a.item ? a.item.label : a.newName;
          } else {
            nameMap[a.key] = a.newName;
          }
        }
      });

      // console.log("nameMap", nameMap);

      let donCompanies = [195, 196, 197, 218, 219, 220];
      if (donCompanies.includes(parseInt(view.$store.state.companyId)) && view.$parent.mode === "monthly") {
        console.log("DONHAUSER GROUP");
        nameMap = {};
        nameMap["month"] = this.$t('export.builder.billingMonth');
        nameMap["externalCompanyId"] = this.$t('export.builder.company');
        nameMap["externalEmployeeId"] = this.$t('export.builder.employeeNumber');
        nameMap["placeholder1"] = this.$t('export.builder.dvNumber');
        nameMap["lohnart"] = this.$t('export.builder.wageTypeShort');
        nameMap["paidWorkTime"] = this.$t('employee.comp.quantity');
        nameMap["placeholder2"] = this.$t('export.builder.rateShort');
        nameMap["placeholder3"] = this.$t('employee.comp.amount');
        nameMap["placeholder4"] = "-";
        nameMap["placeholder5"] = "-";
        nameMap["rollUpMonth"] = this.$t('export.builder.rollUpMonth');
      }

      let state = this.$helpers.GetDataTableStateFromKeyLabelObject(nameMap, view.exportTable);


      // donhauser placeholder begin
      Object.entries(state.headerMap).forEach(([key, value]) => {
        if (key.startsWith("placeholder")) {
          state.headerMap[key].componentStateBuilders = [
            (data, entry) => {
              return {
                componentType: "labelc",
                text: data[key] ?? "",
                type: "occupy-container",
                style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                  state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
                };`,
                styleText: { color: "black" },
              };
            },
          ];
        }
      });
      // donhauser placeholder end
      if (nameMap["externalCompanyId"])
        state.headerMap.externalCompanyId.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.externalCompanyId,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      if (nameMap["externalEmployeeId"])
        state.headerMap.externalEmployeeId.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.externalEmployeeId,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["employeeName"])
        state.headerMap.employeeName.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.employeeName,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["contentName"])
        state.headerMap.contentName.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.contentName,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["lohnart"])
        state.headerMap.lohnart.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.lohnart,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["paidWorkTime"])
        state.headerMap.paidWorkTime.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.paidWorkTime,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["costCenter"])
        state.headerMap.costCenter.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.costCenter,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["storeCostCenter"])
        state.headerMap.storeCostCenter.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.storeCostCenter,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["taxId"])
        state.headerMap.taxId.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.taxId,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["factor"])
        state.headerMap.factor.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.factor,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["hours"])
        state.headerMap.hours.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.hours,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["payment"])
        state.headerMap.payment.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.payment,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["year"])
        state.headerMap.year.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.year,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["day"])
        state.headerMap.day.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.day,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["unavailabilityCode"])
        state.headerMap.unavailabilityCode.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.unavailabilityCode,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["days"])
        state.headerMap.days.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.days,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["daysCalculated"])
        state.headerMap.daysCalculated.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.daysCalculated,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["processingKey"])
        state.headerMap.processingKey.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.processingKey,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["dailyExternalCompanyId"])
        state.headerMap.dailyExternalCompanyId.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.dailyExternalCompanyId,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      if (nameMap["dailyExternalEmployeeId"])
        state.headerMap.dailyExternalEmployeeId.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.dailyExternalEmployeeId,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      if (nameMap["dailyEmployeeName"])
        state.headerMap.dailyEmployeeName.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.dailyEmployeeName,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      if (nameMap["dailyLohnart"])
        state.headerMap.dailyLohnart.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.dailyLohnart,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      if (nameMap["dailyFrom"])
        state.headerMap.dailyFrom.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.dailyFrom,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      if (nameMap["dailyTo"])
        state.headerMap.dailyTo.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.dailyTo,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      if (nameMap["dailyPayoutValue"])
        state.headerMap.dailyPayoutValue.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.dailyPayoutValue,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      if (nameMap["dailyPayoutHoursValue"])
        state.headerMap.dailyPayoutHoursValue.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.dailyPayoutHoursValue,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      if (nameMap["dailyProcessingFlag"])
        state.headerMap.dailyProcessingFlag.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.dailyProcessingFlag,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      if (nameMap["dailyContentName"])
        state.headerMap.dailyContentName.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.dailyContentName,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      if (nameMap["month"]) {
        state.headerMap.month.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.month,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: {color: "black"},
            };
          },
        ];
      }
      if (nameMap["rollUpMonth"]) {
        state.headerMap.rollUpMonth.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.rollUpMonth,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: {color: "black"},
            };
          },
        ];
      }
      if (nameMap["date"]) {
        state.headerMap.date.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.date,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: {color: "black"},
            };
          },
        ];
      }

      if (nameMap["date2"])
        state.headerMap.date2.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.date2,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];

      if (nameMap["ppExternalCompanyId"]) {
        state.headerMap.ppExternalCompanyId.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.ppExternalCompanyId,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      }
      if (nameMap["ppExternalEmployeeId"]) {
        state.headerMap.ppExternalEmployeeId.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.ppExternalEmployeeId,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      }
      if (nameMap["ppEmployeeName"]) {
        state.headerMap.ppEmployeeName.componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data.ppEmployeeName,
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      }
      Object.keys(nameMap).filter((e) => e.startsWith("balance")).forEach(balance => {
        state.headerMap[balance].componentStateBuilders = [
          (data, entry) => {
            return {
              componentType: "labelc",
              text: data[balance],
              type: "occupy-container",
              style: `pointer-events:none; background: ${state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"}; box-shadow: 0 0 0 1px ${
                state.data.indexOf(data) % 2 === 0 ? "var(--contrast-2)" : "var(--contrast-3)"
              };`,
              styleText: { color: "black" },
            };
          },
        ];
      });



      state.compact = true;
      Object.values(state.headerMap).forEach(
        (h) =>
          (h.stylesHeader = (map) => {
            return {
              background: "var(--contrast-3)",
              height: "60px",
              marginTop: "-30px",
              "box-shadow":
                Object.values(state.headerMap).indexOf(map) === 0
                  ? "inset -10px -15px 0 -5px var(--bg),inset -10px 15px 0 -5px var(--bg)"
                  : Object.values(state.headerMap).indexOf(map) === Object.values(state.headerMap).length - 1
                  ? "inset 0px -15px 0 -5px var(--bg),inset 10px 15px 0 -5px var(--bg)"
                  : "inset 0px 0  0 5px var(--bg), inset 0px 5px  0 5px var(--bg), inset 0 -5px  0 5px var(--bg)",
            };
          })
      );
      state.rowStyles = (data, row, index) => {
        return {
          background: index % 2 === 0 ? "var(--contrast-3)" : "var(--contrast-2)",
        };
      };
      return state;
    },
    settingsEmployeesState() {
      let view = this;

      //let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);
      let nameFilter = this.employeeNameFilter;
      //let data = Object.values(wbMap).filter(wb => visibleSpots.includes(view.employeeMap[wb.employeeId].spotId)).map((e) => { return Object.assign({}, e)});
      let data = [];
      this.statementResponses.forEach(
        (s) =>
          (data = data.concat(
            s.filter((d) => {
              let employee = view.employeeMap[d.remoteId];
              return employee && (employee.firstName.indexOf(nameFilter) > -1 || employee.lastName.indexOf(nameFilter) > -1);
            })
          ))
      );

      data.sort(function (a, b) {
        let ea = view.employeeMap[a.remoteId];
        let eb = view.employeeMap[b.remoteId];
        if (view.sortByName) {
          if (ea != undefined && eb != undefined) {
            if (ea.lastName < eb.lastName) return -1;
            if (ea.lastName > eb.lastName) return 1;
            if (ea.lastName == eb.lastName && ea.firstName < eb.firstName) return -1;
            if (ea.lastName == eb.lastName && ea.firstName > eb.firstName) return 1;
          }
        } else {
          if (ea != undefined && eb != undefined) {
            let eaNum = ea.personnelId;
            let ebNum = eb.personnelId;
            if (eaNum != undefined && eaNum != null && ebNum != undefined && (eaNum != ebNum) != null) {
              eaNum = parseInt(eaNum);
              ebNum = parseInt(ebNum);
              if (eaNum < ebNum) return -1;
              if (eaNum > ebNum) return 1;
            } else if (eaNum == null || eaNum == undefined) {
              return 1;
            } else {
              return -1;
            }
          }
        }

        return 0;
      });

      data.forEach((d) => {
        d.subEntries = [
          {
            componentOverride: "monthlyclosingsummary",
            componentStateBuilders: [
              (data) => {
                return {
                  employeeData: d,
                  //enableWorkBalanceMultiplier: view.storeSettings.enableWorkBalanceMultiplier,
                  //prevMonthWorkBalance: view.previousMonthWorkBalanceMap[d.employeeId],
                  optionalColumn: false,
                  componentType: "monthlyclosingsummary",
                  customEvents: {
                    Update: () => {},
                  },
                };
              },
            ],
          },
        ];
      });
      //data.push(view.positiveBalanceSummaryData);

      let state = {};

      if (!this.sortByName) {
        state = this.$helpers.GetDataTableStateFromKeyLabelObject(
          {
            //personnelId: "PN",
            store: "Store",
            name: view.$t('global.ui.employee'),
            workTimeBalance: this.$t('export.builder.workTimeBalance'),
            vacationTimeBalance: this.$t('export.builder.vacationBalance'),
            holidayTimeBalance: this.$t('export.builder.holidayBalance'),
            nightWorkTimeBalance: this.$t('export.builder.nightWorkBalance'),
            overTimeBalance: this.$t('export.builder.overtimeBalance2'),
            actions: " ",
          },
          data
        );

        /*state.headerMap.personnelId.componentStateBuilders = [(data, entry) => {
                    let e = view.employeeMap[data.employeeId];
                    return {
                        componentType: 'labelc',
                        state:{ text: e && e.personnelId ? e.personnelId : '', },
                        styleLabel: {display: 'flex', alignItems: 'center', justifyContent: 'center',background: '', height: 'calc(100% - 10px)'},
                    }
                }];*/
      } else {
        state = this.$helpers.GetDataTableStateFromKeyLabelObject(
          {
            store: "Store",
            name: view.$t('global.ui.employee'),
            workTimeBalance: this.$t('export.builder.workTimeBalance'),
            vacationTimeBalance: this.$t('export.builder.vacationBalance'),
            holidayTimeBalance: this.$t('export.builder.holidayBalance'),
            nightWorkTimeBalance: this.$t('export.builder.nightWorkBalance'),
            overTimeBalance: this.$t('export.builder.overtimeBalance2'),
            actions: " ",
          },
          data
        );
      }

      state.headerMap.store.stylesEntrySum = { color: "black" };
      state.headerMap.store.componentStateBuilders = [
        (data, entry) => {
          /*let storeId = view.employeeMap[data.remoteId]
            ? view.employeeMap[data.remoteId].storeId
            : 0;*/

          let storeName = view.storesMap[data.storeId] ? view.storesMap[data.storeId].name : "";

          return {
            componentType: "labelc",
            state: {
              text: storeName,
            },
            styleLabel: {
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "",
              height: "calc(100% - 10px)",
            },
          };
        },
      ];

      state.headerMap.name.stylesEntrySum = { color: "black" };
      state.headerMap.name.componentStateBuilders = [
        (data, entry) => {
          let employee = view.employeeMap[data.remoteId] ? view.employeeMap[data.remoteId] : { firstName: view.$t('employee.import.unknown'), lastName: view.$t('employee.import.unknown') };

          return {
            componentType: "employeeentry",
            state: {
              firstName: employee.firstName,
              lastName: employee.lastName,
              employee: employee,
              splitName: true,
              hideShadow: true,
              textStyle: { color: "white", fontSize: "12px", margin: "2.5px" },
            },
          };
        },
      ];

      state.headerMap.workTimeBalance.stylesEntrySum = { color: "black" };
      state.headerMap.workTimeBalance.componentStateBuilders = [
        (data, entry) => {
          if (data.confirmed || !view.canEditBalances) {
            return {
              componentType: "labelc",
              state: {
                text: (data.workTimeBalance / 60.0).toFixed(2),
              },
              styleLabel: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "",
                height: "calc(100% - 10px)",
              },
            };
          } else {
            return {
              componentType: "inputc",
              inputProp: (data.workTimeBalance / 60).toFixed(2),
              customEvents: {
                Update: (input, inputPrev) => {
                  view.dataUpdatedByUser(input, data, "workTimeBalance", 60);
                },
              },
              DisplayLabel: (value) => {
                let val = parseFloat(value);
                return val != null ? val.toFixed(2) : 0.0;
              },
              style: {
                background: "white",
                height: "calc(100% - 10px)",
                width: "calc(100% - 10px)",
                margin: "auto",
                right: "0",
                left: "0",
              },
            };
          }
        },
      ];

      state.headerMap.vacationTimeBalance.stylesEntrySum = { color: "black" };
      state.headerMap.vacationTimeBalance.componentStateBuilders = [
        (data, entry) => {
          if (data.confirmed || !view.canEditBalances) {
            return {
              componentType: "labelc",
              state: {
                text: (data.vacationTimeBalance / 60 / 24).toFixed(2),
              },
              styleLabel: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "",
                height: "calc(100% - 10px)",
              },
            };
          } else {
            return {
              componentType: "inputc",
              inputProp: (data.vacationTimeBalance / 60 / 24).toFixed(2),
              customEvents: {
                Update: (input, inputPrev) => {
                  view.dataUpdatedByUser(input, data, "vacationTimeBalance", 60 * 24);
                },
              },
              DisplayLabel: (value) => {
                let val = parseFloat(value);
                return val != null ? val.toFixed(2) : 0.0;
              },
              style: {
                background: "white",
                height: "calc(100% - 10px)",
                width: "calc(100% - 10px)",
                margin: "auto",
                right: "0",
                left: "0",
              },
            };
          }
        },
      ];

      state.headerMap.holidayTimeBalance.stylesEntrySum = { color: "black" };
      state.headerMap.holidayTimeBalance.componentStateBuilders = [
        (data, entry) => {
          if (data.confirmed || !view.canEditBalances) {
            return {
              componentType: "labelc",
              state: {
                text: (data.holidayTimeBalance / 60.0).toFixed(2),
              },
              styleLabel: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "",
                height: "calc(100% - 10px)",
              },
            };
          } else {
            return {
              componentType: "inputc",
              inputProp: (data.holidayTimeBalance / 60.0).toFixed(2),
              customEvents: {
                Update: (input, inputPrev) => {
                  view.dataUpdatedByUser(input, data, "holidayTimeBalance", 60);
                },
              },
              DisplayLabel: (value) => {
                let val = parseFloat(value);
                return val != null ? val.toFixed(2) : 0.0;
              },
              style: {
                background: "white",
                height: "calc(100% - 10px)",
                width: "calc(100% - 10px)",
                margin: "auto",
                right: "0",
                left: "0",
              },
            };
          }
        },
      ];

      state.headerMap.nightWorkTimeBalance.stylesEntrySum = { color: "black" };
      state.headerMap.nightWorkTimeBalance.componentStateBuilders = [
        (data, entry) => {
          if (data.confirmed || !view.canEditBalances) {
            return {
              componentType: "labelc",
              state: {
                text: (data.nightWorkTimeBalance / 60.0).toFixed(2),
              },
              styleLabel: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "",
                height: "calc(100% - 10px)",
              },
            };
          } else {
            return {
              componentType: "inputc",
              inputProp: (data.nightWorkTimeBalance / 60.0).toFixed(2),
              customEvents: {
                Update: (input, inputPrev) => {
                  view.dataUpdatedByUser(input, data, "nightWorkTimeBalance", 60);
                },
              },
              DisplayLabel: (value) => {
                let val = parseFloat(value);
                return val != null ? val.toFixed(2) : 0.0;
              },
              style: {
                background: "white",
                height: "calc(100% - 10px)",
                width: "calc(100% - 10px)",
                margin: "auto",
                right: "0",
                left: "0",
              },
            };
          }
        },
      ];

      state.headerMap.overTimeBalance.stylesEntrySum = { color: "black" };
      state.headerMap.overTimeBalance.componentStateBuilders = [
        (data, entry) => {
          if (data.confirmed || !view.canEditBalances || data.employeeId == "positiveSum") {
            return {
              componentType: "labelc",
              state: {
                text: (data.overTimeBalance / 60.0).toFixed(2),
              },
              styleLabel: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "",
                height: "calc(100% - 10px)",
              },
            };
          } else {
            return {
              componentType: "inputc",
              inputProp: (data.overTimeBalance / 60.0).toFixed(2),
              customEvents: {
                Update: (input, inputPrev) => {
                  view.dataUpdatedByUser(input, data, "overTimeBalance", 60);
                },
              },
              DisplayLabel: (value) => {
                let val = parseFloat(value);
                return val != null ? val.toFixed(2) : 0.0;
              },
              style: {
                background: "white",
                height: "calc(100% - 10px)",
                width: "calc(100% - 10px)",
                margin: "auto",
                right: "0",
                left: "0",
              },
            };
          }
        },
      ];

      let entries = Object.entries(state.headerMap);

      let mainColumns = ["workTimeBalance", "vacationTimeBalance", "holidayTimeBalance", "nightWorkTimeBalance", "overTimeBalance"];
      let mainColumnWidth = 15;
      let nameColumns = ["name"];
      let nameColumnWidth = this.sortByName ? 15 : 10;
      let persColumns = ["personnelId"];
      let persColumnWidth = 5;
      let actionColumns = ["actions"];
      let actionColumnWidth = 10;
      for (let x in entries) {
        if (mainColumns.includes(entries[x][0])) {
          entries[x][1].width = mainColumnWidth + "%";
        } else if (nameColumns.includes(entries[x][0])) {
          entries[x][1].width = nameColumnWidth + "%";
        } else if (persColumns.includes(entries[x][0])) {
          entries[x][1].width = persColumnWidth + "%";
        } else if (actionColumns.includes(entries[x][0])) {
          entries[x][1].width = actionColumnWidth + "%";
        }
        //entries[x][1].width = ((100 / (entries.length + 1)) * (x === (''+(entries.length-1)) ? 0.5 : 1)) + '%';
        //console.log(entries[x][1].width)
        entries[x][1].key = entries[x][0];
      }
      state.headerStyles = {
        top: 0,
        zIndex: 10,
        background: "var(--sub-menu)",
      };
      state.heightSubRow = "fit-content";
      state.rowStyles = { background: "var(--ml)" };
      state.rowStylesCollapsed = { background: "var(--contrast-1)" };
      state.sumRowStyles = { background: "var(--sub-menu)" };
      //state.dataSum = [this.positiveBalanceSummary, this.negativeBalanceSummary, this.balanceSummary];
      return state;
    },
    burgerMenuState(){
      let view = this;
      let state = {
        componentref: 'burgermenustate',
        groups: [],
        items: []
      };
      let group1 = {
        label:  view.$t('settings.help.additionalDownloads') ,
        items: [

          {
            closeOnClick: true,
            icon: "fa-file-download",
            show: view.softwareId === 0 && ['monthly'].includes(view.$parent.mode),
            text: view.$t('export.builder.downloadBmdMonthTotalsInterface'),
            click: () => { view.downloadMFSBmdInterface(); },
          },
          {
            closeOnClick: true,
            icon: "fa-file-download",
            show: view.softwareId === 0 && ['monthly'].includes(view.$parent.mode),
            text: view.$t('export.builder.downloadBmdMonthTotalsMacroBundle'),
            click: () => { view.openMfsImportStapelPopup(); },
          },
          {
            closeOnClick: true,
            icon: "fa-file-download",
            show: view.softwareId === 0 && view.$parent.mode === 'daily',
            text: view.$t('export.builder.downloadBmdAbsenceInterface'),
            click: () => { view.downloadNLZBmdInterface(); },
          },
          {
            closeOnClick: true,
            icon: "fa-file-download",
            show: view.softwareId === 0 && view.$parent.mode === 'daily',
            text: view.$t('export.builder.downloadBmdAbsenceMacroBundle'),
            click: () => { view.openNlzImportStapelPopup(); },
          },
          {
            closeOnClick: true,
            icon: "fa-file-pdf",
            text: view.$t('export.builder.generateWorkTimeAccount'),
            show:  view.subPage === 'export',
            disabled: view.loadingMFS,
            click: () => { view.generateWorkTimeOverviewPdfReport() }
          },
        ]
      }

      state.groups.push(group1);

      return state;
    },
  },
  methods: {
    DragStart(panelDragged) {
      let view = this;
      this.panelDragged = panelDragged;
      this.isDragging = true;
      requestAnimationFrame(() => {
        view.DragWatch();
      });
    },
    DragWatch() {
      let view = this;
      let panel = window.mouse.element.closest(".panel");
      if (panel && panel.id !== this.panelDragged) {
        let order = this.orderStates[this.panelDragged];
        let orderHovered = this.orderStates[panel.id];
        if (order < orderHovered) {
          for (let state in this.orderStates) {
            let orderTemp = this.orderStates[state];
            if (orderTemp > orderHovered) {
              this.orderStates[state] = this.orderStates[state] + 1;
            }
          }
          this.orderStates[this.panelDragged] = orderHovered + 1;
        } else {
          for (let state in this.orderStates) {
            let orderTemp = this.orderStates[state];
            if (orderTemp >= orderHovered) {
              this.orderStates[state] = this.orderStates[state] + 1;
            }
          }
          this.orderStates[this.panelDragged] = orderHovered;
        }
      }
      if (window.mouse.click) {
        requestAnimationFrame(() => {
          view.DragWatch();
        });
      } else {
        view.DragEnd();
      }
    },
    DragEnd() {
      let localOrder = localStorage.setItem("localOrderExportBuilderPanels", JSON.stringify(this.orderStates));
      this.isDragging = false;
      this.panelDragged = "";
    },
    refresh: function (force = false, keepSubPage = true) {
      let view = this;
      view.sessionId = crypto.randomUUID();
      view.somethingHasChangedWhatAffectsExportTable = true;
      view.loading = true;
      view.loadingMFS = true;
      view.settingsUpdated = false;
      view.subPage = keepSubPage ? view.subPage : 'export';
      view.sExportSettings = [];
      view.baseSettings = JSON.parse(JSON.stringify(view.baseSettingsTemplate));


      let promises = [];
      promises.push(view.loadExportJobs());
      promises.push(view.loadWageTypes().then((response) => {
          // view.loadWageTypesMapping();
        })
      );
      promises.push(view.loadExportSettings(view.$parent.mode));
      promises.push(view.$helpers
        .GetCall("/api/sec/proxy/md/storeSettings", {})
        .then((response) => {
          for (let i in response.data) {
            let setting = response.data[i];
            view.storeSettingWeekdaysMap[setting.id] = setting.workDays;
          }
        })
        .catch((e) => {
          console.log(e);
        })
      );
      promises.push(
        view.$helpers
            .GetCompanySettings(force)
            .then((response) => {
              if (response.data[0].bmdId != null) {
                view.bmdId = response.data[0].bmdId;
              }
              if (response.data[0].softwareId !== null) {
                view.softwareId = response.data[0].softwareId;
              }
            })
            .catch((error) => {
              console.log(error);
            })
      );
      promises.push(view.loadEmployees(force));
      promises.push(view.loadStoresForCompany());

      Promise.all(promises)
      .then((responses) => {
        if (view.baseSettings.openSettingsPageDefault && !keepSubPage) {
          view.subPage = 'settings';
        }
        view.$forceUpdate();
        this.loading = false;
        view.loadAllMonthlyStatements(); // load these for Arbeitszeitkonto
      });
    },
    // additional downloads
    downloadMFSBmdInterface() {
      let view = this;

      let resourceName = "ml_abrechnungsdaten_import.zip";
      view.loadResourceFile("bmd", resourceName)
      .then((resp) => {
        let content = view.$helpers.convertToUInt8(atob(resp.data.content));
        view.$helpers.forceFileDownload(content, this.$t('export.builder.mlBillingDataImport') + ".zip"); //resp.data.name, true);
      });
    },
    downloadNLZBmdInterface() {
      let view = this;

      let resourceName = "ml_nichtleistungszeiten_import.zip";
      view.loadResourceFile("bmd", resourceName)
      .then((resp) => {
        let content = view.$helpers.convertToUInt8(atob(resp.data.content));
        view.$helpers.forceFileDownload(content, this.$t('export.builder.mlAbsenceDataImport') + ".zip"); //resp.data.name, true);
      });
    },
    openMfsImportStapelPopup() {
      var view = this;

      view.$helpers.OpenPopup({
        elRelative: null,
        remainAfterSelect: true,
        type: 'datafill',
        componentState: {
            description: this.$t('export.builder.mfsMacroInstructions'),
            entries: [],
            positiveButtonLabel: this.$t('export.builder.downloadMacro'),
            negativeButtonLabel: this.$t('export.builder.downloadBatch'),
            selectCallback: function (result, event) {
            view.downloadMfsImportMacro();
          },
          deleteCallback: function (result, event) {
            view.downloadMfsImportStapel();
          },
          errorCheck: {
          },
        },
        header: this.$t('export.builder.downloadBmdMonthTotalsMacroBundle'),
        expanded: true,
        centered: true,
      });
    },
    downloadMfsImportMacro() {
      let view = this;

      let resourceName = "BMD__FOR_FORMEL_972762356298055_abr_import.XML";
      view.loadResourceFile("bmd", resourceName)
      .then((resp) => {
        let content = view.$helpers.convertToUInt8(atob(resp.data.content));
        view.$helpers.forceFileDownload(content, resourceName, true); //resp.data.name, true);
      });
    },
    downloadMfsImportStapel() {
      let view = this;

      let resourceName = "mfs_import_stapel.zip";
      view.loadResourceFile("bmd", resourceName)
      .then((resp) => {
        let content = view.$helpers.convertToUInt8(atob(resp.data.content));
        view.$helpers.forceFileDownload(content, this.$t('export.builder.mfsImportBatch') + ".zip"); //resp.data.name, true);
      });
    },
    openNlzImportStapelPopup() {
      var view = this;

      view.$helpers.OpenPopup({
        elRelative: null,
        remainAfterSelect: true,
        type: 'datafill',
        componentState: {
          description: view.$t('export.builder.nlzBatchInstructions'),
          entries: [],
          positiveButtonLabel: view.$t('export.builder.downloadMacro'),
          negativeButtonLabel: view.$t('export.builder.downloadBatch'),
          selectCallback: function (result, event) {
            view.downloadNlzImportMacro();
          },
          deleteCallback: function (result, event) {
            view.downloadNlzImportStapel();
          },
          errorCheck: {
          },
        },
        header: view.$t('export.builder.downloadBmdAbsenceMacroBundle'),
        expanded: true,
        centered: true,
      });
    },
    downloadNlzImportMacro() {
      let view = this;

      let resourceName = "BMD__FOR_FORMEL_821162340489558_nlz_import.XML";
      view.loadResourceFile("bmd", resourceName)
      .then((resp) => {
        let content = view.$helpers.convertToUInt8(atob(resp.data.content));
        view.$helpers.forceFileDownload(content, resourceName); //resp.data.name, true);
      });
    },
    downloadNlzImportStapel() {
      let view = this;

      let resourceName = "absences_import_stapel.zip";
      view.loadResourceFile("bmd", resourceName)
      .then((resp) => {
        let content = view.$helpers.convertToUInt8(atob(resp.data.content));
        view.$helpers.forceFileDownload(content, resourceName); //resp.data.name, true);
      });
    },
    loadResourceFile(resourceType, resourceName) {
      let url = "/api/sec/resource";
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, "/api/sec/resource");
      url = this.$helpers.appendParam("resourceType", resourceType, url, "/api/sec/resource");
      url = this.$helpers.appendParam("resourceName", resourceName, url, "/api/sec/resource");
      return this.axios({
        method: "get",
        headers: {
          AUTHORIZATION: "Bearer " + this.$store.state.jwt,
        },
        url: url,
      });
    },

    doCsvDownload() {
      let view = this;

      if (view.currentFilename) {
        view.$helpers.forceFileDownload(view.currentCSV, view.currentFilename);
      } else {
        let filename = "";
        if (view.bmdId != null) {
          filename += view.bmdId + " - ";
        }
          ["monthly"].includes(view.$parent.mode)
              ? (filename += this.$t('export.builder.csvExportMonthlySums'))
              : ["individual-wagetypes"].includes(view.$parent.mode)
                  ? (filename += this.$t('export.builder.csvExportIndividualWageTypes'))
                  : this.$parent.mode == 'daily'
                      ? (filename += this.$t('export.builder.csvExportAbsences'))
                      : (filename += this.$t('export.builder.csvExportProvisions'));

        filename += " - " + view.months.find(month => month.value === (view.timeframeStart.months() + 1)).label + " " + view.timeframeStart.format("YYYY");

        view.$helpers.forceFileDownload(view.currentCSV, filename + ".csv");
      }
    },
    triggerCsvExportWithFrontendSettings() {
      let view = this;

      let baseUrl = '';
      ["monthly"].includes(view.$parent.mode) ? (baseUrl = '/api/sec/bmd/exports/MFS/dispatch/withFile')
          : ["individual-wagetypes"].includes(view.$parent.mode) ? (baseUrl = '/api/sec/iwt/exports/dispatch/withFile')
          : this.$parent.mode == 'daily' ? (baseUrl = '/api/sec/bmd/exports/AS/dispatch/withFile')
          : (baseUrl = '/api/sec/bmd/exports/PP/dispatch/withFile');

      let url = baseUrl;
      let year = view.selectedDate.format("YYYY");
      let month = view.selectedDate.format("M");

      let data = {
        companyId: this.$store.state.companyId,
        year: year,
        month: month,
        file: view.$helpers.b64EncodeUnicode(view.currentCSV),
        exportJson: view.currentJson,
        storeIds: Object.entries(view.selectedStores).filter(([key, value]) => value).map(([key, value]) => parseInt(key)),
        exportSettings: {
          name: view.$t('export.builder.tableExport'),
          id: 0,
          selectedStores: Object.entries(view.selectedStores).filter(([storeId, active]) => active).map(([storeId, active]) => parseInt(storeId)),
          availableFields: Object.values(view.availableFields),
          availableFieldsAdditional: Object.values(view.availableFieldsAdditional),
          availableFieldsIndividualWageTypesListAdditional: Object.values(view.availableFieldsIndividualWageTypesListAdditional),
          selectedEmploymentModels: view.employmentModels.filter((item) => item.checked).map((item) => item.id),
        },
      };

      this.axios({
        method: 'post',
        data: data,
        headers: {
          'AUTHORIZATION': "Bearer "+this.$store.state.jwt
        },
        url: url
      })
      .then((response) => {
        view.loadExportJobs();
        view.$helpers.success(view.$t('global.ui.success'), view.$t('export.builder.exportTriggered'));
      })
      .catch((error) => {
        console.log(error);
        view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.exportCouldNotBeTriggered'));
      })
      .finally((fin) => {

      });

    },
    triggerCsvExport(entity) {
      let view = this;

      let baseUrl = '';
      ["monthly"].includes(view.$parent.mode) ? (baseUrl = '/api/sec/bmd/exports/MFS/dispatch/withSetting')
          : ["individual-wagetypes"].includes(view.$parent.mode) ? (baseUrl = '/api/sec/iwt/exports/dispatch/withSetting')
          : this.$parent.mode == 'daily' ?  (baseUrl = '/api/sec/bmd/exports/AS/dispatch/withSetting')
          : (baseUrl = '/api/sec/bmd/exports/PP/dispatch/withSetting');

      let url = baseUrl;

      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseUrl);
      url = this.$helpers.appendParam("year", entity.year, url, baseUrl);
      url = this.$helpers.appendParam("month", entity.month, url, baseUrl);
      url = this.$helpers.appendParam("exportSettingsId", entity.exportSettingsId, url, baseUrl);

      this.axios({
        method: 'post',
        data: {},
        headers: {
          'AUTHORIZATION': "Bearer "+this.$store.state.jwt
        },
        url: url
      })
      .then((response) => {
        view.loadExportJobs();
        view.$helpers.success(view.$t('global.ui.success'), view.$t('export.builder.exportTriggered'));
      })
      .catch((error) => {
        console.log(error);
        view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.exportCouldNotBeTriggered'));
      })
      .finally((fin) => {

      });

    },
    getCsvExportFromBackend(entity) {
      let view = this;

      let baseUrl = '';
      ["monthly"].includes(view.$parent.mode) ? (baseUrl = '/api/sec/bmd/exports/MFS/create')
          : this.$parent.mode == 'individual-wagetypes' ?  (baseUrl = '/api/sec/iwt/exports/create')
          : this.$parent.mode == 'daily' ?  (baseUrl = '/api/sec/bmd/exports/AS/create')
          : (baseUrl = '/api/sec/bmd/exports/PP/create');

      let url = baseUrl;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseUrl);

      return this.axios({
        method: 'post',
        data: entity,
        headers: {
          'AUTHORIZATION': "Bearer "+this.$store.state.jwt
        },
        url: url
      });

    },
    getCsvExportFromBackendWithSetting(entity) {
      let view = this;

      let baseUrl = '';
      ["monthly"].includes(view.$parent.mode) ? (baseUrl = '/api/sec/bmd/exports/MFS/create/withSetting')
          : this.$parent.mode == 'individual-wagetypes' ?  (baseUrl = '/api/sec/iwt/exports/create/withSetting')
          : this.$parent.mode == 'daily' ?  (baseUrl = '/api/sec/bmd/exports/AS/create/withSetting')
          : (baseUrl = '/api/sec/bmd/exports/PP/create/withSetting');

      let url = baseUrl;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseUrl);

      return this.axios({
        method: 'post',
        data: entity,
        headers: {
          'AUTHORIZATION': "Bearer "+this.$store.state.jwt
        },
        url: url
      });
    },
    openCsvExportWithSettingsPopup() {
      let view = this;

      let entries = view.getDownloadWithSettingsEntries();

      view.$helpers.OpenPopup({
        type: "datafill",
        componentState: {
          entries: entries,
          selectCallback: function (entity) {
            view.triggerCsvExport(entity);
          },
        },
        header: view.$t('settings.sync.exportSettings'),
        expanded: true,
        centered: true,
      });
    },

    openCsvDownloadWithSettingsPopup() {
      let view = this;

      let entries = view.getDownloadWithSettingsEntries();
      if (view.softwareId === 6) {
        entries.push({divider: true});
      }
      entries.push({
        label: view.$t('export.builder.downloadFieldDescriptionFile'),
        key: "downloadFieldDescriptionFile",
        hidden: view.softwareId !== 6,
        value: view.softwareId === 6,
        type: "bool",
      })
      entries.push({divider: true});
      entries.push({
        label: view.$t('export.builder.useForDeltaCalculation'),
        key: "useForDeltaCalculation",
        // dataStyles: {'justify-content': 'end'},
        hidden: false,
        type: "bool",
      })

      view.$helpers.OpenPopup({
        type: "datafill",
        componentState: {
          entries: entries,
          selectCallback: function (entity) {
            view.exporting = true;
            view.getCsvExportFromBackendWithSetting(entity)
            .then((response) => {
              view.exporting = false;
              if (response && response.data && response.data.data) {
                let date = view.months.find(y => { return y.value === entity.month}).label + entity.year;
                let mode = '';
                switch (view.$parent.mode) {
                    case 'monthly':
                        mode = this.$t('export.builder.monthlySumsShort');
                        break;
                    case 'individual-wagetypes':
                        mode = this.$t('export.builder.individualWageTypesShort');
                        view.loadExportJobs();
                        break;
                    case 'daily':
                        mode = this.$t('export.builder.absencesShort');
                        break;
                    case 'personnelProvisions':
                        mode = this.$t('export.builder.provisionsShort');
                        break;
                }
                let settingName = view.sExportSettings.find(s => { return s.id === entity.exportSettingsId}).name;
                settingName = settingName.replace(/[^a-zA-Z0-9]/g, '');

                if (response.data.data.hasOwnProperty('exportCsv')) {
                  let filename = response.data.data.filename;
                  if (!filename) {
                    filename = 'Export_' + mode + '_' + settingName + '_' + date + '.csv';
                  }
                  view.$helpers.forceFileDownload(view.$helpers.b64DecodeUnicode(response.data.data.exportCsv), filename);
                  if (entity.downloadFieldDescriptionFile) {
                    let descriptionFilename = filename.replace('payroll', 'payroll_ini');
                    view.$helpers.forceFileDownload(view.$helpers.createLohnUndGehaltFieldDescriptionFile(view.sExportSettings.find(s => { return s.id === entity.exportSettingsId})), descriptionFilename);
                  }
                } else {
                  console.log(response);
                  view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.downloadCouldNotBeGenerated'));
                }
              } else {
                console.log(response);
                view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.downloadCouldNotBeGenerated'));
              }
            })
            .catch((error) => {
              console.log(error);
              view.exporting = false;
              view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.downloadCouldNotBeGenerated'));
            });
          },
        },
        header: view.$t('export.builder.downloadSettings'),
        width: "700px",
        expanded: true,
        centered: true,
      });
    },

    generateCsvOverview() {
      let view = this;

      let entries = view.getDownloadWithSettingsEntries();
      if (view.softwareId === 6) {
        entries.push({divider: true});
      }
      entries.push({
        label: view.$t('export.builder.downloadFieldDescriptionFile'),
        key: "downloadFieldDescriptionFile",
        hidden: true,
        value: false,
        type: "bool",
      })
      entries.push({
        label: view.$t('export.builder.useForDeltaCalculation'),
        key: "useForDeltaCalculation",
        // dataStyles: {'justify-content': 'end'},
        hidden: true,
        value: false,
        type: "bool"
      })

      view.$helpers.OpenPopup({
        type: "datafill",
        componentState: {
          entries: entries,
          selectCallback: function (entity) {
            view.exporting = true;
            view.getCsvExportFromBackendWithSetting(entity)
            .then((response) => {
              view.exporting = false;
              if (response && response.data && response.data.data) {
                let date = view.months.find(y => { return y.value === entity.month}).label + entity.year;
                let settingName = view.sExportSettings.find(s => { return s.id === entity.exportSettingsId}).name;
                settingName = settingName.replace(/[^a-zA-Z0-9]/g, '');

                if (response.data.data.hasOwnProperty('horizontalCsv')) {
                  let filename = view.$t('export.builder.csvOverview') + '_' + settingName + '_' + date + '.csv';
                  view.$helpers.forceFileDownload(view.$helpers.b64DecodeUnicode(response.data.data.horizontalCsv), filename, true);
                } else {
                  console.log(response);
                  view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.downloadCouldNotBeGenerated'));
                }
              } else {
                console.log(response);
                view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.downloadCouldNotBeGenerated'));
              }
            })
            .catch((error) => {
              console.log(error);
              view.exporting = false;
              view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.downloadCouldNotBeGenerated'));
            });
          },
        },
        header: view.$t('export.builder.downloadSettings'),
        width: "700px",
        expanded: true,
        centered: true,
      });
    },

    openPdfDownloadPopup() {
      let view = this;

      let entries = view.getDownloadWithSettingsEntries();
      entries.push({
        label: view.$t('export.builder.contentFromExportSelection'),
        key: "useExportSettings",
        hidden: false,
        type: "bool",
        value: true,
      });
      entries.push({divider: true});
      entries.push(...view.$helpers.getPdfOptions(view.employmentModelArray, view.content, true));

      view.$helpers.OpenPopup({
        type: "datafill",
        componentState: {
          entries: entries,
          selectCallback: function (entity) {
            localStorage.setItem(this.$store.state.companyId + "_settings_sotecDashboard_pdfOptions", JSON.stringify(entity));
            let exportObject = {};

            if (entity.useExportSettings) {
              let selectedSetting = view.sExportSettings.find(e => e.id === entity.exportSettingsId);

              entity.wageTypes = selectedSetting.selectedWageTypes.map(c => c.id);
              entity.employmentModels = selectedSetting.selectedEmploymentModels;
            }

            exportObject.month = entity.month;
            exportObject.year = entity.year;
            exportObject.exportSettingsId = entity.exportSettingsId;
            exportObject.options = entity;

            view.$refs["modal-loading"].show();
            view.$helpers.getIndividualWageTypeExportPdfReportWithSetting(exportObject)
            .then((response) => {
              view.$refs["modal-loading"].hide();
              console.log(response);

              view.modalPdfFilename = "IndividualWageTypeExport_" + exportObject.month + "_" + exportObject.year + ".pdf";
              view.modalPdfBase64 = response.data.data;

              view.showModal('modal-pdfpreview');

            })
            .catch((error) => {
              view.$refs["modal-loading"].hide();
              view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.errorGeneratingPdfReport'));
              console.log(error);
            });
          },
        },
        width: "700px",
        header: view.$t('export.builder.reportSettings'),
        expanded: true,
        centered: true,
      });

    },

    getDownloadWithSettingsEntries() {
      let view = this;

      let tmpMoment = view.$helpers.getCurrentMonthMomentTZ();
      let years = [];
      for (let i = 0; i < 3; i++) {
        let current = tmpMoment.year() - i;
        console.log(current);
        years.push({value: current, label: current + ""});
      }

      let exportEntries = [];
      let currentSetting = null;
      for (let i = 0; i < view.sExportSettings.length; i++) {
        let setting = view.sExportSettings[i];
        let settingEntry = {value: setting.id, label: setting.name};
        if (setting.id === view.selectedSettingsId) {
          currentSetting = settingEntry;
        }
        exportEntries.push(settingEntry);
      }

      return [
        {
          label: this.$t('employee.comp.year'),
          key: "year",
          hidden: false,
          type: "dropdownsearch",
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: "",
            items: years,
            selectMultiple: false,
            selectedItems: [],
            selectedItem: years.find(y => { return (y.value + "") === view.timeframeStart.format("YYYY") }),
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          value: years.find(y => { return (y.value + "") === view.timeframeStart.format("YYYY") }).value,
        },
        {
          label: this.$t('employee.comp.month'),
          key: "month",
          hidden: false,
          type: "dropdownsearch",
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: "",
            items: view.months,
            selectMultiple: false,
            selectedItems: [],
            selectedItem: view.months.find(y => { return y.value === (view.timeframeStart.months() + 1) }),
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          value: view.months.find(y => { return y.value === (view.timeframeStart.months() + 1) }).value,
        },
        {
          label: view.$t('export.builder.exportSelection'),
          key: "exportSettingsId",
          hidden: false,
          type: "dropdownsearch",
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: "",
            items: exportEntries,
            selectMultiple: false,
            selectedItems: [],
            selectedItem: currentSetting,
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          value: currentSetting.value,
        },
      ];
    },

    // load data
    loadWageTypes: function() {
      let view = this;
      if (["monthly", "daily", "personnelProvisions"].includes(view.$parent.mode)) {
        return view.loadMdWageTypes();
      } else if (view.$parent.mode == "individual-wagetypes") {
        let promises = [];
        promises.push(view.loadIndividualWageTypes());
        promises.push(view.loadEmploymentModels());
        return Promise.all(promises);
      }
    },
    loadIndividualWageTypes: function () {
      let view = this;
      let params = {
        companyId: view.$store.state.companyId,
        mapped: 1,
      };

      return view.$helpers
        .GetCall("/api/sec/individualWageTypes", params)
        .then((response) => {
          let data = response.data.data;

          console.log("individual wage types", data);

          let tmp = [];
          // Looping through sorted data and creating objects
          for (let i = 0; i < data.length; i++) {
            let item = {
              id: data[i].id,
              enumKey: data[i].id,
              numberString: data[i].numberString,
              exportId: data[i].exportId,
              name: data[i].name,
              sorting: data[i].sorting,
              color: data[i].color,
              details: data[i].details,
              selectedValue: view.individualWageTypesExportValueTypes.find(a => a.value == 0), // default "Stunden"
              checked: true,
              printPaidValue: true,
              printHours: true,
              printDays: true,
              printDaysCalculated: true,
              printFactor: true,
              printPayment: true
            };
            if (!item.details || Object.keys(item.details).length === 0) {
              // skip wage types without details
              continue;
            }
            if ([2,3].includes(item.details.workType)) {
              item.selectedValue = view.individualWageTypesExportValueTypes.find(a => a.value == 3); // default "Betrag"
            } else if ([5].includes(item.details.workType)) {
              item.selectedValue = view.individualWageTypesExportValueTypes.find(a => a.value == 4); // default "Wert aus Monatsabschluss"
            }
            tmp.push(item);
          }
          tmp.sort((a, b) => {
            // Handle cases where exportId might be undefined or null
            const numA = a.exportId && parseFloat(a.exportId) ? parseFloat(a.exportId) : (a.exportId == "0" ? 0 : Infinity);
            const numB = b.exportId && parseFloat(b.exportId) ? parseFloat(b.exportId) : (b.exportId == "0" ? 0 : Infinity);

            if (numA == numB) {
              if (a.exportId == b.exportId) {
                return a.name.localeCompare(b.name);
              }
              return a.exportId.localeCompare(b.exportId);
            }
            return numA - numB;
          });
          view.content = tmp;

          view.$helpers.GetExportSelectedWagetypesIndividualWagetypes().then((data) => {
            for (let i in view.content) {
              if (data[view.content[i].enumKey]) {
                view.content[i].checked = data[view.content[i].enumKey].checked;
                view.content[i].selectedValue = data[view.content[i].enumKey].selectedValue;
                view.content[i].printPaidValue = data[view.content[i].enumKey].printPaidValue ?? true;
                view.content[i].printHours = data[view.content[i].enumKey].printHours ?? true;
                view.content[i].printDays = data[view.content[i].enumKey].printDays ?? true;
                view.content[i].printDaysCalculated = data[view.content[i].enumKey].printDaysCalculated ?? true;
                view.content[i].printFactor = data[view.content[i].enumKey].printFactor ?? true;
                view.content[i].printPayment = data[view.content[i].enumKey].printPayment ?? true;
              }
            }
          });
        })
        .catch((e) => {
          view.loading = false;
          console.log(e);
        });
    },
    loadEmploymentModels: function () {
      let view = this;
      let params = { companyId: view.$store.state.companyId };

      view.$helpers
        .GetCall("/api/sec/employmentModels", params)
        .then((response) => {
          let data = response.data.data;
          let employmentModels = [];
          for (let i = 0; i < data.length; i++) {
            let employmentModel = {
              id: data[i].id,
              number: data[i].number,
              name: data[i].name,
              sorting: data[i].sorting,
              color: data[i].color,
              checked: true,
            };
            if(data[i].isActive) {
              employmentModels.push(employmentModel);
            }
          }
          view.employmentModelArray = employmentModels;

          view.$helpers.GetExportSelectedEmploymentModelsIndividualWagetypes().then((data) => {
            for (let i in view.employmentModelArray) {
              if (data[view.employmentModelArray[i].id]) {
                view.employmentModelArray[i].checked = data[view.employmentModelArray[i].id].checked;
              }
            }
          });
        })
        .catch((e) => {
          view.loading = false;
          console.log(e);
        });
    },
    loadMdWageTypes: function () {
      let view = this;
      return view.$helpers
      .GetCall("/api/sec/wagetypes", {})
      .then((response) => {
        view.content = [];
        console.log(view.$parent.mode);
        for (let i = 0; i < response.data.length; i++) {
          response.data[i].enumKey = response.data[i].id;
          response.data[i].checked = false;

          if (response.data[i].monthly && ["monthly", "personnelProvisions"].includes(view.$parent.mode)) {
            view.content.push(response.data[i]);
            if (["monthly"].includes(view.$parent.mode)) {
              view.$helpers.GetExportSelectedWagetypesMonthly().then((data) => {
                for (let i in view.content) {
                  if (data[view.content[i].enumKey]) {
                    view.content[i].checked = data[view.content[i].enumKey].checked;
                  }
                }
              });
            } else if (view.$parent.mode == "personnelProvisions") {
              view.balanceItems = view.content.filter((item) => item.key.endsWith("Balance") || item.key.endsWith("BalanceOnlyPositive") || item.key.endsWith("BalanceOnlyNegative"))
                .map((item) => {
                  return { key: item.id, label: item.name };
                });
            }
          } else if (!response.data[i].monthly && view.$parent.mode == "daily") {
            view.content.push(response.data[i]);
            view.$helpers.GetExportSelectedWagetypesDaily().then((data) => {
              for (let i in view.content) {
                if (data[view.content[i].enumKey]) {
                  view.content[i].checked = data[view.content[i].enumKey].checked;
                }
              }
            });
          }
        }
        console.log("content", view.content);
      })
      .catch((e) => {
        console.log(e);
      });
    },
    loadWageTypesMapping: function () {
      let view = this;
      view.$helpers
        .GetCall("/api/sec/mapping/wagetype", {})
        .then((response) => {
          for (let i = 0; i < view.content.length; i++) {
            view.content[i].externalId = "";
            for (let j = 0; j < response.data.data.length; j++) {
              let tmp = response.data.data[j];
              if (parseInt(view.content[i].enumKey) == parseInt(tmp.wageTypeId)) {
                view.content[i].externalId = tmp.externalId;
              }
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    loadAllMonthlyStatements() {
      let view = this;
      view.prevMonthStatementResponses = [];
      view.statementResponses = [];
      view.employeeWorkDaysCount = [];

      // console.log("stores", view.stores);
      // console.log("storesMap", view.storesMap);

      let promises = [];

      for (let j = 0; j < view.stores.length; j++) {
        console.log(view.stores[j].id);
        promises.push(this.loadMonthlyStatementFromMD(view.stores[j].id));
        promises.push(this.loadPrevMonthlyStatementFromMD(view.stores[j].id));
        // await this.loadStatisticsDynamicActualShifts(view.stores[j].id);
      }

      // console.log(view.statementResponses);

      return Promise.all(promises).finally(() => {
        console.log("finished loading MFS");
        view.loadingMFS = false;
        view.checkDuplicateEmployees();
        if (["monthly", "individual-wagetypes"].includes(view.$parent.mode)) {
          view.$forceUpdate();
          // view.loading = false;
        } else if (view.$parent.mode == "daily") {
          view.loadMDids();
        } else {
          // view.loading = false;
        }
      });
    },
    loadMonthlyStatementFromMD: function (storeId) {
      let view = this;
      let promise = new Promise(function (resolve, reject) {
        let params = {
          storeId: storeId,
          date: view.selectedDate.format("YYYY-MM-DD"),
        };
        view.$helpers
          .GetCall("/api/sec/proxy/md/monthlyfinancialstatements", params)
          .then((response) => {
            let tmpObjectForSet = view.monthlyStatements[storeId];
            view.statementResponses.push(response.data);
            let statement = response.data;
            tmpObjectForSet.loading = false;
            tmpObjectForSet.confirmed = statement.length > 0 ? true : false;
            for (let k = 0; k < statement.length; k++) {
              if (!statement[k].confirmed) {
                tmpObjectForSet.confirmed = false;
              }
            }
            view.$set(view.monthlyStatements, storeId, tmpObjectForSet);

            resolve("");
          })
          .catch((e) => {
            console.log(e);
            reject(e);
          });
      });
      return promise;
    },
    loadPrevMonthlyStatementFromMD: function (storeId) {
      let view = this;

      let promise = new Promise(function (resolve, reject) {
        let params = {
          storeId: storeId,
          date: view.selectedDate.clone().subtract(1, 'months').format("YYYY-MM-DD"),
        };
        view.$helpers
          .GetCall("/api/sec/proxy/md/monthlyfinancialstatements", params)
          .then((response) => {
            view.prevMonthStatementResponses.push(response.data);
            resolve("");
          })
          .catch((e) => {
            console.log(e);
            reject(e);
          });
      });
      return promise;
    },
    loadStatisticsDynamicActualShifts: function (storeId) {
      let view = this;
      let promise = new Promise(function (resolve, reject) {
        let params = {
          storeId: storeId,
          date: view.selectedDate.format("YYYY-MM-DD"),
        };
        view.$helpers
          .GetCall("/api/sec/proxy/md/statisticdynamic/actualshifts", params)
          .then((response) => {
            Object.values(response.data).forEach(actualshift => {
              if (actualshift.count >= 1) {
                if (!(actualshift.remoteId in view.employeeWorkDaysCount)) {
                  view.employeeWorkDaysCount[actualshift.remoteId] = 0;
                }
                view.employeeWorkDaysCount[actualshift.remoteId] += 1;
              }
            });
            resolve("");
          })
          .catch((e) => {
            console.log(e);
            reject(e);
          });
      });
      return promise;
    },

    loadMDids: function () {
      let view = this;
      view.employeeMdids = {};
      view.$helpers
        .GetCall("/api/sec/employee/mdids", {})
        .then((response) => {
          for (let i in response.data) {
            let d = response.data[i];
            view.employeeMdids[d.mdid] = d.employeeId; // The mapping from Employee-MD-id to Employee-remote-id is n:1 => therefore no array of remote ids is needed
          }
          view.loadAllEmployeePreferences();
        })
        .catch((e) => {
          console.log(e);
        });
    },

    async loadAllEmployeePreferences() {
      let view = this;
      view.preferencePerEmployee = {};
      await this.loadEmployeePreferencesFromMD();
      for (let i in view.preferencePerEmployee) {
        view.preferencePerEmployee[i].sort(function (a, b) {
          if (a.timestamp < b.timestamp) return -1;
          if (a.timestamp > b.timestamp) return 1;
          return 0;
        });
      }

      //vanessa wants to have the preferences grouped to few lines
      for (let i in view.preferencePerEmployee) {
        let preferences = view.preferencePerEmployee[i];
        for (let j = 0; j < preferences.length; j++) {
          preferences[j].canMerge = false;
          if (preferences[j + 1]) {
            if (preferences[j].p.type == preferences[j + 1].p.type) {
              let end = view.$helpers.getMomentFromString(preferences[j].p.to);
              let begin = view.$helpers.getMomentFromString(preferences[j + 1].p.from);
              if (preferences[j].enumKey == preferences[j + 1].enumKey) {
                if (end.isSame(begin)) {
                  preferences[j].canMerge = true;
                }
                if (preferences[j].p.id == preferences[j + 1].p.id) {
                  preferences[j].canMerge = true;
                }
              }
            }
          }
        }
      }

      view.$forceUpdate();
      // view.loading = false;
    },

    loadEmployeePreferencesFromMD: function (soreId) {
      let view = this;
      let promise = new Promise(function (resolve, reject) {
        let params = {
          date: view.selectedDate.format("YYYY-MM-DD"),
        };
        view.$helpers
          .GetCall("/api/sec/proxy/md/employeepreferences", params)
          .then((response) => {
            for (let i in response.data) {
              let preference = response.data[i];
              if (preference.state != 1) continue; // Only Absences, we don't want to export wishes
              if (!preference.approved) continue; // Only export approved absences
              if (preference.remoteId == 0) continue; // Skip dummy
              view.CalculatePreference(preference);
            }

            resolve("");
          })
          .catch((e) => {
            console.log(e);
            reject(e);
          });
      });
      return promise;
    },
    loadExportJobs() {
      let view = this;

      let url = ["monthly"].includes(view.$parent.mode) ? '/api/sec/bmd/exports/MFS/jobs'
        : ["individual-wagetypes"].includes(view.$parent.mode) ? '/api/sec/iwt/exports/jobs'
        : this.$parent.mode == 'daily' ? '/api/sec/bmd/exports/AS/jobs'
        : '/api/sec/bmd/exports/PP/jobs';
      let baseurl = url;
      url = this.$helpers.appendParam("companyId", this.$store.state.companyId, url, baseurl);

      this.axios({
        method: "get",
        headers: {
          'AUTHORIZATION': "Bearer " + this.$store.state.jwt
        },
        url: url
      }).then((response) => {
        view.exportJobs = response.data.data;
        console.log(response.data);

        Object.values(view.exportJobs).forEach((elem) => {
          elem.jobStartedISO = elem.jobStarted != null ? view.$helpers.convertUTCDateStringTZ(elem.jobStarted, 'YYYY-MM-DDTHH:mm:ssZ') : null;
          elem.jobStarted = elem.jobStarted != null ? view.$helpers.convertUTCDateStringTZ(elem.jobStarted, 'DD.MM.YYYY HH:mm:ss') : null;
          elem.jobEnded = elem.jobEnded != null ? view.$helpers.convertUTCDateStringTZ(elem.jobEnded, 'DD.MM.YYYY HH:mm:ss') : null;
          elem.jobFailed = elem.jobFailed != null ? view.$helpers.convertUTCDateStringTZ(elem.jobFailed, 'DD.MM.YYYY HH:mm:ss') : null;
        });
      }).catch((e) => {

      });
    },

    // helper
    GetContractsOverlappingMonth(contracts, monthFrom, monthTo) {
      let view = this;
      let result = [];
      contracts.forEach((contract) => {
        let contractFrom = view.$helpers.getMomentFromStringTZ(contract.from);
        if (contractFrom < monthFrom) contractFrom = monthFrom.clone();

        let contractTo = contract.to == null ? monthTo : view.$helpers.getMomentFromStringTZ(contract.to);
        if (contractTo > monthTo) contractTo = monthTo.clone();

        if (contractFrom < monthTo && contractTo > monthFrom) {
          result.push(contract);
        }
      });
      return result;
    },
    CalculatePreference: function (pref) {
      let view = this;
      let mainContract = null;
      let currentMonthFromTZ = this.$helpers.getMomentFromValuesTZ(view.selectedDate.year(), view.selectedDate.month(), 1);
      let currentMonthToTZ = currentMonthFromTZ.clone().add(1, "months");

      if (view.mdEmployeeContractMap[pref.employeeId]) {
        let contracts = view.mdEmployeeContractMap[pref.employeeId];
        let overlappingContracts = this.GetContractsOverlappingMonth(contracts, currentMonthFromTZ, currentMonthToTZ);
        overlappingContracts.forEach((contract) => {
          let contractFrom = view.$helpers.getMomentFromStringTZ(contract.from);
          if (!mainContract) {
            mainContract = contract;
          } else {
            let mainContractFrom = view.$helpers.getMomentFromStringTZ(mainContract.from);
            if (contractFrom > mainContractFrom) {
              mainContract = contract;
            }
          }
        });
      }

      let baseWorkValue = pref.workValue;
      let prefFrom = this.$helpers.getMomentFromStringTZ(pref.from);
      let prefTo = this.$helpers.getMomentFromStringTZ(pref.to);

      let prefStart = prefFrom.clone();
      let dayTimeRegular = mainContract != null ? Math.round(mainContract.weekTimeRegular / mainContract.weekWorkDaysRegular) : 9 * 60;
      let alwaysWork = pref.alwaysWork;
      while (prefStart < prefTo) {
        //step through day, and check interval
        let endOfDay = prefStart.clone().add(1, "days").startOf("day");
        let checkEnd = endOfDay < prefTo ? endOfDay : prefTo;
        let diff = checkEnd.diff(prefStart, "minutes");

        let prefObj = {
          p: pref,
          storeId: pref.storeId,
          remoteId: pref.remoteId,
          date: prefStart.format("YYYY-MM-DD"),
          workValue: 0,
          timestamp: prefStart.unix(),
        };

        let ratioFrom = prefStart < currentMonthFromTZ ? currentMonthFromTZ : prefStart > currentMonthToTZ ? currentMonthToTZ : prefStart;
        let ratioTo = checkEnd > currentMonthToTZ ? currentMonthToTZ : checkEnd < currentMonthFromTZ ? currentMonthFromTZ : checkEnd;
        let ratio = ratioTo.diff(ratioFrom) / checkEnd.diff(prefStart);

        let prefTime = Math.round(diff * ratio);
        if (prefTime > 0) {
          let isWeekend = !view.storeSettingWeekdaysMap[pref.storeId].includes(prefStart.isoWeekday());
          let tWorkValue = 0;
          if (baseWorkValue > -1) {
            let workValueRatio = ratioTo.diff(ratioFrom) / prefTo.diff(prefFrom);
            tWorkValue = Math.round(baseWorkValue * workValueRatio);
          } else {
            if (prefTime > dayTimeRegular) {
              tWorkValue += dayTimeRegular;
            } else {
              tWorkValue += prefTime;
            }
            //prefObj.workValue = tWorkValue;
          }
          if (pref.type == 1 || pref.type == 2 || pref.type == 3 || pref.type == 6 || pref.type == 7 || pref.type == 8) {
            if (!isWeekend || alwaysWork) {
              prefObj.workValue = tWorkValue;
            }
            if (pref.type == 1) {
              // Urlaub
              prefObj.enumKey = 52;
            } else if (pref.type == 2) {
              // Krankenstand
              prefObj.enumKey = 53;
            } else if (pref.type == 3) {
              // Feiertags Ausgleich
              prefObj.enumKey = 54;
            } else if (pref.type == 6) {
              // Pflegeurlaub
              prefObj.enumKey = 56;
            } else if (pref.type == 7) {
              // Ausbildung
              prefObj.enumKey = 57;
            } else if (pref.type == 8) {
              // Lohnfortzahlung
              prefObj.enumKey = 58;
              // add subtypes
              if (pref.subtype == 1) {
                // sonstiges?
                prefObj.subEnumKey = 62;
              } else if (pref.subtype == 8) {
                // Arbeitsunfall
                prefObj.subEnumKey = 64;
              } else if (pref.subtype == 9) {
                // Arztbesuch
                prefObj.subEnumKey = 63;
              } else if (pref.subtype == 10) {
                // Behörde
                prefObj.subEnumKey = 65;
              }
            }
            //}
          } else if (pref.type == 4 && alwaysWork) {
            prefObj.workValue = tWorkValue;
            prefObj.enumKey = 55;
          }
        }
        prefStart = prefStart.add(1, "days").startOf("day");

        if ((pref.type == 2 && prefObj.workValue >= 0) || prefObj.workValue > 0) {
          if (!view.preferencePerEmployee[pref.remoteId]) {
            view.preferencePerEmployee[pref.remoteId] = [];
          }
          view.preferencePerEmployee[pref.remoteId].push(prefObj);
        }
      }
    },
    checkDuplicateEmployees: function () {
      let view = this;
      view.duplicateEmployees = [];
      view.monthlyStatementPerEmployee = {};
      view.previousMonthlyStatementPerEmployee = {};
      let activeStores = [];
      view.stores.forEach(function (store) {
        if (view.globalFilter && view.globalFilter.stores && view.globalFilter.companyId == view.$store.state.companyId) {
          for (let i in view.globalFilter.stores) {
            if (view.globalFilter.stores[i].id == store.id && view.globalFilter.stores[i].selected) {
              activeStores.push(store.id);
            }
          }
        }
      });
      for (let i = 0; i < view.statementResponses.length; i++) {
        let statement = view.statementResponses[i];
        for (let k = 0; k < statement.length; k++) {
          if (statement[k].remoteId == null) continue;
          //if(statement[k].remoteId != 11263)continue;

          if (view.selectedStores[statement[k].storeId] && activeStores.includes(statement[k].storeId)) {
            if (view.monthlyStatementPerEmployee[statement[k].remoteId] == null || view.monthlyStatementPerEmployee[statement[k].remoteId] == undefined) {
              view.monthlyStatementPerEmployee[statement[k].remoteId] = [];
            } else {
              if (!view.duplicateEmployees.includes(statement[k].remoteId)) {
                view.duplicateEmployees.push(statement[k].remoteId);
              }
            }
            statement[k].workDaysCount = view.employeeWorkDaysCount[statement[k].remoteId] ?? 0;
            view.monthlyStatementPerEmployee[statement[k].remoteId].push(statement[k]);
          }
          view.$forceUpdate();
        }
      }
      for (let i = 0; i < view.prevMonthStatementResponses.length; i++) {
        let statement = view.prevMonthStatementResponses[i];
        for (let k = 0; k < statement.length; k++) {
          if (statement[k].remoteId == null) continue;

          if (view.selectedStores[statement[k].storeId] && activeStores.includes(statement[k].storeId)) {
            if (view.previousMonthlyStatementPerEmployee[statement[k].remoteId] == null || view.previousMonthlyStatementPerEmployee[statement[k].remoteId] == undefined) {
              view.previousMonthlyStatementPerEmployee[statement[k].remoteId] = [];
            } else {
              if (!view.duplicateEmployees.includes(statement[k].remoteId)) {
                view.duplicateEmployees.push(statement[k].remoteId);
              }
            }
            view.previousMonthlyStatementPerEmployee[statement[k].remoteId].push(statement[k]);
          }
          view.$forceUpdate();
        }
      }
    },
    getStoreNames: function (storeIdArray) {
      let view = this;

      let storeNames = view.stores.filter(store => storeIdArray.includes("" + store.id)).map(store => {
        return store ? store.name : '';
      });
      return storeNames.join('\r\n');
    },

    // build table
    buildExportTable: function () {
      let view = this;
      if (!view.hasSelectedWageType) {
        view.buildingExportTable = false;
        return;
      }

      view.missingPersonalIds = [];
      view.buildingExportTable = true;
      view.exporting = true;
      view.somethingHasChangedWhatAffectsExportTable = false;
      view.exportTable = [];
      view.currentCSV = null;
      view.previewCsv = null;
      view.currentJson = null;
      view.currentFilename = null;
      view.currentCreateDate = null;

      if (view.$parent.mode === "individual-wagetypes") {
        view.availableFieldsIndividualWageTypes.sort((a, b) => a.fieldOrder - b.fieldOrder);
      }

      let activeStores = [];
      view.stores.forEach(function (store) {
        if (view.globalFilter && view.globalFilter.stores && view.globalFilter.companyId == view.$store.state.companyId) {
          for (let i in view.globalFilter.stores) {
            if (view.globalFilter.stores[i].id == store.id && view.globalFilter.stores[i].selected) {
              activeStores.push(store.id);
            }
          }
        }
      });

      let useBackendCalculation = true;
      if (useBackendCalculation) {
        // if (["monthly", "daily", "personnelProvisions"].includes(view.$parent.mode)) {
          // try to get export from backend
          let entity = {
            year: view.selectedDate.format("YYYY"),
            month: view.selectedDate.format("M"),
            sessionId: view.sessionId,
            exportSettings: {
              name: view.$t('report.comp.standard'),
              id: 0,
              selectedStores: Object.entries(this.selectedStores).filter(([storeId, active]) => active).map(([storeId, active]) => parseInt(storeId)),
              availableFields: Object.values(this.availableFields),
              availableFieldsAdditional: Object.values(this.availableFieldsAdditional),
              selectedEmploymentModels: this.employmentModels.filter((item) => item.checked).map((item) => item.id),
            },
          };
          if (view.$parent.mode == "individual-wagetypes") {
            entity.exportSettings.availableFieldsIndividualWageTypesListAdditional = view.availableFieldsIndividualWageTypesListAdditional;
            entity.exportSettings.selectedWageTypes = this.content.filter((item) => item.checked).map((item) => ({
              id: item.id,
              selectedValue: item.selectedValue,
              printPaidValue: item.printPaidValue,
              printHours: item.printHours,
              printDays: item.printDays,
              printDaysCalculated: item.printDaysCalculated,
              printFactor: item.printFactor,
              printPayment: item.printPayment
            }));
          } else {
            entity.exportSettings.selectedWageTypes = this.content.filter((item) => item.checked).map((item) => item.id);
          }
          view.getCsvExportFromBackend(entity)
          .then(result => {
            // view.$helpers.success("Erfolg", "Export wurde erfolgreich im Backend generiert.");
            var headers = view.availableFields.filter((item) => item.checked).map((item) => item.key);

            let donCompanies = [195, 196, 197, 218, 219, 220];
            if (donCompanies.includes(parseInt(view.$store.state.companyId)) && view.$parent.mode === "monthly") {
              console.log("DONHAUSER GROUP");
              headers = [];
              headers.push("month");
              headers.push("externalCompanyId");
              headers.push("externalEmployeeId");
              headers.push("placeholder1");
              headers.push("lohnart");
              headers.push("paidWorkTime");
              headers.push("placeholder2");
              headers.push("placeholder3");
              headers.push("placeholder4");
              headers.push("placeholder5");
              headers.push("rollUpMonth");
            }

            console.log("headers", headers);
            view.currentCSV = this.$helpers.b64DecodeUnicode(result.data.data.exportCsv);
            if (result.data.data.hasOwnProperty("previewCsv")) {
              view.previewCSV = this.$helpers.b64DecodeUnicode(result.data.data.previewCsv);
            } else {
              view.previewCSV = view.currentCSV;
            }
            view.currentJson = result.data.data.exportJson;
            view.currentFilename = result.data.data.filename;
            view.currentCreateDate = this.$helpers.getMomentTZ();
            // console.log("currentCSV", view.currentCSV);
            // console.log("previewCSV", view.previewCSV);

            var lines = view.previewCSV.split("\n");
            var hasHeader = null;
            if (view.$parent.mode == "individual-wagetypes") {
              hasHeader = this.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === "headerAdditional").item.key === 1;
            } else if (view.$parent.mode == "personnelProvisions") {
              hasHeader = this.availableFieldsAdditional.find(f => f.key === "ppHeaderAdditional").item.key === 1;
            } else {
              hasHeader = this.availableFieldsAdditional.find(f => f.key === "headerAdditional").item.key === 1;
            }
            for(var i = hasHeader ? 1 : 0; i < lines.length; i++) {
              var data = lines[i].split(';');
              if (data.length < headers.length) {
                console.log("ERROR: " + "data.length < headers.length", data.length, headers.length);
                continue;
              }
              var obj = {};
              for(var j = 0; j < data.length; j++) {
                if (headers[j]) {
                  let trimmed = data[j].trim();
                  if (["paidWorkTime", "dailyPayoutValue", "dailyPayoutHoursValue"].includes(headers[j].trim())
                      || (view.$parent.mode == "personnelProvisions" && !["ppExternalCompanyId", "ppExternalEmployeeId", "ppEmployeeName"].includes(headers[j].trim()))) {
                    trimmed = trimmed == "" ? "" : parseFloat(trimmed.replace(",", "."));
                  }
                  obj[headers[j].trim()] = trimmed;
                }
              }
              // console.log(obj);
              view.exportTable.push(obj);
            }
            view.exportTable.sort((a, b) => {
              if (a.employeeName < b.employeeName) {
                return -1;
              }
              if (a.employeeName > b.employeeName) {
                return 1;
              }
              if (a.contentName < b.contentName) {
                return -1;
              }
              if (a.contentName > b.contentName) {
                return 1;
              }
              return 0;
            });
            // JSON.stringify(jsonObj);
            console.log("exportTable", view.exportTable);
          })
          .catch(error => {
            view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.exportPreviewCouldNotBeCreated'));
            console.log(error);
          })
          .finally(() => {
            view.buildingExportTable = false;
            view.exporting = false;
            view.$forceUpdate();
          });

      }
      return Promise.resolve();
    },

    loadEmployees: function (force = false, employeeIdToSelect = null) {
      let view = this;

      this.$helpers.GetEmployeeMap(force, false)
        .then((response) => {
          Object.values(response).forEach(resp => {
            view.employeeMap[resp.id] = resp;
          });

          // view.mdEmployeeContractMap = {};
          // view.mdContractArray = [];
          // view.getEmployeeContracts().then((response) => {
          //   for (let i in response.data) {
          //     let contract = response.data[i];
          //     if (!view.mdEmployeeContractMap[contract.employeeId]) {
          //       view.mdEmployeeContractMap[contract.employeeId] = [];
          //     }
          //     view.mdEmployeeContractMap[contract.employeeId].push(contract);
          //     view.mdContractArray.push(contract);
          //   }
          // });
          /*
        this.employeeArray = empls;
        this.prepareStoreEmployees(empls, employeeIdToSelect, force);
        this.loadingStage++;
        */
        });
    },

    loadStoresForCompany: function () {
      let view = this;
      view.loadStores = true;
      let params = {};
      view.selectedStores = {};

      return view.$helpers.GetExportDeselectedStores().then((deselectedStores) => {
        return view.$helpers
          .GetCall("/api/sec/stores", params)
          .then((response) => {
            view.stores = response.data.data;

            view.storesMap = {};
            for (let j = 0; j < view.stores.length; j++) {
              let tmp = view.stores[j];
              let obj = {
                id: tmp.id,
                name: tmp.name,
                description: tmp.description,
                selected: deselectedStores[tmp.id] != undefined && deselectedStores[tmp.id] != null ? false : true,
                monthlyFinancialStatement: 0,
              };
              view.$set(view.selectedStores, tmp.id, deselectedStores[tmp.id] != undefined && deselectedStores[tmp.id] != null ? false : true);
              view.storesMap[tmp.id] = obj;
              view.monthlyStatements[tmp.id] = {
                confirmed: false,
                loading: true,
              };
              /*
              if(view.globalFilter && view.globalFilter.stores && view.globalFilter.companyId == view.$store.state.companyId){
                for(let i in view.globalFilter.stores){
                  if(view.globalFilter.stores[i].id == tmp.id && view.globalFilter.stores[i].selected){
                    pushed = true;
                  }
                }
              }
              if(!pushed){
                view.storesMap[tmp.id].selected = false;
              }
              */
            }

            view.loadStores = false;

            // view.loadAllMonthlyStatements();
            // this.loading = false;

            view.$forceUpdate();
          })
          .catch((e) => {
            view.loadStores = false;
            // view.loading = false;
            console.log(e);
          });
      });
    },

    modDate: function (method) {
      let view = this;

      if (method == "add") {
        this.selectedDate.add(1, "months");
        this.timeframeStart = this.selectedDate.clone().startOf("month");
        this.timeframeEnd = this.selectedDate.clone().endOf("month");
        this.$forceUpdate();
      } else if (method == "sub") {
        this.selectedDate.subtract(1, "months");
        this.timeframeStart = this.selectedDate.clone().startOf("month");
        this.timeframeEnd = this.selectedDate.clone().endOf("month");
        this.$forceUpdate();
      }
      this.$helpers.SetExportSelectedDate({ currentDate: this.$helpers.getMomentTZ(), date: this.selectedDate, });
      this.refresh(false, true);
    },

    GetEmployeeInfoTooltip() {
      let view = this;
      return {
        components: [
          {
            type: "listlabel",
            state: {
              labels:
                this.duplicateEmployees.length > 0
                  ? this.duplicateEmployees.map((eId) => {
                      return {
                        text: `${view.employeeMap[eId] ? view.employeeMap[eId].firstName + " " + view.employeeMap[eId].lastName : view.$t('export.builder.unknownUnknown')}`,
                        styleLabel: {
                          boxShadow: "0 2px 0px -1px var(--contrast-2)",
                        },
                      };
                    })
                  : [{ text: "-" }],
            },
          },
        ],
        allowWindowOverflow: true,
      };
    },
    GetEmployeeMissingPersoTooltip() {
      let view = this;
      return {
        components: [
          {
            type: "listlabel",
            state: {
              labels:
                this.missingPersonalIds.length > 0
                  ? this.missingPersonalIds.map((eId) => {
                      return {
                        text: `${view.employeeMap[eId] ? view.employeeMap[eId].firstName + " " + view.employeeMap[eId].lastName : view.$t('export.builder.unknownUnknown')}`,
                        styleLabel: {
                          boxShadow: "0 2px 0px -1px var(--contrast-2)",
                        },
                      };
                    })
                  : [{ text: "-" }],
            },
          },
        ],
        allowWindowOverflow: true,
      };
    },

    toggleStoreLocalStorage(storeIdArray, selected) {
      let view = this;
      return view.$helpers.GetExportDeselectedStores().then((data) => {
        storeIdArray.forEach((storeId) => {
          data[storeId] = selected;
          if (selected) {
            delete data[storeId];
          }
        });
        return view.$helpers.SetExportDeselectedStores(data);
      });
    },

    globalFilterChanged() {
      this.somethingHasChangedWhatAffectsExportTable = true;
      this.checkDuplicateEmployees();
    },

    saveContentLS() {
      let saveData = {};
      for (let i in this.content) {
        saveData[this.content[i].enumKey] = {
          enumKey: this.content[i].enumKey,
          checked: this.content[i].checked,
        };
        if (this.$parent.mode == "individual-wagetypes") {
          saveData[this.content[i].enumKey].selectedValue = this.content[i].selectedValue;
          saveData[this.content[i].enumKey].printPaidValue = this.content[i].printPaidValue;
          saveData[this.content[i].enumKey].printHours = this.content[i].printHours;
          saveData[this.content[i].enumKey].printDays = this.content[i].printDays;
          saveData[this.content[i].enumKey].printDaysCalculated = this.content[i].printDaysCalculated;
          saveData[this.content[i].enumKey].printFactor = this.content[i].printFactor;
          saveData[this.content[i].enumKey].printPayment = this.content[i].printPayment;
        }
      }
      if (["monthly"].includes(this.$parent.mode)) {
        this.$helpers.SetExportSelectedWagetypesMonthly(saveData);
      } else if (this.$parent.mode == "individual-wagetypes") {
        this.$helpers.SetExportSelectedWagetypesIndividualWagetypes(saveData);
      } else if (this.$parent.mode == "daily") {
        this.$helpers.SetExportSelectedWagetypesDaily(saveData);
      }
    },
    saveAvailableFieldsLS() {
      let saveData = {};
      for (let i in this.availableFields) {
        // console.log(this.availableFields[i]);
        saveData[this.availableFields[i].key] = {
          key: this.availableFields[i].key,
          checked: this.availableFields[i].checked,
          name: this.availableFields[i].name,
        };
        if (this.availableFields[i].key.startsWith("placeholder")) {
          saveData[this.availableFields[i].key].fixedValue = this.availableFields[i].fixedValue;
        }
        if (this.$parent.mode === "personnelProvisions") {
          saveData[this.availableFields[i].key].newName = this.availableFields[i].item ? this.availableFields[i].item.label : this.availableFields[i].newName;
          saveData[this.availableFields[i].key].item = this.availableFields[i].item;
        } else {
          saveData[this.availableFields[i].key].newName = this.availableFields[i].newName;
        }
        if (this.$parent.mode === "individual-wagetypes") {
          saveData[this.availableFields[i].key].fieldOrder = this.availableFields[i].fieldOrder;
          for (let i in this.availableFieldsIndividualWageTypesListAdditional) {
            saveData[this.availableFieldsIndividualWageTypesListAdditional[i].key] = {
              key: this.availableFieldsIndividualWageTypesListAdditional[i].key,
              checked: this.availableFieldsIndividualWageTypesListAdditional[i].checked,
              item: this.availableFieldsIndividualWageTypesListAdditional[i].item,
              fixedValue: this.availableFieldsIndividualWageTypesListAdditional[i].fixedValue ?? '',
            };
          }
        }
      }
      for (let i in this.availableFieldsAdditional) {
        saveData[this.availableFieldsAdditional[i].key] = {
          key: this.availableFieldsAdditional[i].key,
          checked: this.availableFieldsAdditional[i].checked,
          item: this.availableFieldsAdditional[i].item,
        };
      }
      this.$helpers.SetExportSelectedColumns(saveData, this.$parent.mode);
    },
    saveEmploymentModelsLS() {
      let saveData = {};
      for (let i in this.employmentModels) {
        saveData[this.employmentModels[i].id] = {
          id: this.employmentModels[i].id,
          checked: this.employmentModels[i].checked,
        };
      }
      this.$helpers.SetExportSelectedEmploymentModelsIndividualWagetypes(saveData);
    },

    updateFieldOrder(el, from, to) {
      let view = this;

      console.log("from", from);
      console.log("to", to);

      Object.values(el.availableFields).forEach((element) => {
        // console.log(element.key + " " + element.fieldOrder);
        if (element.fieldOrder === from) {
          // console.log(element.key + " " + element.fieldOrder + " to " + to);
          element.fieldOrder = to;
        } else {
          if (from < to && element.fieldOrder > from && element.fieldOrder <= to) {
            // console.log(element.key + " " + element.fieldOrder + " to " + (element.fieldOrder - 1));
            element.fieldOrder -= 1;
          } else if (from > to && element.fieldOrder < from && element.fieldOrder >= to) {
            // console.log(element.key + " " + element.fieldOrder + " to " + (element.fieldOrder + 1));
            element.fieldOrder += 1;
          }
        }
      });

      // console.log("sExportSettings", view.sExportSettings);

      // fields.sort((a, b) => a.fieldOrder - b.fieldOrder);
    },

    OpenFilterDropdown($event) {
      var view = this;
      var target = $event.currentTarget;
      this.LoadFilterDropdown();

      this.$helpers.OpenPopup({
        elRelative: target,
        type: "list",
        componentState: {
          entries: view.filterDropdownOptions,
        },
        remainAfterSelect: true,
        pointerDirection: 0,
        iconsLeft: true,
        selectCallback: function ($event, item, dropdown) {
          item.toggled = !item.toggled;
          if (item.type == "1") {
            view.hiddenStates.exportsettings = !view.hiddenStates.exportsettings;
          }
          if (item.type == "2") {
            view.hiddenStates.employmentModels = !view.hiddenStates.employmentModels;
          }
          if (item.type == "3") {
            view.hiddenStates.wageTypes = !view.hiddenStates.wageTypes;
          }
          if (item.type == "4") {
            view.hiddenStates.employees = !view.hiddenStates.employees;
          }
          if (item.type == "5") {
            view.hiddenStates.preview = !view.hiddenStates.preview;
          }

          /*
          if (item.state) item.state.show = item.toggled;
          if (item.type) item.type.show = item.toggled;
          if (item.all) {
            view.filterDropdownOptions.forEach((option) => {
              if (option.state || option.type) {
                option.toggled = item.toggled;
                if (option.state) option.state.show = item.toggled;
                if (option.type) option.type.show = item.toggled;
              }
            });
          }*/
        },
      });
    },
    LoadFilterDropdown() {
      var view = this;
      this.filterDropdownOptions = [];
      view.filterDropdownOptions.push({
        label: view.$t('export.builder.exportSettings'),
        toggled: !view.hiddenStates.exportsettings,
        type: "1",
        color: "#000",
      });
      if (this.$parent.mode === "individual-wagetypes") {
        view.filterDropdownOptions.push({
          label: view.$t('export.builder.availableEmploymentModels'),
          toggled: !view.hiddenStates.employmentModels,
          type: "2",
          color: "#000",
        });
      }
      if (this.$parent.mode !== "personnelProvisions") {
        view.filterDropdownOptions.push({
          label: view.$t('export.builder.availableWageTypes'),
          toggled: !view.hiddenStates.wageTypes,
          type: "3",
          color: "#000",
        });
      }
      if (["monthly"].includes(view.$parent.mode)) {
        view.filterDropdownOptions.push({
          label: view.$t('export.builder.mdMonthEnd'),
          toggled: !view.hiddenStates.employees,
          type: "4",
          color: "#000",
        });
      }
      view.filterDropdownOptions.push({
        label: view.$t('export.builder.exportPreview'),
        toggled: !view.hiddenStates.preview,
        type: "5",
        color: "#000",
      });
      /*
      this.filterDropdownOptions.push({
        label: "Alle",
        toggled: true,
        all: true,
        color: "#eeeeee",
      });*/
    },

    OpenMenuDetails($event, state){
      let view = this;

      this.$helpers.OpenPopup({
        type: 'burgermenu',
        componentState: state,
        listStyle: true,
        noScroll: true,
        pointerDirection: 0,
        elRelative: $event.currentTarget,
        pointerOffset: -15,
      });
    },

    previewPdf(doc, filename){
      let view = this;
      var data = doc.output('blob');

      var reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onloadend = function() {
        var base64data = reader.result.replace(/^data:application\/pdf;base64,/, "");

        view.modalPdfFilename = filename
        view.modalPdfBase64 = base64data;
      }

      this.showModal('modal-pdfpreview');
    },
    closePdfPreview(){
      this.hideModal('modal-pdfpreview');
      console.log('cleaning up after pdf preview close');
      this.modalPdfFilename = '';
      this.modalPdfBase64 = '';
    },
    hideModal(ref) {
      this.$refs[ref].hide()
    },
    showModal(ref) {
      this.$refs[ref].show()
    },
    savePreviewedPdf(){
      let downloadLink = document.createElement("a");
      downloadLink.href = "data:application/pdf;base64," + this.modalPdfBase64;
      downloadLink.download = this.modalPdfFilename;
      downloadLink.click();
    },
    openPreviewedPdf(){
      let url = "data:application/pdf;base64," + this.modalPdfBase64;
      fetch(url)
        .then(response => response.blob())
        .then(blob => {
          let objectURL = URL.createObjectURL(blob);
          window.open(objectURL, "_blank");
        })
        .catch(error => {
          console.error("Error loading PDF:", error);
        });
    },
    addPdfReportHeader(headers, data, fieldKey, fieldName, sums, sumsPositive, sumsNegative){
      if(data[fieldKey]){
        headers.push(fieldName)
        this.resetSums(fieldKey, sums, sumsPositive, sumsNegative);
      }
    },
    resetSums(fieldKey, sums, sumsPositive, sumsNegative)  {
      sums[fieldKey] = 0;
      sumsPositive[fieldKey] = 0;
      sumsNegative[fieldKey] = 0;
    },
    addPdfReportColumnValue(row, data, fieldKey, balance, sums, sumsPositive, sumsNegative, totalSums, totalSumsPositive, totalSumsNegative, divisor, isNumerical){
      if(data[fieldKey]){
        let val = balance[fieldKey];
        if(isNumerical && val != null){
          row.push((val/divisor).toFixed(2));
          sums[fieldKey] += val;
          totalSums[fieldKey] += val;
          val >= 0 ? sumsPositive[fieldKey] += val : sumsNegative[fieldKey] += val;
          val >= 0 ? totalSumsPositive[fieldKey] += val : totalSumsNegative[fieldKey] += val;
        } else {
          row.push( val != null ? val : '-');
        }
      }
    },
    addPdfReportSumValue(sumRow, positiveRow, negativeRow, data, fieldKey, sums, sumsPositive, sumsNegative, divisor, isNumerical){
      if(data[fieldKey]){
        let sumVal = sums[fieldKey];
        let posVal = sumsPositive[fieldKey];
        let negVal = sumsNegative[fieldKey];
        if(isNumerical){
          sumRow.push((sumVal/divisor).toFixed(2));
          positiveRow.push((posVal/divisor).toFixed(2));
          negativeRow.push((negVal/divisor).toFixed(2));
        } else {
          sumRow.push('-');
          positiveRow.push('-');
          negativeRow.push('-');
        }
      }
    },

    generateWorkTimeOverviewPdfReport(){
      let view = this;
      let data = {
        "balances": []
      };

        let fields = [
            { fieldKey: "prevMonthTime", fieldName: this.$t('export.builder.prevMonthBalanceHours') },
            { fieldKey: "prevMonthOverTime", fieldName: this.$t('export.builder.prevMonthLegalOvertime') },
            { fieldKey: "prevMonthHolidayTime", fieldName: this.$t('export.builder.prevMonthHolidayHours') },

            { fieldKey: "workTimeRegular", fieldName: this.$t('export.builder.targetHoursCurrentMonth') },
            { fieldKey: "totalWorkTime", fieldName: this.$t('export.builder.actualHoursCurrentMonth') },
            { fieldKey: "holidayTime", fieldName: this.$t('export.builder.holidayHoursCurrentMonth') },
            { fieldKey: "holidayAdjustmentWorkTime", fieldName: this.$t('export.builder.holidayAdjustmentHoursCurrentMonth') },
            { fieldKey: "overTime", fieldName: this.$t('export.builder.legalOvertimeCurrentMonth') },

            { fieldKey: "calcWorkTimeBalance", fieldName: this.$t('export.builder.balanceHoursCurrentMonth') },
            { fieldKey: "calcHolidayTimeBalance", fieldName: this.$t('export.builder.balanceHolidayCurrentMonth') },
            { fieldKey: "calcOverTimeBalance", fieldName: this.$t('export.builder.balanceLegalOvertimeCurrentMonth') },
            { fieldKey: "vacationTimeBalance", fieldName: this.$t('export.builder.balanceVacationCurrentMonth') },

            { fieldKey: "vacationWorkTime", fieldName: this.$t('export.builder.vacationHoursCurrentMonth') },
            { fieldKey: "sickWorkTime", fieldName: this.$t('export.builder.sickHoursCurrentMonth') },
            { fieldKey: "wageContinuationWorkTime", fieldName: this.$t('export.builder.wageContinuationHoursCurrentMonth') },
            { fieldKey: "nursingVacationWorkTime", fieldName: this.$t('export.builder.careVacationHoursCurrentMonth') },
            { fieldKey: "educationWorkTime", fieldName: this.$t('export.builder.educationHoursCurrentMonth') },
        ];

      // console.log(view.monthlyStatementPerEmployee);

      // prep data
      for (let i in view.monthlyStatementPerEmployee) {
        let statements = view.monthlyStatementPerEmployee[i];
        for (let k in statements) {
          let statement = statements[k];
          for (let l in fields) {
            data[fields[l].fieldKey] = true;
          }
          if (view.previousMonthlyStatementPerEmployee && view.previousMonthlyStatementPerEmployee[statement.remoteId] !== undefined) {
            statement.prevMonth = view.previousMonthlyStatementPerEmployee[statement.remoteId].find(prevStatement => {
              return prevStatement.storeId === statement.storeId;
            });
          }
          data.balances.push(statement);
        }
      }

      let stores = [];
      let storesLabel = "";
      Object.values(view.storesMap).forEach(store => {
        if (view.selectedStores[store.id]) {
          stores.push(store);
          storesLabel += store.name + ", ";
        }
      });
      if (stores.length > 0) {
        storesLabel = storesLabel.substring(0, storesLabel.length - 2);
      }

      let superHeaders = [
        {content: '', colSpan: 1, styles: {halign: 'center', fillColor: [229,21,80]}},
          {
              content: this.$t('export.builder.overviewPreviousMonth'),
              colSpan: 3,
              styles: { halign: 'center', fillColor: [229, 21, 80] }
          },
          {
              content: this.$t('export.builder.overviewHoursCurrentMonth'),
              colSpan: 9,
              styles: { halign: 'center', fillColor: [229, 21, 80] }
          },
          {
              content: this.$t('export.builder.unproductiveHoursCurrentMonth'),
              colSpan: 5,
              styles: { halign: 'center', fillColor: [229, 21, 80] }
          }
      ];
      let subHeaders = [this.$t('global.ui.employee')];
      let totalSums = {};
      let totalSumsPositive = {};
      let totalSumsNegative = {};
      let totalSumRow = [this.$t('export.builder.totalSum')];
      let totalPosRow = [this.$t('export.builder.totalSumPositive')];
      let totalNegRow = [this.$t('export.builder.totalSumNegative')];

      Object.values(fields).forEach((element) => {
        this.addPdfReportHeader(subHeaders, data, element.fieldKey, element.fieldName, totalSums, totalSumsPositive, totalSumsNegative);
      });

      let filename = view.$t('export.builder.workTimeAccount') + '_' + this.timeframeStart.format('YYYY-MM')+'.pdf';
      let body = [];
      let headers = [superHeaders, subHeaders];
      let repDoc = this.$helpers.tableReportDoc(
        subHeaders,
        view.$t('export.builder.workTimeAccount') + ' ' + this.timeframeStart.format('MMMM YYYY'),
        view.$store.state.companyData.label,
        storesLabel,
        this.userFullname,
        9
      );
      let doc = repDoc.doc;
      let contentOffsetY = repDoc.contentOffsetY;
      doc.setFontSize(12);

      let balances = data.balances;
      balances.sort(function(a, b) {
        let ea = view.employeeMap[a.remoteId];
        let eb = view.employeeMap[b.remoteId];

        if(ea != undefined && eb != undefined){
          if(ea.lastName < eb.lastName) return - 1;
          if(ea.lastName > eb.lastName) return 1;
          if(ea.lastName == eb.lastName && ea.firstName < eb.firstName) return - 1;
          if(ea.lastName == eb.lastName && ea.firstName > eb.firstName) return 1;
        }

        return 0;
      });

      for (const [_, bal] of Object.entries(balances)) {
        let sums = {};
        let sumsPositive = {};
        let sumsNegative = {};
        Object.values(fields).forEach((element) => {
          this.resetSums(element.fieldKey, sums, sumsPositive, sumsNegative);
        });

        let employee = view.employeeMap[bal.remoteId];
        if (employee === undefined) {
          continue;
        }
        let cur = [
          employee.lastName + " " + employee.firstName,
        ];

        // calc fields
        bal.prevMonthHolidayTime = bal.prevMonth !== undefined ? parseFloat(bal.prevMonth.holidayTimeBalance) : 0;
        bal.totalWorkTime = parseFloat(bal.workTime) + parseFloat(bal.unproductiveWorkTime);
        bal.calcWorkTimeBalance = parseFloat(bal.prevMonthTime) + parseFloat(bal.totalWorkTime) - parseFloat(bal.workTimeRegular);
        bal.calcHolidayTimeBalance = parseFloat(bal.prevMonthHolidayTime) + parseFloat(bal.holidayTime) - parseFloat(bal.holidayAdjustmentWorkTime);
        bal.calcOverTimeBalance = parseFloat(bal.prevMonthOverTime) + parseFloat(bal.overTime);

        Object.values(fields).forEach((element) => {
          if (element.fieldKey === "vacationTimeBalance") {
            this.addPdfReportColumnValue(cur, data, element.fieldKey, bal, sums, sumsPositive, sumsNegative, totalSums, totalSumsPositive, totalSumsNegative, 60*24, true);
          } else {
            this.addPdfReportColumnValue(cur, data, element.fieldKey, bal, sums, sumsPositive, sumsNegative, totalSums, totalSumsPositive, totalSumsNegative, 60, true);
          }
        });

        body.push(cur);
      }

      Object.values(fields).forEach((element) => {
        if (element.fieldKey === "vacationTimeBalance") {
          this.addPdfReportSumValue(totalSumRow, totalPosRow, totalNegRow, data, element.fieldKey, totalSums, totalSumsPositive, totalSumsNegative, 60*24, true);
        } else {
          this.addPdfReportSumValue(totalSumRow, totalPosRow, totalNegRow, data, element.fieldKey, totalSums, totalSumsPositive, totalSumsNegative, 60, true);
        }
      });

      body.push(totalSumRow);
      body.push(totalPosRow);
      body.push(totalNegRow);

      doc.setProperties({
        title: this.$t('export.builder.exportWorkTimeAccount')
      });

      doc.autoTable(
        {
          startY: contentOffsetY,
          head: headers,
          body: body,
          headStyles: {
            fillColor: [229,21,80],
            fontSize: 7,
            font: 'DistrictPro'
          },
          bodyStyles: {
            fontSize: 7,
            font: 'DistrictPro'
          },
          columnStyles: {
            0: {cellWidth: 48},
            1: {cellWidth: 13},
            2: {cellWidth: 13},
            3: {cellWidth: 13},
            4: {cellWidth: 13},
            5: {cellWidth: 13},
            6: {cellWidth: 13},
            7: {cellWidth: 13},
            8: {cellWidth: 13},
            9: {cellWidth: 13, fontStyle: 'bold'},
            10: {cellWidth: 13, fontStyle: 'bold'},
            11: {cellWidth: 13, fontStyle: 'bold'},
            12: {cellWidth: 13},
            13: {cellWidth: 13},
            14: {cellWidth: 13},
            15: {cellWidth: 13},
            16: {cellWidth: 13},
            17: {cellWidth: 13},
          },
          didParseCell: (data) => {
            if (data.section === 'body' && data.cell.raw !== undefined && data.cell.raw.includes(this.$t('export.builder.sum'))) {
              data.cell.styles.fontStyle = 'bold';
            }
            if (data.section === 'body' && data.cell.raw !== undefined && data.row.cells[1].raw === undefined) {
              data.cell.styles.fontStyle = 'bold';
            }
          },
          didDrawCell: (data) => {
            if (data.section === 'body' && (data.column.index === 0 || data.column.index === 3 || data.column.index === 12)) {
              const columnWidth = data.cell.width
              const rowHeight = data.cell.height;
              data.doc.setLineWidth(1.0);
              data.doc.line(data.cursor.x + columnWidth, data.cursor.y, data.cursor.x + columnWidth, data.cursor.y + rowHeight);
            }
          }
        }
    );

      this.previewPdf(doc, filename);
    },

    // sync settings
    loadExportSettings(mode) {
      let view = this;

      let url = "/api/sec/bmd/exports/settings/" + mode;
      if (mode == "individual-wagetypes") {
        // console.log("loading individual wage types export settings");
        url = "/api/sec/iwt/exports/settings"
      }

      view.baseSettings = JSON.parse(JSON.stringify(view.baseSettingsTemplate));
      view.sExportSettings = [];

      view.$helpers.GetCall(url).then((response) => {
        if (response.data) {
          view.baseSettings.enableExportViaTransferService = response.data.enableExportViaTransferService;
          view.baseSettings.enablePeriodicExport = response.data.enablePeriodicExport;
          view.baseSettings.enableMonthlyClosingExport = response.data.enableMonthlyClosingExport;
          view.baseSettings.openSettingsPageDefault = response.data.openSettingsPageDefault;
          view.baseSettings.periodicExportTimes = response.data.periodicExportTimes;
          view.baseSettings.monthlyClosingExportSettings = response.data.monthlyClosingExportSettings ? response.data.monthlyClosingExportSettings : [];
          // set default for new property monthlyClosingRequired
          view.baseSettings.periodicExportTimes.forEach(time => {
            if (!time.hasOwnProperty("monthlyClosingRequired")) {
              time.monthlyClosingRequired = false;
            }
            if (!time.hasOwnProperty("months")) {
              time.months = [1,2,3,4,5,6,7,8,9,10,11,12];
            }
          });
          view.sExportSettings = response.data.exportSettings;
          view.sExportSettings.forEach(setting => {
            if (!setting.hasOwnProperty('locked')) {
              setting.locked = false;
            }
            // console.log("setting", setting);
            if (mode == "individual-wagetypes") {
              // add potentially missing additional fields
              if (!setting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === 'zeroValuesAdditional')) {
                setting.availableFieldsIndividualWageTypesListAdditional.push({
                  key: "zeroValuesAdditional",
                    name: this.$t('export.builder.zeroValuesAdditional'),
                    item: {
                        key: 0,
                        label: this.$t('export.builder.doNotExportZeroValues')
                    },
                  checked: true,
                });
              }
              if (!setting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === 'absencesAdditional')) {
                setting.availableFieldsIndividualWageTypesListAdditional.push({
                  key: "absencesAdditional",
                    name: this.$t('export.builder.absencesAdditional'),
                    item: {
                        key: 0,
                        label: this.$t('export.builder.standard')
                    },
                  checked: true,
                });
              }
              if (!setting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === 'shiftsAdditional')) {
                setting.availableFieldsIndividualWageTypesListAdditional.push({
                  key: "shiftsAdditional",
                    name: this.$t('export.builder.shiftsAdditional'),
                    item: {
                        key: 2,
                        label: this.$t('export.builder.exportActualShifts')
                    },
                  checked: true,
                });
              }
              if (!setting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === 'calcModeAdditional')) {
                setting.availableFieldsIndividualWageTypesListAdditional.push({
                  key: "calcModeAdditional",
                    name: this.$t('export.builder.calcModeAdditional'),
                    item: {
                        key: 1,
                        label: this.$t('export.builder.calcModeCurrentDay')
                    },
                  checked: true,
                });
              }
              if (!setting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === 'deltaAdditional')) {
                setting.availableFieldsIndividualWageTypesListAdditional.push({
                  key: "deltaAdditional",
                    name: this.$t('export.builder.deltaAdditional'),
                    item: {
                        key: 1,
                        label: this.$t('export.builder.ignoreLastExportValues')
                    },
                  checked: true,
                });
              }
              if (!setting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === 'processingKeyAdditionalHours')) {
                setting.availableFieldsIndividualWageTypesListAdditional.push({
                  key: "processingKeyAdditionalHours",
                  name: this.$t('export.builder.processingKeyAdditionalHours'),
                  fixedValue: "1",
                  checked: true,
                });
              }
              if (!setting.availableFieldsIndividualWageTypesListAdditional.find(f => f.key === 'processingKeyAdditionalValue')) {
                setting.availableFieldsIndividualWageTypesListAdditional.push({
                  key: "processingKeyAdditionalValue",
                  name: this.$t('export.builder.processingKeyAdditionalValue'),
                  fixedValue: "3",
                  checked: true,
                });
              }
            }
            // add potentially missing fields
            // console.log("setting.availableFields", setting.availableFields);
            if (mode == "individual-wagetypes") {
              if (!setting.availableFields.find(f => f.key === 'costCenter')) {
                setting.availableFields.push({
                  key: "costCenter",
                  name: this.$t('export.builder.employeeCostCenter'),
                  newName: this.$t('comp.ui.costCenter'),
                  checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
              if (!setting.availableFields.find(f => f.key === 'storeCostCenter')) {
                setting.availableFields.push({
                  key: "storeCostCenter",
                    name: this.$t('export.builder.storeCostCenter'),
                    newName: this.$t('export.builder.storeCostCenter'),
                    checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
              if (!setting.availableFields.find(f => f.key === 'taxId')) {
                setting.availableFields.push({
                  key: "taxId",
                    name: this.$t('export.builder.taxId'),
                    newName: this.$t('export.builder.taxId'),
                    checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
              if (!setting.availableFields.find(f => f.key === 'factor')) {
                setting.availableFields.push({
                  key: "factor",
                  name: this.$t('export.builder.wageRate'),
                  newName: this.$t('export.builder.wageRate'),
                  checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
              if (!setting.availableFields.find(f => f.key === 'hours')) {
                setting.availableFields.push({
                  key: "hours",
                  name: this.$t('export.builder.workHours'),
                  newName: this.$t('export.builder.workHours'),
                  checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
              if (!setting.availableFields.find(f => f.key === 'days')) {
                setting.availableFields.push({
                  key: "days",
                  name: this.$t('export.builder.days'),
                  newName: this.$t('export.builder.days'),
                  checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
              if (!setting.availableFields.find(f => f.key === 'daysCalculated')) {
                setting.availableFields.push({
                  key: "daysCalculated",
                  name: this.$t('export.builder.daysCalculated'),
                  newName: this.$t('export.builder.daysCalculated'),
                  checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
              if (!setting.availableFields.find(f => f.key === 'payment')) {
                setting.availableFields.push({
                  key: "payment",
                  name: this.$t('employee.comp.amount'),
                  newName: this.$t('employee.comp.amount'),
                  checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
              if (!setting.availableFields.find(f => f.key === 'year')) {
                setting.availableFields.push({
                  key: "year",
                  name: this.$t('employee.comp.year'),
                  newName: this.$t('employee.comp.year'),
                  checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
              if (!setting.availableFields.find(f => f.key === 'day')) {
                setting.availableFields.push({
                  key: "day",
                  name: "Tag",
                  newName: "Tag",
                  checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
              if (!setting.availableFields.find(f => f.key === 'unavailabilityCode')) {
                setting.availableFields.push({
                  key: "unavailabilityCode",
                  name: view.$t('settings.wage.absenceCode'),
                  newName: view.$t('settings.wage.absenceCode'),
                  checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
              if (!setting.availableFields.find(f => f.key === 'processingKey')) {
                setting.availableFields.push({
                  key: "processingKey",
                  name: this.$t('export.builder.processingKey'),
                  newName: this.$t('export.builder.processingKey'),
                  checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
              if (!setting.availableFields.find(f => f.key === 'date2')) {
                setting.availableFields.push({
                  key: "date2",
                  name: this.$t('export.builder.date2'),
                  newName: this.$t('export.builder.date2'),
                  checked: false,
                  fieldOrder: setting.availableFields.length + 1
                });
              }
            }
            // add potentially missing field settings
            if (mode == "individual-wagetypes") {
              if (!setting.availableFieldsAdditional.find(f => f.key == 'externalEmployeeIdAdditional')) {
                setting.availableFieldsAdditional.push({
                  key: "externalEmployeeIdAdditional",
                  name: this.$t('comp.ui.employeeId'),
                  item: {
                    "key": 0,
                    "label": this.$t('export.builder.applyWithoutChange')
                  },
                  checked: true,
                });
              }
            }

            // add potentially missing wage type settings
            if (mode == "individual-wagetypes") {
              setting.selectedWageTypes.forEach(wt => {
                if (!wt.hasOwnProperty("printPaidValue")) {
                  this.$set(wt, 'printPaidValue', true);
                }
                if (!wt.hasOwnProperty("printHours")) {
                  this.$set(wt, 'printHours', true);
                }
                if (!wt.hasOwnProperty("printDays")) {
                  this.$set(wt, 'printDays', true);
                }
                if (!wt.hasOwnProperty("printDaysCalculated")) {
                  this.$set(wt, 'printDaysCalculated', true);
                }
                if (!wt.hasOwnProperty("printFactor")) {
                  this.$set(wt, 'printFactor', true);
                }
                if (!wt.hasOwnProperty("printPayment")) {
                  this.$set(wt, 'printPayment', true);
                }
              });
            }

            setting.availableFields.filter(f => f.key && f.key.startsWith("placeholder")).forEach(f => {
              if (!f.hasOwnProperty("fixedValue")) {
                f.fixedValue = "";
              }
              if (!f.hasOwnProperty("deleteable")) {
                f.deleteable = true;
              }
              f.deleteFunction = () => {
                let currentFieldOrder = setting.availableFields.find(a => a.key == f.key).fieldOrder;
                if (setting.locked) {
                  view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
                  return;
                }
                view.updateFieldOrder(setting, currentFieldOrder, 100);
                setting.availableFields = setting.availableFields.filter(a => a.key != f.key);
                view.settingsUpdated = true;
              }
            });

            // sort availableFields by fieldOrder if available (IWT)
            if (setting.availableFields.length > 0 && setting.availableFields[0].hasOwnProperty('fieldOrder')) {
              setting.availableFields.sort((a, b) => a.fieldOrder - b.fieldOrder);
            }
          });

          console.log("sExportSettings", view.sExportSettings);
        }
        view.baseSettingsBackup = JSON.parse(JSON.stringify(view.baseSettings));
        view.sExportSettingsBackup = JSON.parse(JSON.stringify(view.sExportSettings));
        view.selectedSettingsId = view.sExportSettings.length > 0 ? view.sExportSettings[0].id : null;
      });
    },
    putExportSettings(mode, successmessage, errormessage) {
      let view = this;

      let url = "/api/sec/bmd/exports/settings/" + mode;
      if (mode == "individual-wagetypes") {
        url = "/api/sec/iwt/exports/settings"
      }
      let payload = {
        "enableExportViaTransferService": view.baseSettings.enableExportViaTransferService,
        "enablePeriodicExport": view.baseSettings.enablePeriodicExport,
        "enableMonthlyClosingExport": view.baseSettings.enableMonthlyClosingExport,
        "openSettingsPageDefault": view.baseSettings.openSettingsPageDefault,
        "periodicExportTimes": view.baseSettings.periodicExportTimes,
        "monthlyClosingExportSettings": view.baseSettings.monthlyClosingExportSettings,
        "exportSettings": view.sExportSettings
      };
      return view.$helpers.EditCall(url, payload, null, successmessage, null, errormessage);
    },
    putOpenSettingsPageDefault(mode) {
      let view = this;
      let url = "/api/sec/bmd/exports/settings/" + mode + "/pinExportSettings";
      if (mode == "individual-wagetypes") {
        url = "/api/sec/iwt/exports/settings/pinExportSettings"
      }
      let payload = {
        "openSettingsPageDefault": view.baseSettings.openSettingsPageDefault
      };
      let successmessage = {
        title: this.$t('global.ui.success'),
        message: view.baseSettings.openSettingsPageDefault ? this.$t('export.builder.exportSettingsPinned') : this.$t('export.builder.exportSettingsUnpinned')
      };
      let errormessage = {
        title: view.$t('global.messages.error'),
        message: this.$t('export.builder.errorChangingPinSetting')
      };
      let errorCallback = (error) => {
        view.baseSettings.openSettingsPageDefault = !view.baseSettings.openSettingsPageDefault;
      }
      return view.$helpers.EditCall(url, payload, null, successmessage, errorCallback, errormessage);
    },
    getPeriodicTimeTypeInputs(type, selectedValues=null) {
      switch(type) {
        case 1: return [
          { label: this.$t('global.time.sundays'), value: 0, selected: selectedValues ? (Array.isArray(selectedValues) ? selectedValues.includes(0) : selectedValues === 0) : false },
          { label: this.$t('global.time.mondays'), value: 1, selected: selectedValues ? (Array.isArray(selectedValues) ? selectedValues.includes(1) : selectedValues === 1) : false },
          { label: this.$t('global.time.tuesdays'), value: 2, selected: selectedValues ? (Array.isArray(selectedValues) ? selectedValues.includes(2) : selectedValues === 2) : false },
          { label: this.$t('global.time.wednesdays'), value: 3, selected: selectedValues ? (Array.isArray(selectedValues) ? selectedValues.includes(3) : selectedValues === 3) : false },
          { label: this.$t('global.time.thursdays'), value: 4, selected: selectedValues ? (Array.isArray(selectedValues) ? selectedValues.includes(4) : selectedValues === 4) : false },
          { label: this.$t('global.time.fridays'), value: 5, selected: selectedValues ? (Array.isArray(selectedValues) ? selectedValues.includes(5) : selectedValues === 5) : false },
          { label: this.$t('global.time.saturdays'), value: 6, selected: selectedValues ? (Array.isArray(selectedValues) ? selectedValues.includes(6) : selectedValues === 6) : false }
        ];
        case 2:
          let items = [];
          for (let i = 0; i <= 30; i++) {
            items.push({ label: this.$t('global.time.dayOfMonth', { day: i + 1 }), value: i, selected: selectedValues ? (Array.isArray(selectedValues) ? selectedValues.includes(i) : selectedValues === i) : false});
          }
          items.push({ label: this.$t('global.time.lastDayOfMonth'), value: 31, selected: selectedValues ? (Array.isArray(selectedValues) ? selectedValues.includes(31) : selectedValues === 31) : false});
          return items;
        default: return [];
      }
    },
    getPeriodicTimeLabel(time) {
      let view = this;
      let values = view.getPeriodicTimeTypeInputs(time.type);
      let label = "";

      let hours = parseInt(time.hours);
      if (hours > 23) {
        time.hours = 23;
      } else if (hours < 10) {
        time.hours = "0" + hours;
      } else {
        time.hours = hours;
      }

      let minutes = parseInt(time.minutes);
      if (minutes > 59) {
        time.minutes = 59;
      } else if (minutes < 10) {
        time.minutes = "0" + minutes;
      } else {
        time.minutes = minutes;
      }

      switch (time.type) {
        case 0: return time.hours + ":" + time.minutes;
        case 1:
          if (Array.isArray(time.dayOfWeek)) {
            if (time.dayOfWeek.length > 1) {
              label = this.$t('export.builder.onDays', { count: time.dayOfWeek.length });
            } else {
              label = values[time.dayOfWeek[0]].label;
            }
          } else {
            label = values[time.dayOfWeek].label;
          }
          break;
        case 2:
          if (Array.isArray(time.dayOfMonth)) {
            if (time.dayOfMonth.length > 1) {
              label = this.$t('export.builder.onDays', { count: time.dayOfMonth.length });
            } else {
              label = values[time.dayOfMonth[0]].label;
            }
          } else {
            label = values[time.dayOfMonth].label;
          }
            label += (time.months.length === 12 ? "" : (time.months.length > 1
                ? " " + this.$t('export.builder.inMonths', {count: time.months.length})
                : " " + this.$t('export.builder.inMonth', {
                month: view.months.find(month => month.value === time.months[0]).label
            })));
          break;
      }
      return label + " " + this.$t('export.builder.at') + " " + time.hours + ":" + time.minutes;
    },
    getMonthlyClosingSettingMonths(time) {
      let view = this;

      if (time.months.length === 12) {
        return "Jedes Monat";
      } else {
        let label = "";
        view.months.forEach((month) => {
          if (time.months.includes(month.value)) {
            label += month.label + ", ";
          }
        });
        return label.substring(0, label.length - 2);
      }
    },
    setExportSettingId(id) {
      // console.log("selectedSettingsId updated");
      let currentSetting = this.sExportSettings.find(e => e.id === id);
      if (currentSetting && currentSetting.availableFields && currentSetting.availableFields.length > 0
        && currentSetting.availableFields[0].hasOwnProperty("fieldOrder") && this.sExportSettings.find(e => e.id === this.selectedSettingsId)) {
          // console.log("sorting...");
          this.sExportSettings.find(e => e.id === this.selectedSettingsId).availableFields.sort((a, b) => a.fieldOrder - b.fieldOrder);
          // console.log(currentSetting.availableFields);
      }

      this.selectedSettingsId = id;
    },
    createExportTemplate(isPerStore = false) {
      let view = this;

      let wageTypes = view.content.map(wt => { return { id: wt.id, selectedValue: wt.selectedValue, printPaidValue: true, printHours: true, printDays: true, printDaysCalculated: true, printFactor: true, printPayment: true }; });
      let employmentModels = view.employmentModelArray.map(em => em.id);

      let exportTemplates = view.$helpers.createExportTemplate(view.softwareId, isPerStore ? view.stores : [], wageTypes, employmentModels);
      // console.log(exportTemplate);

      // reapply delete functions for placeholders
      exportTemplates.forEach(template => {
        template.availableFields.filter(f => f.key && f.key.startsWith("placeholder")).forEach(f => {
          f.deleteFunction = () => {
            let currentSetting = view.sExportSettings.find(s => s.id === view.selectedSettingsId);
            let currentFieldOrder = currentSetting.availableFields.find(a => a.key == f.key).fieldOrder;
            if (currentSetting.locked) {
              view.$helpers.warning(view.$t('export.builder.warning'), view.$t('export.builder.settingsLocked'));
              return;
            }
            view.updateFieldOrder(currentSetting, currentFieldOrder, 100);
            currentSetting.availableFields = currentSetting.availableFields.filter(a => a.key != f.key);
            view.settingsUpdated = true;
          }
        });
      });

      view.sExportSettings.push(...exportTemplates);
      view.selectedSettingsId = exportTemplates.length > 0 ? exportTemplates[0].id : view.selectedSettingsId;
      view.settingsUpdated = true;
    },
    openEditSettingsPopup() {
      let view = this;
      let setting = view.sExportSettings.find(s => s.id === view.selectedSettingsId);

      let dataEntries = [
          {label: view.$t('settings.groups.name'), key: 'name', hidden: false, type: 'text', value: setting.name},
          {label: view.$t('export.builder.lockSetting'), key: 'locked', hidden: false, type: 'bool', value: setting.locked},
      ];
      this.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        pointerDirection: 0,
        componentState: {
          positiveButtonLabel: this.$t('employee.data.save'),
          entries: dataEntries,
          selectCallback: function (entity) {
            setting.name = entity.name;
            setting.locked = entity.locked;
            view.settingsUpdated = true;
            view.$forceUpdate();
          },
          negativeButtonLabel: view.$t('settings.notes.delete'),
          deleteCallback: function (entity) {
            if (view.baseSettings.enablePeriodicExport && view.baseSettings.enableExportViaTransferService && view.baseSettings.periodicExportTimes.find(t => t.exportId === view.selectedSettingsId)) {
              view.$helpers.warning(view.$t('export.builder.warning'), this.$t('export.builder.exportSettingUsedInPeriodic'));
            } else if (view.baseSettings.enableMonthlyClosingExport && view.baseSettings.enableExportViaTransferService && view.baseSettings.monthlyClosingExportSettings.find(t => t.exportId === view.selectedSettingsId)) {
              view.$helpers.warning(view.$t('export.builder.warning'), this.$t('export.builder.exportSettingUsedAfterMonthEnd'));
            } else {
              let index = view.sExportSettings.indexOf(setting);
              view.sExportSettings.splice(index, 1);
              view.selectedSettingsId = view.sExportSettings.length > 0 ? view.sExportSettings[0].id : null;
              view.settingsUpdated = true;
            }
          },
          errorCheck: {
          }
        },
        header: view.$t('export.builder.editExportSetting'),
        remainAfterSelect: false,
        centered: true,
        expanded: true,
      });
    },
    openCreateNewSettingsPopup() {
      let view = this;
      let dataEntries = [
          {label: view.$t('settings.groups.name'), key: 'name', hidden: false, type: 'text', value: ''},
      ];
      this.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        pointerDirection: 0,
        componentState: {
          positiveButtonLabel: view.$t('export.builder.create'),
          entries: dataEntries,
          selectCallback: function (entity) {
            let element = {
              id: crypto.randomUUID(),
              name: entity.name,
              locked: false,
              availableFields: [],
              availableFieldsAdditional: [],
              selectedStores: [],
              selectedWageTypes: [],
              selectedEmploymentModels: [],
              availableFieldsIndividualWageTypesListAdditional: [],
            };
            if (view.$parent.mode === "individual-wagetypes") {
              element.availableFields = JSON.parse(JSON.stringify(view.availableFields));
              element.availableFieldsAdditional = JSON.parse(JSON.stringify(view.availableFieldsAdditional));
              element.availableFieldsIndividualWageTypesListAdditional = JSON.parse(JSON.stringify(view.availableFieldsIndividualWageTypesListAdditional));
            }
            console.log(view.sExportSettings);
            view.sExportSettings.push(element);
            view.selectedSettingsId = element.id;
            view.settingsUpdated = true;
          },
          errorCheck: {
            'name': (entries) => {
              if (!entries.hasOwnProperty('name') || entries.name === '') {
                return {
                  key: 'name',
                  label: view.$t('settings.groups.name'),
                  type: 'error',
                  text: view.$t('settings.wage.mustBeProvided')
                }
              } else {
                return null;
              }
            }
          }
        },
        header: view.$t('export.builder.createExportSetting'),
        remainAfterSelect: false,
        centered: true,
        expanded: true,
      });
    },
    openImportSettingsFromCompanySelect() {
      let view = this;

      let items = Object.values(this.companyArray).filter(c => ""+c.id !== ""+this.companyId).map((company) => {
              return {
                value: company.id,
                label: company.name,
              };
            });

      let dataEntries = [
        {
          label: view.$t('export.builder.company'),
          key: "companyId",
          hidden: false,
          type: "dropdownsearch",
          styles: { width: "500px" },
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: "",
            items: items,
            selectMultiple: false,
            selectedItems: [],
            selectedItem: items && items.length > 0 ? items[0] : null,
            onceSelected: function ($event, item, searchbar) {},
            styleLight: true,
            placeholder: view.$t('settings.help.pleaseSelect'),
          },
          value: null,
        },
      ];


      view.$helpers.OpenPopup({
        elRelative: null,
        type: "datafill",
        pointerDirection: 0,
        componentState: {
          entries: dataEntries,
          selectCallback: function (entity) {
            view.openImportSettingsFromCompany(entity.companyId);
          },
          errorCheck: {
            companyId: (entries) => {
              if (entries.companyId == null) {
                let key = "companyId";
                let label = dataEntries.find((f) => f.key === key) ? dataEntries.find((f) => f.key === key).label : "";
                return {
                  key: key,
                  label: label,
                  type: "error",
                  text: view.$t('settings.wage.pleaseSelect'),
                };
              } else {
                return null;
              }
            }
          },
        },
        header: view.$t('settings.wage.selectCompanyForImport'),
        remainAfterSelect: false,
        centered: true,
        expanded: true,
      });
    },
    openImportSettingsFromCompany(companyId) {
      let view = this;

      view.showModal('modal-loading');
      view.loadSettingsFromCompany(companyId)
      .then((response) => {
        view.hideModal('modal-loading');

        let importedSettings = response.exportSettings ? response.exportSettings.map((es) => {
          return {
            value: es,
            label: es.name
          };
        }) : [];

        let dataEntries = [
          {
            label: view.$t('export.builder.exportSetting'),
            key: "exportSetting",
            hidden: false,
            type: "dropdownsearch",
            styles: { width: "500px" },
            dropdownSearchState: {
              toggled: false,
              displayedItems: [],
              input: "",
              items: importedSettings,
              selectMultiple: true,
              selectedItems: [],
              selectedItem: null,
              onceSelected: function ($event, item, searchbar) {},
              styleLight: true,
              placeholder: view.$t('settings.help.pleaseSelect'),
            },
            value: null,
          },

        ];


        view.$helpers.OpenPopup({
          elRelative: null,
          type: "datafill",
          pointerDirection: 0,
          componentState: {
            entries: dataEntries,
            selectCallback: function (entity) {
              let selectedSettings = entity.exportSetting.map((es) => {
                let newSetting = JSON.parse(JSON.stringify(es));
                // console.log(newSetting);
                newSetting.id = crypto.randomUUID();
                // newSetting.name = es.name + " (Import)";
                newSetting.locked = false;
                newSetting.selectedStores = [];
                newSetting.selectedEmploymentModels = [];
                if (view.$parent.mode === "individual-wagetypes") {
                  newSetting.selectedWageTypes = [];
                }
                return newSetting;
              });
              view.sExportSettings = view.sExportSettings.concat(selectedSettings);
              view.settingsUpdated = true;
            },
            errorCheck: {
              'exportSetting': (entries) => {
                if (!entries.hasOwnProperty('exportSetting') || entries.exportSetting.length === 0) {
                  return {
                    key: 'exportSetting',
                    label: $t('export.builder.exportSetting'),
                    type: 'error',
                    text: view.$t('settings.wage.mustBeProvided')
                  }
                } else {
                  return null;
                }
              }
            },
          },
          header: view.$t('export.builder.importExportSetting'),
          remainAfterSelect: false,
          centered: true,
          expanded: true,
        });
      })
      .catch((error) => {
        view.hideModal('modal-loading');
        view.$helpers.error(view.$t('global.messages.error'), view.$t('settings.wage.bonusSettingsLoadFailed'));
        console.log(error);
      });
    },
    loadSettingsFromCompany: function (companyId) {
      let view = this;
      let url = "/api/sec/bmd/exports/settings/" + this.$parent.mode + "/getForCompany";
      if (this.$parent.mode == "individual-wagetypes") {
        url = "/api/sec/iwt/exports/settings/getForCompany";
      }
      let params = {
        foreignCompanyId: companyId,
      };
      return view.$helpers
        .GetCall(url, params)
        .then((response) => {
          let data = response.data;
          let tmp = [];
          // console.log(data);
          return data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    copyCurrentExportSettings: function() {
      let view = this;
      let setting = view.sExportSettings.find(s => s.id === view.selectedSettingsId);

      if (setting) {
        let newSetting = JSON.parse(JSON.stringify(setting));
        newSetting.id = crypto.randomUUID();
        newSetting.name = setting.name + " (" + view.$t('export.builder.copyName') + ")";
        newSetting.locked = false;
        view.sExportSettings.push(newSetting);
        view.selectedSettingsId = newSetting.id;
        view.settingsUpdated = true;
      }
    },

    setDeltaCalculationFlag: function(individualWageTypeExportId, useForDeltaCalculation) {
      let view = this;
      let url = "/api/sec/iwt/exports/setDeltaCalculationFlag";
      let payload = {
        individualWageTypeExportId: individualWageTypeExportId,
        useForDeltaCalculation: useForDeltaCalculation
      };
      return view.$helpers.EditCall(url, payload, null, null, null, null);
    },


    openEditPeriodicTimePopup(time, newEntry=false) {
      let view = this;

      let exportSettingItems = view.sExportSettings.map(s => {
        return {value: s.id, label: s.name};
      });
      let months = view.months.map(value => {
        return {value: value.value, label: value.label, selected: time.months.includes(value.value)};
      });

      let dataEntries = [
        {label: 'placeholder', key: 'placeholder', hidden: true, type: 'text', value: 'placeholder'},
        {
          label: view.$t('export.builder.setting'),
          key: 'exportId',
          hidden: false,
          type: 'dropdownsearch',
          value: time != null ? time.exportId : null,
          flexGroup: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: exportSettingItems,
            selectMultiple: false,
            selectedItems: [],
            selectedItem: exportSettingItems.find(s => s.value === time.exportId),
            onceSelected: function ($event, item, searchbar) {
            },
            styleLight: true,
            placeholder: view.$t('export.builder.selectSetting')
          }
        },
        {
          label: view.$t('export.builder.selectSetting'),
          key: 'exportMonth',
          hidden: false,
          type: 'dropdownsearch',
          value: time != null ? time.exportMonth : null,
          flexGroup: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: view.periodicExportTimeReportMonth,
            selectMultiple: false,
            selectedItems: [],
            selectedItem: view.periodicExportTimeReportMonth.find(s => s.value === time.exportMonth),
            onceSelected: function ($event, item, searchbar) {
            },
            styleLight: true,
            placeholder: view.$t('export.builder.selectExportMonth')
          }
        },
        {
          label: view.$t('export.builder.timePeriod'),
          key: 'type',
          hidden: false,
          type: 'dropdownsearch',
          value: time != null ? time.type : null,
          flexGroup: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: view.periodicExportTimeTypes,
            selectMultiple: false,
            selectedItems: [],
            selectedItem: view.periodicExportTimeTypes.find(s => s.value === time.type),
            onceSelected: function ($event, item, searchbar) {
            },
            styleLight: true,
            placeholder: view.$t('export.builder.selectTimePeriod')
          }
        },
        {
          label: view.$t('export.builder.monthSelection'),
          key: 'months',
          hidden: time != null ? time.type !== 2 : false,
          type: 'dropdownsearch',
          value: null,
          flexGroup: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: months,
            selectMultiple: true,
            selectedItems: [],
            selectedItem: null,
            onceSelected: function ($event, item, searchbar) {
            },
            styleLight: true,
            placeholder: view.$t('export.builder.selectMonths')
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let type = datafill.entries.find((i) => i.key === "type");
            let monthType = type.value === 2;
            entryBeforeUpdate.hidden = !monthType;
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('export.builder.dayOfMonth'),
          key: 'dayOfMonth',
          hidden: time != null ? time.type !== 2 : false,
          type: 'dropdownsearch',
          value: null,
          flexGroup: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: view.getPeriodicTimeTypeInputs(2, time.dayOfMonth),
            selectMultiple: true,
            selectedItems: [],
            selectedItem: [],
            onceSelected: function ($event, item, searchbar) {
            },
            styleLight: true,
            placeholder: view.$t('export.builder.selectDay')
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let type = datafill.entries.find((i) => i.key === "type");
            let monthType = type.value === 2;
            entryBeforeUpdate.hidden = !monthType;
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('export.builder.weekday'),
          key: 'dayOfWeek',
          hidden: time != null ? time.type !== 1 : false,
          type: 'dropdownsearch',
          value: null,
          flexGroup: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: view.getPeriodicTimeTypeInputs(1, time.dayOfWeek),
            selectMultiple: true,
            selectedItems: [],
            selectedItem: [],
            onceSelected: function ($event, item, searchbar) {
            },
            styleLight: true,
            placeholder: view.$t('export.builder.selectDay')
          },
          computed: (datafill, lastVal, entryBeforeUpdate) => {
            let type = datafill.entries.find((i) => i.key === "type");
            let monthType = type.value === 1;
            entryBeforeUpdate.hidden = !monthType;
            return entryBeforeUpdate;
          },
        },
        {
          label: view.$t('export.builder.exportTime'),
          key: 'timeframe',
          hidden: false,
          type: 'timeframe',
          value: view.$helpers.getMomentFromStringUTC("2024-01-01T" + time.hours + ":" + time.minutes + "Z"),
          flexGroup: false,
        },
        {
          label: 'Nur bei abgeschlossenem Monat exportieren',
          key: 'monthlyClosingRequired',
          hidden: false,
          type: 'bool',
          value: time.monthlyClosingRequired,
          flexGroup: false,
        },
      ];
      this.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        pointerDirection: 0,
        componentState: {
          positiveButtonLabel: "Übernehmen",
          entries: dataEntries,
          selectCallback: function (entity) {
            time.exportId = entity.exportId;
            time.exportMonth = entity.exportMonth;
            time.type = entity.type;
            time.months = entity.months;
            time.dayOfMonth = entity.dayOfMonth;
            time.dayOfWeek = entity.dayOfWeek;
            time.monthlyClosingRequired = entity.monthlyClosingRequired;
            time.hours = entity.timeframe.format('HH');
            time.minutes = entity.timeframe.format('mm');
            if (newEntry) {
              view.baseSettings.periodicExportTimes.push(time);
            }
            view.settingsUpdated = true;
          },
          errorCheck: {}
        },
        header: 'Periodische Exportzeit bearbeiten',
        remainAfterSelect: false,
        centered: true,
        expanded: true,
      });
    },
    openEditMonthlyClosingExportPopup(time, newEntry=false) {
      let view = this;

      let exportSettingItems = view.sExportSettings.map(s => {
        return {value: s.id, label: s.name};
      });
      let months = view.months.map(value => {
        return {value: value.value, label: value.label, selected: time.months.includes(value.value)};
      });

      let dataEntries = [
        {label: 'placeholder', key: 'placeholder', hidden: true, type: 'text', value: 'placeholder'},
        {
          label: view.$t('export.builder.setting'),
          key: 'exportId',
          hidden: false,
          type: 'dropdownsearch',
          value: time != null ? time.exportId : null,
          flexGroup: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: exportSettingItems,
            selectMultiple: false,
            selectedItems: [],
            selectedItem: exportSettingItems.find(s => s.value === time.exportId),
            onceSelected: function ($event, item, searchbar) {
            },
            styleLight: true,
            placeholder: view.$t('export.builder.selectSetting')
          }
        },
        {
          label: view.$t('export.builder.monthSelection'),
          key: 'months',
          hidden: false,
          type: 'dropdownsearch',
          value: null,
          flexGroup: false,
          dropdownSearchState: {
            toggled: false,
            displayedItems: [],
            input: '',
            items: months,
            selectMultiple: true,
            selectedItems: [],
            selectedItem: null,
            onceSelected: function ($event, item, searchbar) {
            },
            styleLight: true,
            placeholder: view.$t('export.builder.selectMonths')
          },
        },
      ];
      this.$helpers.OpenPopup({
        elRelative: null,
        type: 'datafill',
        pointerDirection: 0,
        componentState: {
          positiveButtonLabel: "Übernehmen",
          entries: dataEntries,
          selectCallback: function (entity) {
            time.exportId = entity.exportId;
            time.months = entity.months;
            if (newEntry) {
              view.baseSettings.monthlyClosingExportSettings.push(time);
            }
            view.settingsUpdated = true;
          },
          errorCheck: {}
        },
        header: 'Export nach Monatsabschluss bearbeiten',
        remainAfterSelect: false,
        centered: true,
        expanded: true,
      });
    },


    downloadCSVFromExportJob(csv, date, filename) {
      let view = this;
      if (!filename) {
        filename = 'Export_' + date + '.csv';
      }
      view.$helpers.forceFileDownload(view.$helpers.b64DecodeUnicode(csv), filename);
    },
    openCreatePdfFromExportJob(bmdExport) {
      let view = this;

      let selectCallback = function (entity) {
        localStorage.setItem(this.$store.state.companyId + "_settings_sotecDashboard_pdfOptions", JSON.stringify(entity));

        bmdExport.options = entity;
        bmdExport.storeIds = view.storeArray.map((store) => store.id);
        bmdExport.exportJson = JSON.parse(bmdExport.exportJson);

        if (!bmdExport.exportJson) {
          view.$helpers.error(view.$t('global.messages.error'), "Export enthält keine Daten.");
        } else {
          view.$refs["modal-loading"].show();
          entity.exportJson = bmdExport.exportJson;

          view.$helpers.getIndividualWageTypeExportPdfReport(bmdExport)
          .then((response) => {
            view.$refs["modal-loading"].hide();
            console.log(response);

            view.modalPdfFilename = "IndividualWageTypeExport_" + bmdExport.month + "_" + bmdExport.year + ".pdf";
            view.modalPdfBase64 = response.data.data;

            view.showModal('modal-pdfpreview');

          })
          .catch((error) => {
            view.$refs["modal-loading"].hide();
            view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.errorGeneratingPdfReport'));
            console.log(error);
          });
        }
      };

      view.$helpers.openCreateIndividualWageTypeExportPdfPopup(view.employmentModelArray, view.content, selectCallback);
    },
    openCreatePdfFromExportJson(json, month = null, year = null) {
      let view = this;

      let exportObject = {};
      exportObject.exportJson = JSON.parse(json);
      exportObject.month = month == null ? view.selectedDate.format("M") : month;
      exportObject.year = year == null ? view.selectedDate.format("YYYY") : year;
      exportObject.created_at = view.currentCreateDate.format("YYYY-MM-DDTHH:mm:ssZ");
      exportObject.storeIds = Object.entries(view.selectedStores).filter(([key,value]) => value).map(([key,value]) => parseInt(key));

      let selectCallback = function (entity) {
        localStorage.setItem(view.$store.state.companyId + "_settings_sotecDashboard_pdfOptions", JSON.stringify(entity));
        exportObject.options = entity;
        if (!exportObject.exportJson) {
          view.$helpers.error(view.$t('global.messages.error'), "Export enthält keine Daten.");
        } else {
          view.$refs["modal-loading"].show();
          entity.exportJson = exportObject.exportJson;
          view.$helpers.getIndividualWageTypeExportPdfReport(exportObject)
          .then((response) => {
            view.$refs["modal-loading"].hide();
            console.log(response);

            view.modalPdfFilename = "IndividualWageTypeExport_" + exportObject.month + "_" + exportObject.year + ".pdf";
            view.modalPdfBase64 = response.data.data;

            view.showModal('modal-pdfpreview');

          })
          .catch((error) => {
            view.$refs["modal-loading"].hide();
            view.$helpers.error(view.$t('global.messages.error'), view.$t('export.builder.errorGeneratingPdfReport'));
            console.log(error);
          });
        }
      };

      view.$helpers.openCreateIndividualWageTypeExportPdfPopup(view.employmentModelArray, view.content, selectCallback);
    },
    generatePDF(entry, contracts) {
      let view = this;

      // console.log("json", entry.exportJson);

      let [doc, filename] = this.$helpers.generateIndividualWageTypeExportPDF(entry, view.employeeMap, contracts,
        view.employmentModelArray, null, view.userFullname);

      view.$refs["modal-loading"].hide();
      this.previewPdf(doc, filename);
    },
  },
};
</script>

<style scoped>

/* tr {
  display: inline-flex;
  flex-direction: column;
} */

.export-builder {
  background: var(--bg);
  padding: 24px 0px 32px 24px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: left;
}

.export-builder > .header {
  width: calc(100% + 24px);
  margin-left: -24px;
  padding-left: 28px;
  box-shadow: 0 2px 0px -1px var(--contrast-2);
  margin-bottom: 20px;
}

.panel {
  align-self: flex-start;
  width: calc(100vw - 48px);
  background: var(--bg);
  padding: 48px 0px 24px 0px;
  position: relative;
}

.panel.side {
  width: 200px;
  padding: 20px 10px;
  position: absolute;
  right: -1620px;
  left: 0;
  top: 100px;
  margin: auto;
  z-index: 10;
  display: flex;
  flex-wrap: wrap;
}

.panel.side .entry {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.panel > .header {
  position: absolute;
  top: 0px;
  left: 0px;
  padding: 5px;
  width: calc(100% - 24px);
  display: inline-block;
  text-align: left;
  /* box-shadow: 0 2px 0px -1px var(--contrast-2); */
  /* box-shadow: 0 6px 6px -6px rgba(0, 0, 0, 0.15); */
  font-size: 22px !important;
  color: var(--contrast-4) !important;
  margin-left: 0;
}

.panel > .header::after {
  content: "";
  position: absolute;
  left: -24px;
  bottom: -1px; /* Place just below header */
  width: calc(100% + 72px);
  height: 8px;
  pointer-events: none;
  box-shadow: 0 6px 6px -2px rgba(0, 0, 0, 0.15);

}

.panel.settings .panel-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
  column-gap: 24px;
  row-gap: 24px;
  padding-top: 8px;
  margin-right: 24px;
  margin-bottom: 24px;
}

.panel.settings .panel-container.compact-gap{
  column-gap: 0px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: left;
  column-gap: 0px;
  margin-right: 24px;
}

.data-table {
  padding-bottom: 0px !important;
}

.panel.settings .panel-container > .flex-item {
  flex: 0 1 calc(50%); /* don't shrink, can grow */
  max-width: 800px;
  min-width: 650px; /* damit nicht zu früh auf eine Spalte reduziert wird */
}

.panel.settings .panel-container > .flex-item-wide {
  flex: 0 1 calc(70%); /* don't shrink, can grow */
  max-width: 1228px;
  min-width: 650px; /* damit nicht zu früh auf eine Spalte reduziert wird */
}

.panel .close {
  position: absolute;
  right: 20px;
  top: 20px;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
}

.fa-stack.cancel {
  cursor: pointer;
  position: absolute;
  top: 6px;
  right: 5px;
  font-size: 10px;
  transform: scale(1);
}

.fa-stack.cancel .fa-circle {
  color: transparent;
  font-size: 22px;
  transform: translateY(2px);
}

.fa-stack.cancel .fa-times {
  font-size: 16px;
  transform: translateY(5px);
  color: var(--contrast-3);
}

.fa-stack.cancel:hover .fa-circle {
  color: var(--contrast-3);
}

.fa-stack.cancel:hover .fa-times {
  color: white;
}

.drag-marker {
  cursor: grab;
  user-select: none;
  position: absolute;
  left: 10px;
  top: 10px;
  color: var(--contrast-1);
}

.name-filter {
  position: absolute !important;
  width: 300px !important;
  box-shadow: inset 0 0 0 1px var(--contrast-3);
  top: 8px;
  right: 60px;
  z-index: 30;
}

.entryBox {
  width: 100%;
  font-size: 13px;
  text-align: left;
  padding: 2px 0px;
}

.entryBox .entryHeader {
  display: inline-block;
  width: 300px;
  color: #555;
  font-weight: 700;
}

.entryBox .entryHeaderLight {
  display: inline-block;
  color: var(--contrast-5);
  font-weight: 200;
}

.entryBox .entryData {
  display: inline-block;
  color: var(--contrast-5);
  font-weight: 200;
}
</style>
